var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIllustrationTransparentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "33.6 8.4 940 1489.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7A4",
    d: "M173.1 532.5c.5-.6 1-1.2 2-1.9 1.3-.5 2-.9 2.5-1.3l.5.1 14-1.1h1.2c.8 0 1 .3 1.2 1 1.2 1 2.3 1.6 3.3 2.3v.3l5.6 3.4c1.3.8 2.4 1.3 3.4 1.7v.3a7 7 0 0 0 2.6 1.3c.1.1.3.2.1.6 1 .8 2 1.3 3.2 1.8 0 0 .2 0 0 .5.7.6 1.4.8 2 1-.2 0 0 0 0 .4 2.2 1.8 4.6 3.2 7 4.7 0 0 .2.2 0 .6.8 1.4 1.8 2.5 3 3.8l9 5.7c2 1.9 3.6 3.6 5.5 5.1 12 10.1 24.6 19.6 36 30.5 10.3 10 19.1 21.5 28.7 32.2 1.8 2 3.6 5.7 6.9.9 2.8 0 5 0 7.5.4 1.9 7.5 3.5 14.7 5.5 21.8.4 1.6 1.8 3 3 4.5 0 0 .2 0 .2.6l7.9 45.5.9 3.7c1.6 9.8 3 19.2 5 28.5.7 3.4 2.7 6.6 4 9.9v.3a23 23 0 0 0 2.3 3v.4l2.2 3v.3l2.3 3s-.1 0 0 .2l1 1v.3l1.4 2.1c9.2 12.1 18 24 27.3 35.5a3526 3526 0 0 0 45 55.7c22.5 27.1 45.2 54 68 80.8 13.4 15.9 27 31.6 40.7 47 12.2 13.8 24.8 27 37.4 40.8.9.5 1.5.7 2.1.8l-.1.4c.3.9.8 1.4 1.2 1.9v.2l1.2.9v.3l1 .8v.3c.5.5.8.7 1.2.8v.4l4.3 5.2c4.7 5.4 9.6 10.3 13.7 15.8 10.8 14.4 21.2 29 31.8 43.5 1 1.4 3.1 2.2 4.7 3.2l1.3-1.6c-13-24.3-31-44.8-49.2-65.6l1.3-4.3s0 .1.2 0l.9-2.2.3-.2.8-3.1.3-.1c.5-.8.7-1.5.8-2.1l.4-.1c2.3-4.2 4.3-8.2 6.3-12.2l.4.1 3.8 2.6 2.5 2.2c.3.4.5.6 1 .9l1.1.9.2.3c1.5 1.2 3 2.1 4.3 3l.1.3c.8.5 1.5.7 2.1.8v.5c3.4 2.7 6.7 5 10 7.4l.2.3 2 .8.2.3a5 5 0 0 0 2.1.8v.3c.4.5.7.6 1.1.8v.3c.4.5.8.7 1.1.8l.2.3c.8.5 1.4.7 2 .8l.2.4c.8.5 1.4.6 2 .7v.4c1 1 2.1 1.6 3.4 2.5 3.1 1.9 6 3.4 9 5l.1.2c.8.5 1.5.7 2.1.8l.1.4 8.8 4.7c.9.3 1.6.5 2.3.5v.4c.8.5 1.5.6 2.2.7v.3c.4.5.7.7 1.1.9l.1.3 2.1.8.1.3 6.6 3.6a83 83 0 0 0 6.7 2.8v.3c.9.5 1.6.6 2.2.8l.1.3c.8.5 1.5.7 2.2.8v.4a6 6 0 0 0 2.2.7v.4c.9.5 1.5.6 2.2.7v.4c3.8 2 7.5 3.6 11.2 5.2v.4c.8.5 1.5.6 2.2.7v.4c2.9 1.8 5.7 3 8.9 4.7a91 91 0 0 0 6.7 2.7l.1.4c5.2 2.8 10.3 5.2 15.6 7.8 1.6.8 3 1.4 4.4 1.9l.2.3c1.2.5 2.1.6 3.1.8l.1.4c3 1.6 5.9 2.9 9 4.4 1 .6 2 .9 3.1 1.4 7.5 3.4 14.8 6.5 22.3 10l6.8 2.8.1.3c.3 2 .8 3.8.4 5.4-.6 2.2-1.8 4.3-2.8 6.4h-.4c-2 3-3.6 6-5.1 9h-.5a36.7 36.7 0 0 0-2.9 5.5h-.4a28 28 0 0 0-3 4.5l-.2.1c-.5.8-.7 1.5-.9 2.1l-.3.1-3 5.5h-.3l-2.2 3.5c-.5.3-.7.7-.8 1.3 0 .2-.1.7 0 .8 0 0 0-.1-.4 0a58 58 0 0 0-3 5.5l-.4.2a26 26 0 0 0-1.8 4.3h-.4c-1 1-1.6 2-2.4 3.2l-1 1.4c-1.2 1.9-2 3.6-3 5.4l-.3.1c-2.3 3.4-4.3 6.7-6.3 10h-.3a6 6 0 0 0-.8 2.2h-.4c-.9 1.1-1.4 2.2-1.8 3.3h-.5c-.8.7-1.3 1.4-2 2.3a2872.5 2872.5 0 0 0-22.1 28.8l-.4.2a44.2 44.2 0 0 0-3 4.3l-.3.1-.7 1-.4.1-.8 1.1-.4.1-7.7 7.8-1 1.8-.9 1.5h-.3l-.8 1.1h-.3l-.8 1.1h-.3l-1.4 1.3-4.1 4.2-.9 1.2h-.3l-1.3 1.2c-.4.2-.6.4-.9.9a5 5 0 0 0-.8 1.3h-.3a3 3 0 0 0-.9 1h-.2a3 3 0 0 0-.9 1.2h-.3l-1.7 1.1-15 13.2-2 1.3h-.3l-5.2 4.4h-.4a11 11 0 0 0-1.8 2.3l-.4-.1c-1.6.7-2.9 1.5-4 2.3h-.4c-1.3.8-2.2 1.5-3 2.2h-.4a24 24 0 0 0-3 2.3s0-.1-.4 0a63 63 0 0 0-5.2 3.3h-.3c-.8.3-1.4.7-1.9 1.1h-.4c-8.4 2.1-16.3 5.4-24.4 6.1-19 1.8-38 1.7-55.5-8-3.2-1.9-6.6-3.3-10-4.8v-.3c-.3-.5-.7-.6-1-.8l-.1-.3c-1.2-.9-2.2-1.5-3.3-2l-.1-.3-5.4-3v-.4c-1.5-1.3-3-2.1-4.5-3v-.3c-.4-.4-.7-.6-1.1-.7v-.5a21.2 21.2 0 0 0-3.4-2.9v-.3a6 6 0 0 0-2.2-.8v-.4c-1.4-1.6-3-2.9-4.5-4v-.3l-1.1-1.4a3 3 0 0 0-1-.9c-1-.5-1.6-.6-2.3-.8v-.4c-1.8-2-3.7-3.7-5.7-5.6-.3-.5-.5-.6-1-1s-.8-.6-1.3-1.2c-3.3-3.4-6.6-6.3-9.5-9.6-7-8.1-13.6-16.4-20.7-24.7l-.8.1v-.3c-.3-.9-.7-1.4-1.1-2v-.3a12 12 0 0 0-2.3-1.8v-.3c-.4-.5-.7-.7-1.1-.8l.1-.4c-.3-.9-.8-1.4-1.2-1.9v-.3a11 11 0 0 0-2.2-2v-.2c-.3-1-.7-1.4-1.1-2v-.3a24 24 0 0 0-2.3-3v-.2l-1.1-.9v-.3c-.4-.5-.8-.6-1.1-.8v-.3c-.3-1-.7-1.4-1.1-2v-.3a21 21 0 0 0-2.3-3v-.3c-.7-1.3-1.4-2.2-2.2-3v-.4a102 102 0 0 0-4.5-6.3v-.3c-.4-.5-.7-.7-1-.8v-.4a15 15 0 0 0-2.3-3l.1-.4c-.7-1.2-1.5-2-2.5-3.3l-25.5-43.5-5.5-8.5v-.4l-3.4-5.2v-.3c-.4-.5-.8-.6-1.1-.8v-.4c-.6-1.6-1.4-2.9-2.2-4v-.5l-7.8-13v-.3a429 429 0 0 0-7.8-13v-.4l-4.5-7.4v-.4c-1.1-2-2.2-3.6-3.3-5.2v-.3c-.5-.5-.8-.7-1.2-.8l.1-.4c-3.3-6.9-6.7-13.3-10-19.7v-.3a126 126 0 0 0-4.5-7.5v-.4c-1.2-2-2.3-3.6-3.4-5.1v-.4c-.3-.8-.7-1.4-1.1-1.9v-.3a3 3 0 0 0-1.1-.8v-.4c-1-2-2.2-3.6-3.4-5.2l.1-.4c-3.3-6.1-6.7-11.8-10.1-17.4v-.4a117 117 0 0 0-4.5-8.5v-.3c-.4-.5-.7-.7-1-.8-.1 0 0 0 0-.4a67 67 0 0 0-3.4-6.3v-.4a209 209 0 0 0-5.6-9.7v-.3a8 8 0 0 0-1.1-1.9v-.4a147 147 0 0 0-4.5-7.4v-.3c-.3-.9-.7-1.4-1-2l-.1-.2c-.5-.6-.8-.8-1-1.3l-.2-1a3 3 0 0 0-1-.8v-.3a39 39 0 0 0-2.2-4.1v-.4l-1.1-1.9v-.4l-4.5-6.3.1-.3c-.4-.9-.8-1.4-1.2-1.9v-.3a6 6 0 0 0-1.1-1.9v-.4a67.3 67.3 0 0 0-3.4-6.3v-.3c-.4-.5-.8-.7-1.1-.8v-.4a62.4 62.4 0 0 0-3.4-6.3v-.3c-.4-.5-.7-.7-1-.8v-.4c-1.4-3.2-3-5.9-4.5-8.5v-.5a900 900 0 0 0-11.2-19.6v-.4c-1.8-3.5-3.7-6.6-5.6-9.7 0 0 .1 0 0-.2-.4-.5-.7-.7-1-.9v-.3a9.4 9.4 0 0 0-1.2-3v-.4c-1.1-2-2.2-3.6-3.3-5.2v-.4a133 133 0 0 0-4.5-7.4v-.3l-1.1-2v-.3l-2.2-3v-.3a8 8 0 0 0-1.1-1.9v-.2l-.2-1c-.2-.6-.5-.9-1-1.4-.7-1.2-1.4-2-2.2-3v-.3c-1.1-2-2.2-3.7-3.3-5.2v-.4l-2.3-3v-.4l-4.4-6.3v-.4c-.9-2-1.9-3.8-3-5.8-.9-1.6-1.7-2.7-2.5-4.3-1-1.7-2-3-3.1-4.6l-2.3-3.5-2.5-4.1-2-2.6-3.6-5c-.3-.7-.6-.9-1-1.2-.4-.6-.7-.8-1.2-1.2l-3.3-2.7c-9.2-7.1-18.8-13.8-27.7-21.3a1088.5 1088.5 0 0 1-40-35.6c-.8-1.5-1.8-2.5-2.7-3.5v-.2l-1.1-1v-.3a37.8 37.8 0 0 0-3.4-4l.1-.4c-.8-1.3-1.5-2.1-2.3-3v-.4c-.7-1.2-1.5-2-2.2-3v-.3l-1.1-1.9v-.2l-1.2-.9.1-.3c-.4-.9-.8-1.4-1.2-2l.1-.3c-1.9-3.9-3.7-7.3-5.6-10.8v-.3c-.4-.9-.8-1.4-1.1-1.9v-.4c-.4-1.8-.8-3.3-1.3-4.6a78.4 78.4 0 0 1-6.5-45.3h.3l.8-1h.3c2-.5 3.7-.9 5.7-1 7 10.9 13.6 21.6 20.6 32.2.8 1.3 3 1.6 4.7 2.4-.4-1.6-.3-3.5-1.2-4.8-6.6-10.8-13.4-21.4-20.1-32.5l-3.4-5.2.1-.5-3.4-23h.4a39 39 0 0 0 3-4.5l.3-.1.8-2.1h.3l.8-1.1h.3l.9-1.1h.4c3.1-1.1 5.9-2.3 8.6-3.4.4 0 .9 0 1.7.4 10.3 12.8 20.1 25.4 30.2 37.7 1 1.3 3.2 1.5 5 2.2-.7-1.8-1-3.9-2-5.3-9.8-12.4-19.8-24.6-29.7-37.2-1.8-2.1-3.6-3.8-5.4-5.5v-.3c-.3-.9-.7-1.4-1-1.9v-.4l-2.3-1.8v-.4a38 38 0 0 0-2.3-4l.1-.6c-2.6-7.2-.5-13.5 2.2-19.7 0 0 0 .1.4 0 .8-.7 1.3-1.5 1.8-2.2h.3l.4-.5-.7-.6c4.7-5.7 10.8-7.5 18.4-6.4 1.6 1.8 2.7 3.4 4 4.6 9.8 8.3 19.7 16.4 29.4 24.7 6.1 5.3 12 11 18.2 16.3 1 .7 2.5.8 3.7 1.1-.2-1.4 0-3-.6-4.3-.7-1.2-2-2.2-3.1-3.1l-49.6-42.7-.2-1.3-1.2-2.2v-.3l-1.1-.8v-.4a18.6 18.6 0 0 1-4.4-15.5l2.1-7.8m8.6 9.2c-.8 1.6-1.8 3.2-2.3 5-.3 1 0 2.3 0 3.5 1.3-.4 3.1-.5 3.7-1.4 1.4-2.2 2.6-4.6 3-7.1.2-1.6-1-3.4-1.6-5.1a50 50 0 0 0-2.8 5Z",
    "data-index": 1,
    style: {
      opacity: 1,
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M335.7 702.4c-.3-1-.5-1.9-.5-3.5.5-2.5 1-4.4.6-6.2-2.4-13.2-5-26.3-7.3-39.8.4-1.2.6-2.2.7-3.2h.3l.9-1 .2-.1c.5-.4.7-.8.9-1h.3c3.1-3 5.8-6 8.6-9l.3-.1.8-1.4c0-.3.2-.5 1-.7 1.1-.4 1.7-.8 2.3-1.1h.4c1.6-1.5 2.9-3 4-4.5h.4c.4-.4.5-.8.7-1.2 5.4-4 10.8-7.9 16.7-11.7 1.9-.8 3.2-1.8 4.6-2.8l.4.1a118.5 118.5 0 0 0 7.8-4.4c.8-.4 1.3-.8 1.8-1.2h.5c2.6-.8 4.8-1.6 7-2.5 29-11.7 58.1-23.5 87.3-34.8l-2.2 14-.3.1c-1 1-1.8 1.9-2.2 2.9-7.5 16.7-10 34.3-8.5 52.4.4 3.6 2.9 6.9 4.4 10.3v.3c.3.9.7 1.4 1 2v.3l2.3 4.1v.4a23 23 0 0 0 2.8 1.9c.4.2.5.4.6 1l1 1.2.2.2c.4.5.7.7 1 .9v.3c.8.9 1.5 1.4 2.2 2l.2.2 2 .8.1.2 1 1 .3.2c9 5.6 19 7 28.9 7.5 21.2 1 41.8-2.7 62-8.7a366 366 0 0 0 69.3-28.1c1.8-1 3-3 4.5-4.4h.3c2.4-1.1 4.4-2.3 6.4-3.4h.3l8.6-5.5h.3c.8-.8 1.3-1.6 2-2.6 11.4-9.7 22.9-18.8 33.6-28.7 6.1-5.7 11-12.9 16.6-19.4.5 0 .5-.2.5-.7.1-.2.4-.5.8-.6 3-.2 5.8-.2 8.7 0 1.9 1 3.7 1.4 5.7 2.2 7.8 4 15.4 7.6 23 11 1.4.7 3.2.6 4.9 1.2.5 1 .7 1.8 1.3 2.1 9.3 4.5 18.5 9 27.8 13.2.9.4 2.1 0 3.1.2 5.5 3.2 11.1 6 16.8 9 1.6.9 3 1.3 4.4 2.2 3.3 2 6.6 3.6 10.1 5.6.8.5 1.5.6 2.2 1 3.3 2.5 6.6 4.5 10.1 7l11 6.2.1.3a126 126 0 0 0 10 6.3s-.1.1 0 .4c3.1 2 6 3.6 8.9 5.2v.4c3.7 3.1 7.4 5.8 11.1 8.6v.3c1.9 2 3.7 3.6 5.6 5.2v.3l1.1.9v.2l1.1.9.2.3 1.5.8c.4 0 1 .2 1.6.9.5.8.9 1 1.2 1.3v.3l1.1.9v.2c.6.5 1 .7 1.4.8 1.3 1.3 2.6 2.5 3.9 4.2l-.4.8.7.6v.4c1.9 2 3.7 3.6 5.6 5.2l-.1.4c1.1 1.6 2.3 2.8 3.4 4v.5c.7 2 1.2 3.8 2.2 5.2a101.4 101.4 0 0 1 15.7 36.5c.8 3.1 2.2 6.1 3.2 9.2v1.2c0 2.5 0 4.4.2 6.2 1 11.4 2.8 22.8 3 34.1 0 12.5-1.2 25-2.2 37.6-.7 7.5-2.1 14.9-3.6 22.4-2 2.9-3.8 5.6-5.1 8.6-1 2.3-1 5-2 7.3-1.8 4.2-.5 7.3 3 10 0 1.3 0 2.2-.5 3l-8.8-3-.9 1.3 7.8 5c-5.9 2.9-6.2 6-4.6 9.6.2.3.4.9.2 1l-5.4 8.3-2.6-7-9-3 10.3-5.7-7.2-7.8 7.2-2.3c0-3 1-6.8-3.7-7.3-4-.5-10.8 9.1-9 12.7 1.5 2.7 2 4.6-.7 6.6-2 1.5-3.8 3.8-6.1 4.7-3.2 1.2-6.8 1.3-11 2 2 5 3.7 9.4 5.2 13.8.4 1 0 2.3 0 3.5-1-.1-2.2 0-3.2-.4-1.3-.5-2.4-1.3-3.9-2.2-2.7 7.4 3.8 7 7 9.4l-2 6.2-9.6-4.7 1.8-21.2c-.6 0-1.1-.2-1.7-.3l-6 5c-1.8-7.5 5.5-6.4 8.4-10l-4-5.6-7.3 6c-.7-3-.4-6-1.8-7.3-1.4-1.4-4.4-1.2-6.7-1.7l-.5-2.2c2.6-1.6 5.5-2.8 7.8-4.7 1.9-1.7 3-4.2 4.6-6.4l-6-1.4c-.4 0-.7-.3-1.1-.4l-3.4-6.2-3.6 4.5-2-.5c.6-4.5.3-9.5 2.2-13.5a19 19 0 0 0-5.4-20.8l2.1 8.5-7.5 3.8 4.4 10c.6 1.2-1.4 3.5-1.8 3.3-3.3-1.9-6.2-4.2-10.6-7.4.7 2.5.7 4.8 1.8 5.9 3.4 3.1 7.3 5.7 11 8.5l-.6 1.4-4-.6c-4.7 4.4-2 8.8-.2 13.7-4.2-1.8-7.2-7.2-12.3-1.5l-3.4-10-22.7 1.4 6.3 8.2c-3.3.5-5.8 1.7-7.5 1-3-1.1-5.5-3.4-8.7-5.4 2.1-3 5.5-6.4 7-10.4 4.5-11.7-9-31.7-17.2-25.8l3.2 3c-4.6 2.8-6.2.4-6.7-3.1-.5-3.2-1.3-5.7-6.5-6.1l3.2 8c1.7 3.7 4.9 7.3 5 11 .1 3.6-.4 6.1 3.7 7.8 1.4.6 3 3.3 3 5-.1 4.7-1 9.5-1.4 14.2l-9.2.6c-1.5-1-2.9-2.5-4.4-2.7-1 0-2.8 2-3 3.2-.8 4.5-4.3 7.5-9.8 7.6 1-1.5 3.3-4 3-4.5a20.2 20.2 0 0 0-6-5.2c-1-.7-3-.2-4.2-.8-2.9-1.4-5.6-3.2-9-5 4-3.7 6.4-3 9.2-1 .8.7 3-.7 4.6-1.1-2.6-7.1 5.1-7.5 7-11.7 2.8 2.2 5.3 4 7.7 6l4.4-9.6-5.6-1.7-4.1-8-9.6 7.1c-2.8-2-6-7.3-10.7 0l-2.8-7c-3.2-.4-6-1-7.3 3.6-.5 2-3.3 3.4-5.4 5.3-.5-1.3-1-2-.8-2.2 2.8-5.7.5-9.5-4.3-12.7-.6-.4-.1-4 .5-4.2 3-.8 6.3-1.1 9.6-1.6.5-1.6 1.5-4 1.7-6.3.3-3.7-2.9-4.4-5.9-2.6-2.6-2.8-5-5.3-7.2-8-.7-.9-1-2.6-.6-3.5 1.1-3 2.7-5.7 4.2-8.8 7.8-.4 8.9-1.5 9.2-9.8 0-.8 3.6-2.4 3.7-2.2 2 2.6 3.7 5.4 6 8.9 2.4-.6 6.7-4.3 10 1.4 3-5.2 2.3-6.4-4.5-8.8 1.6-3.8 6-6.7 3-12-2.1-3.4-2.9-7.7-4.2-11.6l-2 .5c.2 1.6.7 3.3.5 4.9 0 .8-1 2.1-1.6 2.3-.7 0-2.4-1-2.4-1.5.4-6.9-4.1-5.6-8-5.5 7-10.3 14-20.3 21.3-30 2.5-3.4 1.7-4.7-1.6-6-.5.4-1.1.6-1.4 1-17 24.3-35.6 47.6-50.5 73-25.1 43-48 87.3-71.5 131.2a1150 1150 0 0 0-24.8 49.7c-3.3 6.9-5.7 14.3-8.5 21.4h-.5c-2.3 4.1-4.3 8.2-6.3 12.3l-.3.1-.8 2.1-.3.2c-.5 1.2-.7 2.2-.8 3.2h-.3a6 6 0 0 0-.8 2.2h-.4c-2.6 1.5-3.7 5.5-7.6 3.3v-.3l-1-.8-.1-.3-1.1-.8v-.3l-1.1-.9v-.3l-1.1-1.9v-.3a9 9 0 0 0-2.2-.7c-12.5-13.5-25-26.8-37.3-40.5a2564.7 2564.7 0 0 1-40.7-47c-22.8-26.9-45.5-53.8-68-80.9a3526 3526 0 0 1-45-55.7 1016.6 1016.6 0 0 1-28.7-38v-.2l-1.1-1v-.3c-.7-1.2-1.5-2-2.3-3l.1-.3c-.7-1.3-1.5-2.1-2.3-3v-.4c-.7-1.2-1.4-2-2.2-3v-.4c-1.9-9.4-3.7-18.4-5.7-27.4-.9-3.7-2.2-7.3-3.4-11m393.1 95 1.1 1.2 2-5.1-1.6-.5-1.5 4.3Z",
    "data-index": 2,
    style: {
      opacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC5A2",
    d: "M474.3 661.7c0-.3-.2-.5-.8-1a13 13 0 0 0-2.6-2v-.4c-.6-1.6-1.4-2.9-2.2-4.1v-.3l-1.1-2v-.3a64.6 64.6 0 0 1-1.5-37.9c2.6-9.2 5.4-18.3 8.2-27.4l.2-.3c1.3-4.9 2.2-9.5 3.3-14.4.3-1 .4-1.8.5-2.6-.2-6.2-.5-12.5-.4-19.6.6-4.8.7-8.8 1-12.8 15-3 28.7-7.7 41.1-16h.4l7.4-4.5h.2l.9-1.1h.3a8 8 0 0 0 1.9-1.1h.4l5.2-3.4h.3c.9-.8 1.4-1.5 2-2.2h.3c1.6-.7 2.9-1.5 4-2.3h.4c.9-.8 1.4-1.5 2-2.2h.2c.9-.3 1.4-.7 2-1.1h.3l1.9-2.2h.3c.9-.3 1.4-.7 1.9-1.2h.3l.8-1h.2l1.1-.4c17.2-13.3 29.7-30.4 43.6-46.3l-1.7-1.7c-7.3 6-14.7 12.2-22.3 18.3-.5.4-.8.6-1 1h-.2l-.8 1.1h-.3c-.5.4-.7.8-.8 1.1h-.4c-1 .3-1.5.7-2.2 1.2-.5.2-.7.4-1.1.8-.9.5-1.4 1-2 1.4h-.2l-.8 1h-.4l-1.9 1.2h-.2l-.9 1.1h-.3a3 3 0 0 0-.8 1.1h-.4c-1.6.7-2.8 1.5-4 2.2h-.4c-.9.8-1.4 1.5-1.9 2.3l-.4-.1c-9.8 4.8-19.2 9.7-28.6 14.6l-.4-.1c-5 1.5-9.4 3.1-14.4 4.7l-15.7 4.5-6.8 1.7-14.1 3.8s-.5-.1-.8-.6c-2.9-.5-5.4-.6-8-.6-17.8 0-34.7-3.3-50.5-11.8-1.8-1-4.2-1.1-6.3-1.6-8-6.8-16.2-13.7-24.2-21-.1-.7-.3-1-.4-1.3v-.4a17 17 0 0 0-2.5-1.8c-.3 0-.5-.2-.7-1a8.8 8.8 0 0 0-1.3-2.3v-.3c-.4-.5-.8-.7-1-.9v-.3a20 20 0 0 0-2.3-3v-.4a20 20 0 0 0-2.3-3l.1-.3c-.7-1.3-1.5-2.1-2.3-3v-.3c-.3-.9-.7-1.4-1-2v-.3c-.3-1.5-.4-2.6-.9-3.6a256.3 256.3 0 0 1-23.4-109.7c-.5-31 .5-62.2 1-93.4 0-2 0-4 .4-6.3.4-3.4.3-6.8.8-10 2-13.6 3.6-27.4 6.7-40.8 4.4-19 9.5-38 20-55 1.4-2.3 2.2-5 3.6-7.5 3.9-4.5 7.4-9 11.1-13.5.9-.7 1.4-1.4 2.3-2.2l7.7-7.8c.6-.3.8-.6 1.1-1l2.4-1.1 2.1-2.3c1.3-.7 2.2-1.4 3.4-2.2 1.3-.7 2.1-1.5 3.3-2.2 2 0 3.6 0 5.2.3.4.9.8 1.4 1.1 2.3l3.3 6.7 5.7 10c.3.8.7 1.3 1 2.3l10.1 15.6 3.3 5.6c2 2.3 3.8 4.3 5.6 6.6l1.2 2.2c1.2 1.2 2.3 2.1 3.3 3.3.3 1 .7 1.4 1.2 2.3l4.7 3.8v.2c.4.6.8.8 1 1v.2l1.1 1v.1c.4.6.8.8 1 1l.1.2c.5.6.9.8 1.5 1 .5.3.6.6.6 1.3 2.3 3.4 4.4 6.7 7.1 9.3 2.6 2.5 5.8 4.1 9 6.2a5 5 0 0 1 1.8 2c.6.6 1 .8 1.4 1v.4c2 2.5 4 4.6 6.4 7 .8.4 1.5.6 2.1 1.1 2.3 2 4.5 3.6 6.7 5.6 1.9 1.6 3.7 2.8 5.7 4.3.3.6.6.8 1 1.3l5.6 4.4c1.5 1.3 3 2.1 4.4 3.4 1.5 1.2 3 2 4.5 3.3 1 .6 1.8.9 2.7 1.1v.6l1.8 1.7c2.6 2 5.2 3.5 7.9 5.5 1.1.8 2.2 1.3 3.2 2.2 1.1 1 2.2 1.4 3.4 2.3l29 16.7c8.5 4.6 17 8.8 25.7 13.4 9.4 4.2 18.7 8 27.7 12.1 2.1 1 4.9 2.7 5.4 4.6 1 4.4 1.2 9.1 1.2 13.7 0 5.5-.6 11-1 16.6-.1 2.8-.3 5.7 4.3 5.6.8-2 1.6-4.1 2.8-6.3 2-3.1 3.5-6 5-9l.4.1c.9-.8 1.3-1.6 1.8-2.4h.2l.9-1.2c0 .1-.2 0 .2 0 .5-.4.7-.8.9-1.1h.2c.5-.4.6-.8.8-1.1h.3c.5-.4.7-.8 1-1.1h.2c.6-.5.8-1 1-1.6v-.3l.2-.2h1c2.1-1.3 3.9-2.8 6-4.3 1.2-.7 2-1.5 3.3-2.2 1.5-.3 2.6-.5 3.6-1a39.3 39.3 0 0 1 29.4-3.3c5.8 1.7 11.2 5 16.9 8 .3.5.6.7 1 1 .5.5.8.7 1.1 1.2.6.7 1.1 1 1.7 1.3 0 0 .2.1 0 .5.5 2 1 3.9 1.9 5.3 5.4 8 6.3 17.1 6 26a82.8 82.8 0 0 1-9 33.4c-2.2 4.7-4 9.7-6.5 14.7-2 3-3.6 5.9-5.6 8.8-1 1.1-1.4 2.2-2.3 3.3-1.6 1.9-2.8 3.7-4.3 5.7-.6.3-.8.6-1.2 1.1l-4.4 4.4c-.6.3-.8.6-1.2 1l-2.3 1.2c-7 2.3-13.8 4.4-20.4 6.7-1.7.6-3.2 1.5-5.3 2.2l-19-2.2-.8 2.5a80 80 0 0 1 8.2 3.7c2.4.8 4.8.9 6.8 1.7 1.6.6 3.7 2 4 3.4 1.1 6.5 1.4 13.1 2.5 19.6 1 5.4 2.8 10.6 4.3 16.2.2.5.3.7.3 1.4 1 6.7 2.2 13 3.3 19.8-.1 1.8-.4 3.2 0 4.4 4.7 16.3 9.5 32.7 14.5 49 .8 2.4 2.9 4.3 4.3 6.9 1 2.8 2.2 5.1 3.4 7.7.3.6.6.7 1 1.2 1.9 3.1 3.8 5.8 5.6 9 1.5 2.3 3 4.3 4.4 6.6l1.3 2.2c1 1.2 2 2 3.2 3.2l14.8 12.9a26 26 0 0 1-.4 4.1l-.5.5-.5.7c-5.5 6.5-10.4 13.7-16.5 19.4-10.7 10-22.2 19-33.9 28.8-1 1-1.5 1.7-2 2.4 0 0 0 .1-.4 0a117 117 0 0 0-8.6 5.6h-.3c-2.4 1-4.4 2.2-6.4 3.4h-.3a319.4 319.4 0 0 1-109.7 38.4c-9.9 1.4-20.2 1.3-30.1.4-8.4-.7-16.5-3.5-24.8-5.4v-.3c-.3-.5-.7-.6-1-.8l-.2-.3a6 6 0 0 0-2.1-.8v-.3a9.6 9.6 0 0 0-2.2-2l-.1-.2c-.4-.5-.7-.7-1-.9l-.1-.2c-.4-.6-.7-1-1-1.2m56.6-414.9-1.3-1.2c-.6-.1-1.2-.3-2.2-1.2a46.8 46.8 0 0 0-33.8-8.7c-4 .3-7.8 2.5-12.3 3.8l-2 1.4-1.3.9a6 6 0 0 1-2.4 1.1c-2.9 2.2-5.7 4.3-1.2 8.3l1.5 1.3c2.2.1 4.4.5 6.6.4 11.5-.4 22.8 0 33.9 3.5 4.9 1.5 9.8 2.9 14.9 4.8.2.4.5.6 1.3 1.3 2.6 1.3 5.3 3.5 8-1 2.4-4.7-.6-7.3-4.2-10.2l-1.2-1.3c-1-.5-2-1-3.2-2-.2-.4-.5-.6-1.1-1.2m-173.3-8a3 3 0 0 1-1.2 2c-.5.6-1 1.4-2.1 2.6-.3 5.8 1.3 7.4 7.7 6a92.4 92.4 0 0 1 37.2-.2c1 .2 2.4-1.2 4.2-2l1.1-1.4-1.8-5.7c-.3-.3-.6-.5-1-1.3-.7-.5-1.5-1-2.3-2.3-1-.5-2.1-1-3.6-2.2-2.7-1-5.3-3-8-3.2-7.4-.4-15.1-2.6-22.4 2.9a6 6 0 0 1-2.4 1c-.8.8-1.7 1.5-3.2 2.3l-2.2 1.5m127.2 54.6c-.2.6-.4 1.2-1.3 2.2-7.1 8.2-4.1 23.4 5.6 27.2 3 2.1 6 2.8 9.3-.7 1.6-2 3.2-3.8 5.4-6 .1-.6.3-1.2 1.3-2.3a18 18 0 0 0-.8-17c-.4-.5-.7-1-1.2-2.4a53.4 53.4 0 0 1-5.8-4.3c-4-2.9-7-1.5-10.4 1.9l-2.1 1.4m-78 41.4-.5 2.9-.7.3-8.3 17.5-.7.4c-4.3 6.5-3.1 13.3-1.2 20.1.1.3 1.3.3 2.5 1 1.7 2 3.4 4 5.1 6.4.3 0 .6 0 1.7.3 5.5 1.3 11 2.8 16.5 3.8 1 .2 2.5-1.5 3.7-2.4-1.1-.8-2.2-1.9-3.5-2.6-.6-.3-1.5 0-2.2 0-16.7-.3-23.2-10.6-16.5-25.9 6.8-15.2 13.2-30.5 20.5-46l.8-3 .6-.5c1.3-8.9 2.6-17.7 3.7-26.5 0-.6-1.4-1.3-2-2l-.4-.5-2.4.8-2.2 1.3c-1.7 9.6-3.1 19.3-5 28.8-1.1 5.2-3 10.2-4.5 15.3l-.7.4-1.5 5.2-.7.3-1.5 4.1-.6.5m-21.1-17.4c.5-.7 1-1.3 2.3-2.4 1.2-4 3.6-8 3.3-11.8-.3-4.9-.5-10.7-6.4-14.3-2.4-.7-5.1-2.5-7.2-2-9.2 2.4-13.3 20.6-7.2 27 2.5 2.4 4.6 5.5 7.6 6.7 1.6.6 4.6-1.9 7.6-3.2m283.5-2.7c6-6.9 13.9-10.9 22.6-13.5 1.6-.5 3-1.8 4.6-2.7l-.9-2c-2 .2-4.3 0-6.3.7-20.5 6-31.5 21-37.4 40.5-.4 1.1.8 2.8 1.2 4.2 1-1.1 2.3-2 3-3.3 4.3-7.7 8.4-15.5 13.2-23.9m-207 113c3.8-2.5 7.7-5 11.5-7.8.6-.4.6-1.8.8-2.8-1 0-2.3-.4-3.2 0-1.2.4-2.2 1.4-3.3 2-14.3 9.2-29.2 14.6-46.3 8.4-1.2-.4-2.6-.3-4.2-.4 3.5 9.6 25.8 9.8 44.7.6Z",
    "data-index": 3
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36384D",
    d: "M712 91.2a83 83 0 0 0 9 10.3c.1 0 .2.4 0 .9.3.6.7.7 1 .9 0 0 .2-.3.1.1 1 1.4 2 2.4 3.2 3.3l-.2.4c2.7 4 5.5 7.6 8.3 11.2 0 0 .2.2 0 .7 1.6 3 3.4 5.4 5.3 7.8l-.2.4c1.4 3.1 2.9 5.8 4.4 9a1001 1001 0 0 0 10 25A177.5 177.5 0 0 1 765 221a168 168 0 0 1-3.7 50c-2.8 10.8-4.8 21.8-7.6 32.6-2 7-4.8 13.8-7.2 20.8 0 0 .5.3 0 .2-1 1.4-1.5 2.9-2 4.3 0 0 .2.2-.2.2-4.3 6.2-8.2 12.4-12 18.7-.3.5.1 1.6.2 2.4 0 0 0 .2-.5 0-5.4 4.7-10 9.5-11.3 16.5l-.4-.1C716 371 712 375.4 708 380c-.7.8-.5 2.4-.7 3.7 0 .3 0 .6-1 .8a120 120 0 0 0-6.9 14.2 5 5 0 0 1-1.2 1.4c-.5 1.3-.7 2.4-1.3 3.5l-1 2.3c-1 1.1-1.4 2.2-2.3 3.3l-3.4 4.3c-.5.7-.6 1.5-.8 2.6v1.8h-.4c-.5.3-.7.7-.8 1.1l-.3-.2c-.7 0-1 .2-1.8.4l-1.2 1-.2.1c-.5.6-.7 1-1 1.8v1.4l-.2-.2c-.8 0-1.2.2-2 .3-1.8 1.3-3 2.6-4.4 4-.2.4-.4.5-1.1.4l-8.2 4.5c-2.4.4-4.4.8-6.6.8l-4.7-27.3c9.9-4.4 18.1-7.8 26.2-11.7 1.4-.7 2-3 3.2-4.5 0 0-.1.1.2 0l1-1h.1l1-1.2c-.1.1-.2 0 .2.1 2-2.2 3.6-4.5 5.2-6.8h.3c3.7-4.2 7.4-8.2 10-13 10.2-17.5 18.2-36 16.5-57-.4-4.5-3-8.8-4.5-13.3l.1-.3c-1-2.4-2.3-4.3-3.5-6.3l.2-.4a12 12 0 0 0-2.8-3l-.8-.6-.3-.4c-.4-.6-.5-.9-.3-1.4-.2-.9-.7-1.5-1.3-2.6-1-2.5-1.7-5.1-5-3.3v-.6c0-.9-.3-1.5-.7-1.8-11.1-9.7-39.2-8.7-49.3 1.8-.3.3 0 1-.1 1.6-.1 0-.2.1-.7-.1-1 .5-1.6 1.2-2.4 1.8-.4-.2-.6-.4-1-.4l-1 2.6h-.3c-.9.7-1.4 1.4-2 2 0 0 0 .2-.4.2a82 82 0 0 0-9.8 8.5c-1.2 1.3-1.5 3.6-2.3 5.4-.1 0-.3-.2-.7-.2l-2.2-.5c.1-6.6.8-13.2.5-19.7-.2-3-2.1-6-3.1-9 .1 0 0 .2 0-.2-1.2-1.5-2.4-3-3.9-3.6a134.8 134.8 0 0 0-27.3-9.4v-.3c-5.1-2.8-10.4-5.1-15.7-7.4 0 .1-.2.1-.1-.3-5.9-3.2-11.8-6-17.6-8.8v-.3a102 102 0 0 0-10-5.2s-.1 0 0-.4c-2.6-1.7-5.2-3-7.8-4.2v-.3c-1.1-1-2.3-1.4-3.4-1.8v-.3c-3-2-6-3.7-8.9-5.4v-.3c-1-1-2.2-1.5-3.3-2v-.2a3 3 0 0 0-1.2-.8v-.3c-1-.9-2.2-1.4-3.3-2v-.2c-.6-.6-1.4-.8-2.4-1l-1.3-.6-.2-.3c-.3-.3-.5-.5-.4-1.2-1.6-1.4-3.2-2.3-4.7-3.2.1 0 0 0 0-.4-1.4-1.3-3-2.2-4.4-3v-.4c-1.4-1.3-3-2.2-4.4-3.1v-.2c-.5-.6-.9-.7-1.2-.9v-.3c-1.8-1.6-3.7-2.8-5.6-4.1v-.3c-.4-.5-.8-.6-1.1-.8 0 .1-.1.2 0-.2-1-1-2.2-1.6-3.6-2.2-.6-.2-.7-.4-.8-1.1a3 3 0 0 0-1-1l-.1-.3a3 3 0 0 0-1.2-.8v-.3c-1.4-1.3-3-2.3-4.7-3.3a8 8 0 0 1-2-2c-.3-.6-.7-1-1-1.2.1 0 0 .2 0-.1l-1.2-.9s-.1.2 0-.2c-1.8-1.8-3.7-3-5.8-4.5-.5-.2-.7-.5-.8-1.2-.5-.5-.9-.7-1.6-1-1.1-1-2-2-2.9-3.3-.5-.6-1-.8-1.6-1.2-1.1-1-2-2-2.9-3.3-.4-.6-.8-.8-1.4-1-.5-.3-.7-.6-.8-1.3l-1-1v-.2l-1.2-.9.1-.3c-2.3-2.6-4.6-4.9-6.9-7.2 0 0 .1 0 0-.4l-1-1v-.3c-1.5-2-3-3.4-4.7-5 0-.1.2 0 .2-.4-.4-.5-.8-.7-1.1-1v-.2c-1-1.7-2.3-2.9-3.4-4.2 0 0 .1.1 0-.2l-1-1v-.3c-.7-1.2-1.6-2-2.3-2.9v-.3c.5-4.7-2.4-6.3-5.6-7.5l.1-.4c-.7-1.3-1.5-2.1-2.3-3l.1-.3c-.7-1.3-1.6-2.2-2.3-3v-.3c-.4-1-.8-1.4-1.2-2l.1-.3a352 352 0 0 0-10-20.5c-1.6-3-3.8-5.5-5.7-8.2.1 0 0 .2 0-.2-3.3-1.8-9.1 1.6-10.8 6 0-.1.1-.1-.3-.2-1.3.8-2 1.6-3 2.4h-.2c-2 1.4-3.6 3-5.3 4.5 0 0 0-.2-.3-.1l-1 1h-.2c-.5.6-.7 1-1 1.6-.2.5-.4.6-1 .7-.7.4-1 .8-1.2 1h-.1l-1 1.2-.3-.1c-1.6 1.5-2.8 3-4 4.6h-.3c-.5.4-.7.8-.9 1.1h-.2c-1.7 1.8-3 3.7-4.2 5.6h-.3c-5.9 5.2-10.8 11-11.9 19 0-.1.2 0-.2 0-1.7 2.9-3.1 5.8-4.9 8.8-3 7.2-6.6 14-8.3 21.3-4.3 18.1-7.6 36.4-11.4 54.6-.2 1.1-1.4 2-2.2 2.7-2-10.6-5-20.6-6-30.9-1-10-1-20.2.1-30.2 2-16.3 8-31.3 16.8-45.2.7-1 .4-2.7.6-4 0 0 .1-.2.6-.1 2.3-3 4.1-6 6-9h.6c2.7-2.9 5-5.9 7.2-8.9h.7c.8-.6 1.2-1.4 1.5-2.2 0 0 .2-.3.6 0 3.4-2.8 6.2-5.7 9-8.7l.5.2c2-1.5 3.5-3 5.1-4.6l.5.2c1.6-1.1 2.8-2.3 4-3.6l.4.2c13.6-7.2 27.4-13.8 40-22.2a217.5 217.5 0 0 1 63.4-30 205.7 205.7 0 0 1 83.6-6.7c15.1 2.1 30.3 5.2 44.8 9.8A203.6 203.6 0 0 1 685.7 69c1 .8 2.7.8 4.1 1.1 0 0 .3.2.1.7 2.8 2.6 5.7 4.7 8.6 6.9l-.2.4c1.2 1.2 2.4 2 3.6 2.9l-.2.3c3.4 3.5 6.9 6.6 10.3 9.8Z",
    "data-index": 4,
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "M733.9 757.8c4-.5 8.5-1.8 8.1 5 0 .6 1.7 1.7 2.4 1.6.7-.2 1.6-1.5 1.6-2.3.2-1.6-.3-3.3-.5-4.9l2-.5c1.3 4 2 8.2 4.1 11.6 3.2 5.3-1.3 8.2-2.9 12 6.8 2.4 7.5 3.6 4.5 8.8-3.3-5.7-7.6-2-10-1.4-2.3-3.5-4-6.3-6-9 0 0-3.7 1.5-3.7 2.3-.3 8.3-1.4 9.4-9.2 9.8-1.5 3.1-3 5.9-4.2 8.8-.4 1 0 2.6.6 3.4 2.2 2.8 4.6 5.3 7.2 8.1 3-1.8 6.2-1 6 2.6-.3 2.4-1.3 4.7-1.8 6.3-3.3.5-6.6.8-9.6 1.6-.6.2-1 3.8-.5 4.2 4.8 3.2 7.1 7 4.3 12.7-.2.3.3 1 .8 2.2 2-1.9 5-3.3 5.4-5.3 1.2-4.7 4-4 7.3-3.5l2.8 6.8c4.7-7.2 8-2 10.7.1l9.6-7 4.1 8 5.6 1.6-4.4 9.6c-2.4-2-4.9-3.8-7.7-6-1.9 4.2-9.6 4.6-7 11.7-1.5.4-3.8 1.8-4.6 1.2-2.8-2-5.1-2.8-9.1.8 3.3 2 6 3.7 9 5 1.2.7 3 .2 4.2.9 2.2 1.4 4.4 3 5.9 5.2.3.5-2 3-3 4.5 5.5-.1 9-3.1 9.8-7.6.2-1.3 2-3.3 3-3.2 1.5.2 3 1.8 4.4 2.7l9.2-.6c.5-4.7 1.3-9.5 1.3-14.2 0-1.7-1.5-4.4-3-5-4-1.7-3.5-4.2-3.6-7.8-.1-3.7-3.3-7.3-5-11l-3.2-8c5.2.4 6 2.9 6.5 6 .5 3.6 2 6 6.7 3.2l-3.2-3c8.1-5.9 21.7 14.1 17.3 25.8-1.6 4-5 7.3-7.1 10.4 3.2 2 5.7 4.3 8.7 5.4 1.7.7 4.2-.5 7.5-1l-6.3-8.2 22.7-1.4 3.4 10c5.1-5.7 8.1-.3 12.3 1.5-1.8-4.9-4.5-9.3.1-13.7l4 .6c.3-.4.4-.9.6-1.4-3.6-2.8-7.5-5.4-10.9-8.5-1.1-1-1-3.4-1.8-5.9 4.4 3.2 7.3 5.5 10.6 7.4.4.2 2.4-2.1 1.8-3.3l-4.4-10 7.5-3.8-2.1-8.5a19 19 0 0 1 5.4 20.8c-1.9 4-1.6 9-2.3 13.5l2 .5 3.7-4.5 3.4 6.2 1 .4 6 1.4c-1.4 2.2-2.6 4.7-4.5 6.4-2.3 2-5.2 3.1-7.8 4.7l.5 2.2c2.3.5 5.3.3 6.7 1.7 1.4 1.3 1.1 4.3 1.8 7.4l7.2-6 4.1 5.4c-3 3.7-10.2 2.6-8.5 10l6.1-4.9 1.7.3-1.8 21.2 9.6 4.7 2-6.2c-3.2-2.5-9.7-2-7-9.4 1.5.9 2.6 1.7 3.9 2.2 1 .4 2.2.3 3.3.4 0-1.2.3-2.5 0-3.5l-5.2-13.8c4.1-.7 7.7-.8 10.9-2 2.3-.9 4-3.2 6.1-4.7 2.8-2 2.2-3.9.8-6.6-1.9-3.6 4.8-13.2 8.9-12.7 4.8.5 3.7 4.4 3.7 7.3l-7.2 2.3 7.2 7.8-10.4 5.8 9.1 2.9 2.6 7 5.4-8.2c.2-.3 0-.8-.2-1-1.6-3.7-1.3-6.8 4.6-9.8l-7.8-4.9 1-1.3c2.7 1 5.5 2 8.5 3.4-1 7.6-2.4 14.8-3.7 22l-.3.1c-.5 1.6-.6 3-.8 4.4h-.3c-.8.8-1.4 1.5-2.3 2-2.3-1.3-4-2.6-6-3.9l-4.4 10.7 1.6.6a51 51 0 0 1 8-2.3v5.3s.1.4-.3.7c-2.4 5.8-4.4 11.3-6.8 17a18 18 0 0 0-1.8 4.9c-4.5 14.6-9 28.8-13.8 43-5.8 2.8-6.2 4-3 9.3-1.5 5-3 9.5-5 14-5 .2-3 3.3-2.7 6-.4 1.6-.8 2.8-1.6 4.1-.9 1.5-1.3 3-1.8 4.8a8.5 8.5 0 0 1-1.4 3c-.5.8-.6 1.5-.8 2.6a8.2 8.2 0 0 1-1.5 3c-1 .4-2 .6-2.2 1.2-2.5 5.4-5 10.7-7 16.3-.4.9 1 2.4 1.6 4-3 6.3-6 12.2-8.7 18.2a1445 1445 0 0 0-13.3 32c-.8 2-.8 4.2-1.2 6.4h-.3c-.5.8-.6 1.5-.8 2.2 0 0 0-.1-.4 0-1.6 2.3-3 4.5-4.6 6.6-1.3 1.9-2 3.7-2.9 5.5l-.3.1c-2 .8-3.6 1.5-5.5 2-1.9 2-4 4.1-5 6.7-.5 1 1.2 3 2 5.2a691 691 0 0 1-3.8 27.4 6 6 0 0 0-1.4 1c.6.4 1.1.8 1.7 1.6-.3 2.3-.7 4.3-1.2 6.3l-.4.5c.1.2.4.4.6 1 0 .8 0 1.3-.4 1.8-.7.4-1 .8-1.4 1.1.6.4 1.1.7 1.7 1.5a6 6 0 0 1-1.3 2.7c-1 3-2 6-2.7 9.3 0 .1 1.9.7 2.9 1.4 0 1.7 0 2.9-.5 4-1.2.8-2 1.5-2.7 2.2.7.8 1.4 1.5 2.1 2.8 0 1.2 0 2-.4 2.9-5.4 2.9-4 7.3-3.6 11.8 1.5-.3 2.7-.5 4-.3 0 .8 0 1.3-.5 1.9-1.2 1.3-2.6 2.6-2.6 4 0 .8 2 1.7 3 3 0 1.3 0 2.1-.3 3-3.2-1.5-6.5 0-5.8 2.1 2 5.4 2.5 10.4.4 15.9-.7 2 0 4.5 0 7.6 5.9 2 1.3 7.9 1.8 12.3.6 4.7.1 9.5.1 14.5l-8.1-5.1 4.5-9.6-1.2-1-6.3 1.7c-3.6-8.5-3.6-8.5 3.5-11.7-.3-.5-.6-1.4-.8-1.3-3.7.5-7.4 1.5-11 1.7-7.2.4-11 12.7-20.1 5.4-.2-.2-1 .4-1.6.5-7.2 1.3-9.2-.1-9.3-7.3 0-1.7 1-3.4 1.8-5.8-2.1-.7-4.2-1.3-6-2.2-1.4-.6-3.7-1.8-3.6-2.5 1.1-8.3-3.2-4.3-7.2-3.6 3.6 4.4 6.4 8.2 2.2 12.9-.5.5.2 2.2.2 3.3 0 1.4.2 3.4-.6 4-1.4 1-3.4 1.3-5.2 1.8-.4-1.6-1.6-3.5-1.2-4.8 1-3.4 2.8-6.6 4.4-10-5.5-4.5-4.4 4-6.2 4.1l-8.5-7.8-3.5 8-.9-.5v-12.3l11.1 4 1.1-5.9 6.9-1.7c-2-1.1-2.8-2.1-3.7-2.1-4 0-8 .7-12 .5-1.5-.1-3-1.9-4.4-3-1-.9-1.8-2-2.7-3l-1.3.5 1.7 7.7a8.2 8.2 0 0 1-10-4.5c-.8-1.5 2.8-5.1 4.7-7.7.5-.6 1.8-.7 2.3-1.4.6-.9.8-2 1.3-3.7l-8 2c6.9-9.2 13.8-18.3 21-27.3.3.4.3.6.4 1.2 1 1 1.9 1.7 2.8 2.4l.5-6.5v-1h.3l1.9-3.3.3-.1.8-2h.3l3.5-2.3a20 20 0 0 0 3-4.9l-.1-3s0 .2.3.1h2.3c3.4-1.4 5.5-3.1 3.2-7l.8-3h.5c.8-1.6 1.3-3 1.8-4.5l.4-.1 3-5.5h.1l.5-.4-.5-.6c0-.3.2-.7 1-1 1.2-1.4 1.7-2.5 2.2-3.6 0 0 0 .1.4 0 1.2-1.9 2-3.7 3-5.6 0 0 0 .1.2 0 .5-.9.7-1.5.9-2.2h.3c1.2-1.5 2.1-3 3-4.4l.4-.1 3-5.5.3-.1c2-3 3.6-6 5.2-8.8l.4-.1c1.9-2.6 3.6-4.8 5-7.3 2.1-3.6.5-5-3.2-4.8v-.3c-1-1.3-2.2-2.2-3.3-3.5-3.4-6.4-10.4-4.8-15.3-7.7 0 0-.2.3-.7.4a18 18 0 0 1-5.1-1.6c-.5-1.4-.6-3-1.3-3.2a85 85 0 0 0-11-4c-.5-.2-1.5.6-2.6 1h-2l-.1-.3c-1.2-.5-2.2-.7-3.2-.8l.1-.3v-1.4c-1.7-4.6-7.2-7.2-12.7-6.2l-7.4-2.2-.1-.3c-1.6-1.2-3-2.2-4.4-3.5-1.9-1.2-3.7-2-6-2.9l-5.1-1-.2-.4-2-.8-.2-.3c-.8-.8-1.4-1.4-2-2.4a28.3 28.3 0 0 0-6-3l-3 .1-.2-.3-2-.8-.2-.3-2-.8-.2-.3-2.1-.8-.1-.3c-.9-.5-1.5-.6-2.1-.8l-.1-.4c-1.6-1.2-3-2.1-4.4-3.4-1.1-.9-2.2-1.3-3.7-1.9l-5.2-1-.1-.3a6 6 0 0 0-2.2-.8v-.3l-1-.9-.2-.2c-.8-.5-1.4-.7-2-.9l-.1-.2c-.5-.5-.8-.8-1-1.4-.2-4.3-3-4-6.1-4h-4l-.2-.2c-.8-.5-1.4-.7-2-.8v-.4l-5.6-4.6c.5-4.9-2.3-3.3-4.8-2.9h-2v-.3l-2.2-.8v-.3a10 10 0 0 0-2.2-.8v-.3l-1.1-.8v-.3l-1.1-.8-.1-.3c-.9-.5-1.5-.6-2.1-.8l-.2-.3c-.8-.5-1.5-.7-2.1-.8v-.4c-.8-1.2-1.5-2.1-2.2-3.5.4-5-3-3.8-6-4h-1.8l-.2-.3a9 9 0 0 0-2-.8v-.4a33 33 0 0 0-4.5-3v-.2a6 6 0 0 0-1.3-.9c-.3 0-.5-.2-.8-1 0-.7 0-1 .4-1.2 3.7-2.4 3.7-2.4-.6-7.1.4-.8.7-1.4 1.5-2 2-4 3.6-8 5.3-12.1h.4c2-3.4 3.5-6.7 5.1-10l.4-.2c2.3-4.5 4.3-8.9 6.3-13.2l.4-.2c.9-1 1.5-2 2-3 3.2-6.3 5.4-13.4 9.8-18.8 4-5 4.5-10.4 5.6-16.3.4-.8.7-1.4 1.5-2a52.7 52.7 0 0 0 12-22.2l.3-.1c1.6-3 2.8-6 4.1-8.8l.3-.1c.5-.3.7-.6.8-1l.4-.2c1.6-3 2.8-6 4-9.2.5-1.2.9-2 1.6-2.9.8-.7 1.3-1.5 1.8-2.2l.3-.2c.5-.8.6-1.4.8-2l.3-.2c.5-.9.6-1.5.8-2.5.4-1.2.8-2 1.6-3 .8-.7 1.3-1.4 1.8-2.1h.4l2.8-2.5a8.7 8.7 0 0 1-1.8-2.2 35 35 0 0 1 3.3-4.3l.9-1 .3-.2c4.8-.9 4.1-3.6 3-6.5l.3-.3c.5-.8.6-1.5.8-2.5.4-1.2.8-2 1.5-2.8 2.5-1.5 4.7-2.7 6.4-4.4.4-.3-.9-2.3-1.4-3.8 0-.2.2-.7.4-.8l.4-.4c-.2-.3-.4-.4-.5-1 .4-.8.8-1.3 1.4-1.9l1.9-1.1h.4c7.2-2.1 5.6-7.4 5.1-12.6a5 5 0 0 1 1.6-2c6.8-.7 7.7-5.3 7.8-10.6 0-.9.4-1.8.7-2.7l.3-.2.8-2h.4c8.5.5 7.8-8.5 12.8-11.4 2.4-1.4 4.2-4 6.2-6l1.5 1.1c0-1-.1-2.1 0-3.2l.7-4.8c1.7 1 3.5 1.8 5 3 .7.5.8 2 1.5 2.3 2.7 1.1 5.5 2 8.3 2.9l1.3-5.4c-4-2.1-7.5-3-9.4-5.1-2-2.4-2.6-6-3.8-9.1m57 84.4c3-6.4-4.5-7.2-5.1-13.1-2.1 4.6-3.5 7.3-4.6 10.2-.3.8 0 2.4.7 2.8 2.5 1.6 5.3 3 8.3 4.6l.7-4.5m105.6 51.5c-3-3.7-6.3-2.2-9.3-.4-.8.5-1 3.5-.9 3.6 2.5 1 5 2.1 7.7 2.2.8 0 1.8-3 2.5-5.4m-92-12.4 7.2-3-.3-1.5c-2.1.4-5.2 1.8-6.1 1-1.7-1.6-2.3-4.6-3.8-8.1-1 1.8-2.8 3.4-2.4 4.2 1 2.7 3 5 5.3 7.4m3 32.2c.7 1.2 1.1 2.5 2 3.5 0 .2 1.7-.3 2.2-.8 2.2-3-.2-8.4-5-10l.9 7.3m67 5.1c-4.1-.4-7.4.2-6.5 5.7 9.5.3 9.6.2 6.5-5.7m-56-45.2c-1.3 3.3-1 6 2.8 8.2-.3-3.5-.4-6.4-.8-9.2-.4-2.8-1.2-5.6-2-9-4.4 4-1.9 6.5 0 10m-57 11.2c2.2-2.7 4.5-5.4 6.5-8.2.3-.3-.5-1.7-1.1-2-.7-.4-2.3-.3-2.5 0a40.3 40.3 0 0 0-2.9 10.2m-31.9-23.5 5.8 1.7.9-2-8.6-6.4-1 1.3a77 77 0 0 1 3 5.4m55.6 368.8-2.6 4.1c7.2-.4 8.4-2 7-8.5l-4.4 4.4m76.9-333.3c-1-1.2-1.8-2.5-2.7-3.7-.9.7-2.7 1.8-2.5 2.2.8 2.3 2.1 4.4 3.3 6.6l1.4-.6.5-4.5m-124.9-43.6c3.5 1.5 4.5-.5 4.3-3.3 0-1-1.7-2.5-2.6-2.5-4 0-2.8 2.8-1.7 5.8m-.8 359.7-5.6.3c.7 1.2 1.2 3 2.3 3.5 2.6 1.2 4.1 0 3.3-3.8m-6-7.5c-2.7 0-6.5-1.6-6.5 2.6l1.6 2.2c1.8-1.4 3.7-2.9 4.9-4.8m25.8-292.8-4.6 2.8 3.4 3.1 1.9-.3c0-2 0-4-.7-5.6m27.1 330.2c.8-.7 2-1.2 2.2-2 .4-1 0-2.3-.2-3.4-.1-.3-1.7-.7-1.8-.5-.7 1-1.4 2-1.6 3.2-.1.7.4 1.6 1.4 2.7M840.3 867c0 5 3 3.4 5.5 3l.7-1.6c-1.9-.7-3.8-1.3-6.2-1.4m-127-34.8c-5.3-.8-5.6-.5-3.6 5.1 1.5-1.6 2.7-3 3.7-5m186.4 80.5-4.7.5 3.4 4.3 1.2-.8c0-1 .2-2.1 0-4M743 844.2l4-1.5-1.9-3.5h-1.4c-.4 1.5-.8 3-.7 5m32.9 390 1.5 2 4.3-3.7-1.2-1.7c-1.4 1-2.8 1.8-4.6 3.3m96.9-299.9-1.2 3.5 4.4.8 2.2-2.8c-1.5-.5-3-1-5.4-1.5M708.3 860l3.2.1-2.2-3.7c-.5 1-1 2-1 3.6m90.5 361.6 3.9-1.6-1.7-2.4c-.8 1.1-1.6 2.2-2.2 4m-15.6-12 1.8 4 2-1.3a9.7 9.7 0 0 0-3.8-2.7m-65.5-346.8-1.5-2a6471 6471 0 0 1-3.4 4.3l1.2 1c1-1 2.2-1.8 3.7-3.3m1.2-7.5-.2 3.7 1.4.4 2.3-3.7c-1-.3-2-.6-3.5-.4m66.7 22.5L784 882l2.5.3c0-1.4-.2-2.9-1-4.6M760.3 1221c3-1.9 3-1.9-.2-5a17 17 0 0 0 .2 5m90.3-357.3 2.3-2-2.6-1a4 4 0 0 0 .3 3M729.8 842c-.5 1.4-1 3-1.3 4.4l2 .2c0-1.4 0-2.9-.7-4.6m-9 31.1-2.6 2.9 2.1 1a8 8 0 0 0 .4-3.9m57.6 350.2-.6 3.4h2.3c-.3-1.3-.6-2.5-1.7-3.4m65.4-347-2.5.1 1 2.6c.6-.7 1.2-1.4 1.5-2.8m-68 366.6-1-2.6-1.6.7c.6.6 1.2 1.2 2.6 1.9m34-346.9-1-1.8-1.7.9a9 9 0 0 0 2.7 1m-88.5-58.1-2.6.4.3 1.4c.8-.4 1.6-.7 2.3-1.8M863 912.5l2.3-1.6-1-1.1c-.6.7-1.2 1.5-1.3 2.7M811.6 888l-2-1.4-.4 1.3c.8.3 1.6.5 2.4 0M712 875l.6 1.8 1-.4c-.4-.6-.8-1.3-1.6-1.4m97.6-7.1-1.4-1-.4 1.5c.6 0 1.1 0 1.8-.5m-82 36.3 1.6-.2-.3-1.5c-.5.4-1 .7-1.3 1.7m160 2.3-.7-1.9-1 .5c.4.6.8 1.2 1.6 1.4m-30 43 1.9-.6-.4-1c-.6.4-1.3.8-1.4 1.6m-101.9 278.9 1-1.5-1.5-.3c0 .5-.1 1 .5 1.8m24.1-13-1.8.7.4 1c.6-.4 1.3-.8 1.4-1.7m72.8-282.6 1 1c0-.2.3-.4.3-.4-.3-.4-.6-.7-1.3-.6m-10-96 .9 1 .4-.3c-.3-.4-.6-.7-1.3-.6m-51.1 40.8-1-1-.3.4c.3.3.6.6 1.3.6m-120.6 124.7h1.3v-.5c-.5 0-.9 0-1.3.5m199.3-70.9v-1.3h-.5c0 .5 0 .9.5 1.3m12.4-15.8-1 1 .4.3c.3-.3.6-.6.6-1.3m-27.8-.2h1.3v-.5c-.4 0-.8 0-1.3.5M819 895.6l-1 .9.4.4c.4-.3.7-.6.6-1.3m7.8-1.1-1 .9.4.3c.4-.2.7-.5.6-1.2m-78.7-4.4 1-.9-.4-.3c-.3.2-.6.5-.6 1.2Z",
    "data-index": 5,
    style: {
      visibility: "visible",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36384D",
    d: "M893.4 591.8a49.7 49.7 0 0 1-5.6 4.5c-2.4 2.1-4.1 4.1-5.8 6.1 0 0-.2.2-.7 0-1.4.9-2.4 2-3.4 3l-.4-.1c-1.2.7-2 1.6-2.9 2.4l-.4-.2c-.7.5-1.1 1.1-1.5 1.7 0 0-.3-.5-.6-.5-1.5.4-2.8.5-3.8 1.2a92.3 92.3 0 0 1-37.7 14.7l.2-.5a36 36 0 0 0-7.3-5.6c-16.8-9-33.5-18-50.4-26.5-11.9-6-24.1-11.1-36.2-16.4-6.1-2.7-12.4-4.8-18.8-7.4a497 497 0 0 0-12.4-10.3c-1.7-1.4-3.6-2.5-5.4-3.7l.1-.4c-2.8-5.3-5.7-10.2-8.7-15-.5-.7-1.8-.9-2.6-1.4l.1-.3c-1-3.2-2-6-3-8.6-10.3-25-21.8-49.8-17.5-78.2l15.4-8c1.3-.6 2.1-1.4 3.4-2.2 1.6-1.1 2.8-2.3 4-3.4.1 0 0 .2.3 0 .5-.6.7-1 1-1.6l1.4-1.7 2-2a3 3 0 0 1 1.1-.2c1-.7 1.5-1.5 2.3-2.3l1.3-1c1.2-1.5 2-3 3.2-4.6.5-.8.6-1.5 1.2-2.1.9-1.1 1.4-2.2 1.9-3.3l.2-.2c.5-.8.7-1.4.9-2l.3-.2c.9-2 1.4-3.7 2-5.4l.2-.2c1.6-3.4 2.9-6.6 4.6-9.8l10.4 1.1c19.2 2.8 37.9 7.5 54.8 17.6 3.7 2.2 7.7 3.8 11.6 5.6l-.2.4c1.5 1.3 3 2.2 4.6 3l-.2.4c.8.9 1.6 1.4 2.5 1.8l-.2.4c1.1 1.2 2.3 2 3.5 3v.3c.4.4.8.6 1.2.8 0 0-.2 0-.2.3l1.3.9s-.2 0-.2.2c.5.5.9.7 1.3.9 0 0-.2 0-.1.2.4.5.8.7 1.1 1l-.2.3c.4 1.4.5 2.6 1.1 3.4a149.7 149.7 0 0 1 26.6 58.8c4.2 17 9.2 33.5 20.7 47.2 3 3.4 7.3 5.6 11 8.3 0 0-.2 0-.2.4a33 33 0 0 0 4.6 3l-.2.4c2.5 2.3 4.8 4.9 7.7 6.2 8.8 4 17.8 7.6 26.6 11.4l-1.9 5.7-.3-.1c-3.2 3-6 5.9-8.7 8.8Z",
    "data-index": 6,
    style: {
      opacity: 1
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M268.4 281.9c1 1.9 2 3.7 2.9 6.5a21 21 0 0 0 1.3 5 158 158 0 0 1 13 67c-.4 12.6-2.8 25-4.3 37.9l-6.6 23h-.4c-.4.9-.6 1.6-.7 2.3 0 0 0-.1-.4 0a7 7 0 0 0-.7 2.2h-.4c-.5.8-.6 1.5-.8 2.2h-.3c-.5.8-.6 1.6-.8 2.3l-.2-.1a88.5 88.5 0 0 1-35.3 35.6c0-1.4.5-3 1.5-4.2 7.1-8.5 14.6-16.8 17.3-28l.3-.3c.9-2 1.4-3.7 2.2-5.7 1.5-3.8 3-7.2 4-10.7 5.9-20.3 7.3-41 5.6-62-1.3-14.4-3.2-29-6.7-43a166.8 166.8 0 0 0-28.4-59.3 117 117 0 0 0-52.8-42.7 12 12 0 0 1-4-2.8h7.4l.1.4c10.7 4.3 21.2 8.3 31.7 12.3 2.9 1.1 5.6 2.7 8.3 4v.4c2 1.3 3.8 2.1 5.6 3l-.1.4a54 54 0 0 0 5.7 4l-.2.5a364 364 0 0 0 11.3 10.7v.4c.3.9.8 1.4 1.2 1.9v.3a246 246 0 0 0 7.8 9.7l-.1.4c5.3 9 10.6 17.7 16 26.4Z",
    "data-index": 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E60AC",
    d: "M173.2 207.1c1.5 1 2.9 2.2 4.5 2.8a117 117 0 0 1 52.8 42.7c13.3 18 23 37.7 28.4 59.3 3.5 14 5.4 28.6 6.7 43 1.7 21 .3 41.7-5.5 62-1 3.5-2.6 6.9-4.5 10.9-1 2.2-1.6 4-2 5.8l-.5.1c-1.9 2.6-3.4 5-6.1 9-.8-3.2-1-5-1.6-6.7-1-2.7-2-5.3-3-8.4 16-38 14.6-76 3.7-114.3-.4-1.2-1.5-2.3-2.5-3.7-1.7-4.3-3-8.2-4.3-12.4-.8-2.3-1.7-4.3-2.7-6.3v-.3c-.3-.9-.7-1.4-1-2v-.2c-.4-1-.8-1.5-1.2-2v-.3c-.3-.9-.7-1.4-1-2l-.1-.2c-.4-.5-.8-.7-1.1-.8v-.4c-.3-1.2-.8-2.1-1.2-3v-.3c-.7-1.2-1.5-2.1-2.5-3.3A148.8 148.8 0 0 0 192 235c-.4-.6-.8-.8-1-1l-.1-.2c-1.2-1-2.3-1.4-3.3-2v-.3c-6.4-3.4-12.6-6.8-19-9.6-11-4.9-22.8-3.2-34.4-4.1l4.2-4.4c1.6-2 3.1-4 5.2-6l22.7-.7c.8 0 1.5-1 2.3-1.5.9 0 1.8 0 3.3.2.8.8 1 1.3 1.3 1.7Z",
    "data-index": 8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#56589E",
    d: "M143.1 207.4c-1.6 2-3 4-4.7 6l-4.5 4.5c-1 .4-1.5.4-2 0-.6-1.5-1.2-2.7-2.4-5-1 3.2-1.5 4.8-2.4 6.6-5.7 3-11 6-16.3 9h-.2c-.5.4-.7.8-1 1.1h-.2c-.5.4-.6.8-.8 1.1h-.3c-.9.3-1.4.8-1.9 1.2h-.3c-1.3 1-2.1 2.2-3 3.4-.1 0 0-.2-.4-.1-.5.4-.6.7-.8 1h-.3c-.5.5-.7.8-.8 1.2h-.3c-1.3 1.4-2.1 3-3 4.5h-.3c-.5.3-.7.7-.8 1 0 0 0 .2-.3 0a7 7 0 0 0-2.2 2.6c-1 1.7-2 3-3.1 4.4a11 11 0 0 0-1.1 3h-.3c-1.7 3-3 6-4.2 9h-.4a133.4 133.4 0 0 0-10.1 78.8c1.9 13.2 5.5 26 8.3 39.5-2.1 8-8.1 11.7-16.2 9.6-4-13.2-7.8-26.1-11.6-39.5l-2.3-35.5-.3-7.4c0-2.2 0-4.5.6-7.4 2.5-8.3 4.4-16 6.4-24a117 117 0 0 1 21-36.1c.8-1 .7-2.7 1.1-4 0-.4 0-.6 1-.7a6.7 6.7 0 0 0 2.3-2.5l.4.1c.5-.4.6-.8.8-1.2l.3.2c2.4-1.9 4.3-3.8 6.3-5.8l.5.2a53 53 0 0 0 7.4-4c13-8.3 27.2-13 42.4-14.8Z",
    "data-index": 9,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M189.7 1009.8c0-1.2 0-2.5.5-4.1.6-1.8.8-3.2 1-4.7 0-1 0-1.9.4-3.2 1.6-7 2.8-13.6 4.3-20.3.4-.7.5-1.4.7-2.6 1.1-6.9 2.3-13.2 3.8-19.5.8 1.7 1.7 3.4 1.6 5-.2 3-1 5.9-1.2 8.8 0 1.4.6 3 1.5 4.2.2.3 2-.5 3.2-.8l3.3-.9c.2 0 .9 1.7.7 1.8-1 .8-2.1 1.3-3.2 1.9l-5.4 3.5 9.4 2c-2.7 2.4-4.6 3.7-6 5.4-1.2 1.3-2.8 3.1-2.5 4.4.3 1.4 2.6 2.3 3.7 3.7 2 2.3 4.2 4.5 5.2 7.2.3.9-2.9 3.3-4.7 4.6-2.7 1.8-5.7 3.3-8.5 4.9l.6 2c4.9-.8 9.8-1.7 14.7-2.2 1.4-.2 3 .8 4.4 1.3-.6 1.8-.9 3.9-2 5.3-.7 1-2.8 1.4-4.1 1.2-7.3-1.3-10.1 4.2-13.4 8.8-.8 1-1 3.4-.3 4.5.8 1.1 2.8 1.8 4.3 2 1.5 0 3.2-.6 4.8-1.2 3.7-1.3 5.5-.2 5.8 4 .2 2.1 1.7 4.2 2.6 6.4l2.2-1.1-3.6-7 8-.4-2.4 5.9c1.5 1.2 3 2 3.9 3.4 1.9 3.2 3.7 3.3 6 .5 4-5 9-3.5 14-1.8 3.5 1.2 7.1 2 11.6 3.3l-.5-5.9c-1-6.1-2-12.3-2.8-18.5-2-16.1-4-32.2-5.8-48.3-1.6-15.8-3.7-31.5-4-47.3-.4-15.3.7-30.7 2.1-46 .8-8 3.6-16 5.5-23.5l-.4 5.5c-1.7 14-4.6 28-5 42.1a774.6 774.6 0 0 0 6.7 97.6c2.7 20.6 5.9 41.2 8.5 61.9-.9.4-1.5.7-2 .4-.5-4.8-1-9-1.3-13.3l-20.8 5.6c.8 2 1.4 3.4 1.5 4.9-13.2-3.7-25.9-7.4-38.6-11.5-.3-1-.6-1.8-1-2.4-.4.5-.8 1-1.6 1.6-10.4-2.9-10.4-2.9-8.1-10 3.6 1.2 5.6 1.1 4.3-3.2-1-3.4-1.7-6.8-2.5-10.7l-.1-8.5c0-1.2 0-2.3.4-4 .5-1.2.6-2 .6-2.7m16.9 31c-2.5 4.4 0 7.8 3.1 10 6.7 4.6 8.1 4.4 11.4 1-4.6-3.8-9.2-7.6-14.5-11m35 5.3-1.2 1.9 1 .4c.2-.6.4-1.2.1-2.3m-8.5.4h-1.4v.5c.5 0 1 0 1.4-.5Z",
    "data-index": 10,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A5CA5",
    d: "M67.1 390c7.8 1.9 13.8-1.7 16.1-9.5 2 3 3.7 6.3 5.3 9.5v.4c.3 1.2.8 2 1.2 3v.3c.6 1.6 1.4 2.9 2.2 4.1l-.1.4a26 26 0 0 0 2.3 4.1v.3c.3.9.7 1.4 1.1 2v.3c1 2.3 2.3 4.3 3.4 6.3v.2l1 1v.3c.8 1.6 1.6 2.8 2.4 4v.3c1.4 2.4 3 4.4 4.4 6.4v.3c2.2 3.2 4.5 5.9 6.8 8.6v.3c.3.5.7.6 1 .8v.4c2.6 2.7 5.2 5 7.8 7.5v.3c.3.5.7.6 1 .8v.3c.4.5.8.7 1.2.8v.4c1.4 1.6 3 2.8 4.5 4v.3c.5.5.8.6 1.1.8v.3a90.4 90.4 0 0 0 34.5 19.2c1.1 1.7 2.2 3 2.9 3.8a71.4 71.4 0 0 1-4.3 6.2c-1.5.1-2.7.4-3.6 0L126 464l-6.4-2.6v-.4c-.7-.5-1.2-.6-1.7-.8-4.9-3.9-10.2-7.4-14.5-11.8-6-6.1-11.2-13-17-20.1-.6-1.3-1-2-1.5-2.6l.1-.3L67.1 390Z",
    "data-index": 11,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55579C",
    d: "m163.2 478.4 4-6c-.7-1-1.8-2.2-2.4-3.9 5.3.4 10.1 1.5 15 1.7 11.5.4 22-3 32.5-7.6 1.6 3.6 3 6.9 4.2 10.5-.9 1.2-1.4 2.2-2 3.3 0 .3 0 .5-1 .6a4 4 0 0 0-2.4 1.6c1.3 9.4 2.5 18.3 4 27.1 1.9 12.4 4 24.7 5.6 37.1-2-.7-3.4-1.6-5-2.4l-10.4-5.2.2-.4a6.6 6.6 0 0 0-2.4-1.8c0 .1-.3.2-.2-.1a11 11 0 0 0-3.3-3.2c-3.6-2-5-4.6-5.4-8.8-1-9.4-2.8-18.7-5-27.8-.6-3-3.3-5.4-5-8.1v-.4c-2-1.4-3.9-2.6-6-3.1-5-1.2-10-2-15-3Z",
    "data-index": 12,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E92CD",
    d: "M779 1468.6c-16.4 4-32.6 9-49.1 11.5-30.7 4.9-61.7 8.6-92.6 12.2a529 529 0 0 1-46 3.3c-37.3 1-74.7 2.9-112 2-42.2-1-84.5-4-126.6-7.3-37.2-3-74-9-110.3-17.7-1.8-.4-3.6-1-5.6-2-.2-1-.2-1.2-.1-1.7.4-.5.7-.8 1.1-.8.5.6.8.9 1.6 1.3 2 .8 3.8 1.5 5.6 2a1136.3 1136.3 0 0 0 187.6 23.4c21.3.9 42.6.9 64 1.1 3 0 6.2-.8 9.3-.8 15-.1 30 .2 44.9-.3 25-.8 49.9-2 74.8-3.3 9.4-.5 18.8-1.4 28.1-2.5a1292.3 1292.3 0 0 0 87.5-12.8c12.5-2.4 25-5.4 37.5-8l.3.4Z",
    "data-index": 13,
    style: {
      visibility: "visible"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBF97",
    d: "M318.1 626.4a59 59 0 0 1-7.4-.3c-3.2-3.5-5.7-6.7-8.4-9.8-7-8-13.4-16.4-21-23.5-12.6-11.5-26-22-39-33-2.7-2.5-5.3-3.5-8.7-2.5a71 71 0 0 1-8.5-5.5c.6-2.2 1-4 2-5.6 2.5.6 4.7 1 6.7 1.9 3.6 1.4 7.2 3 10.8 4.7v.2l1.1.9v.2c.5 0 .8-.1 1.1-.3 17 13.2 34 26.4 51 40 0 .7.2 1 .4 1.3v.3l1 .8.1.3c.4.5.7.7 1 .9l.1.2 1 .9.1.3 1 .8.1.3 1.1.8v.3l1.1.8v.3l1.1.8v.3c.5.5.8.6 1.1.8v.4c.8.9 1.6 1.4 2.3 1.8v.4c.3.9.7 1.4 1.1 2v.2c.7 1.3 1.5 2.2 2.2 3l.1.3c.4.5.7.7 1 .9v.3c.4.9.8 1.4 1.2 2l-.1.3a104 104 0 0 0 3.5 6.5s.1.2 0 .8c-.2 1.5-.2 2.5-.2 3.5Z",
    "data-index": 14
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M141.5 1430.7c.6-8 .9-16.1 2-24 4.2-29.3 8.7-58.5 13-87.6l10.7-69.7 14-92.5 10.6-75.1a850 850 0 0 1 4.3-29c.8-.4 1.2-.3 1.6.2-3 20.7-6 41-8.8 61.2-2.9 20.8-5 41.7-8.1 62.5-4.2 28.6-8.9 57.1-13.3 85.7l-13.3 88-12.3 79.9-.4.4Z",
    "data-index": 15,
    style: {
      visibility: "visible"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M689.6 70c-1.2-.1-2.9-.1-4-1a203.6 203.6 0 0 0-64-34.7 277.5 277.5 0 0 0-44.9-9.8c-28.2-3.9-56.2-.8-83.6 6.7a217.5 217.5 0 0 0-63.5 30c-12.5 8.4-26.3 15-40 22.2 3-2.4 6.2-4.8 9.6-6.9 16.3-9.7 32.4-19.8 49-29A214 214 0 0 1 532 22c59.1-5.7 111.2 11.1 157.6 48Z",
    "data-index": 16
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5CA5",
    d: "M216.7 472.8a197 197 0 0 1-4.2-10.5c.6-1.5 1.2-2.4 1.9-3.2h.3c2.4-2 4.4-4 6.4-6.1.2-.5.5-.6 1.2-.4 1-.4 1.5-1 2-1.4h.3c.5-.4.7-.8.9-1l.2-.1c.6-.8.8-1.5 1-2.1h.3c.5-.4.6-.8.8-1.1h.3c.5-.4.6-.8.8-1.2l.2.1c.6.1.8.1 1.3-.1 3.8-6.1 7.2-12 10.6-17.9h.3l1 .2c1 2.7 2.2 5.3 3 8 .7 1.7 1 3.5 1.7 6.7 2.7-4 4.2-6.4 6.2-9-2.4 11.1-9.9 19.4-17 27.9a9.2 9.2 0 0 0-1.8 4.3 11 11 0 0 1-4.2 2.3c-5 1.4-9.3 3-13.5 4.6Z",
    "data-index": 17
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M813 1216.2v-3.4a2008.4 2008.4 0 0 0 .1-20v-3.4l1-4.4a553.8 553.8 0 0 0 .2-14.5c.3-.9.7-1.8 1-3.4a355.6 355.6 0 0 0 0-5.5c.4-2 .8-4 1.1-6.7v-2.3c1.2-9 2.3-18 3.8-27.6a456 456 0 0 0 3-11.4c1.6-.7 3.2-1.4 5.2-1.8l.5 1.2c-2 2.7-5.1 5.3-5.5 8.2-2.7 19-4.9 38.1-7 57.3-.7 7.3-.8 14.8-1.4 22.9-.2 1.7 0 2.6.1 3.6-.9 58.7 9.9 115.7 25.4 172.4-.2.4-.6.4-1 .2-5.7-22.7-11.7-45-16.4-67.5-6.4-31-10.5-62.2-10-94Z",
    "data-index": 18,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "m346.2 243.8-.2 6.1c-.4 31.2-1.4 62.3-1 93.4.6 38 6.8 75 23.5 109.7.5 1 .6 2.1.9 3.6-3.4-6.3-7.3-12.8-10-19.8a236 236 0 0 1-15.5-80c-.6-33.9-.1-67.8 0-101.6 0-3.9.5-7.8 1.2-12 .6-.1.8.3 1 .6Z",
    "data-index": 19,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "m868.9 1018.8 1.3-3.1 1-2.4c.3-.9.6-1.8 1.3-3.2l1.9-4.6 1.4-4.3 3-5.8 4.9-14.3 3-9 13.7-43.2 2-4.8c2-5.6 3.9-11 6.2-16.7-1 6-2.1 12-3.9 18-14 46.5-32 91.5-50.7 136.2-4.9 11.8-10.4 23.3-16 35.1 0-1.9.1-4.2.9-6 4.3-10.8 8.7-21.5 13.3-32 2.7-6.1 5.7-12 8.7-18.7l8-21.2Z",
    "data-index": 20,
    style: {
      visibility: "visible"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M747 324.4c2-6.9 4.8-13.6 6.7-20.7 2.8-10.8 4.8-21.8 7.6-32.6a168 168 0 0 0 3.7-50c-.8-20.6-4.4-40.7-12.2-60-3.3-8.1-6.6-16.3-10-25.2l.1-1.2a193.7 193.7 0 0 1 23.6 78.6 218 218 0 0 1-12.5 95.3c-2 5.3-4.4 10.5-7 15.8Z",
    "data-index": 21
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M177.8 561.2c16.6 13.8 33.2 28 49.7 42.3 1.1 1 2.4 1.9 3 3.1.7 1.3.5 2.9.7 4.3-1.2-.3-2.8-.4-3.7-1.1-6.1-5.4-12-11-18.2-16.3-9.7-8.3-19.6-16.4-29.4-24.7a20.6 20.6 0 0 1-3.6-4.5l1.5-3.1Z",
    "data-index": 22
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M199 950.8c3.1-15.7 5.7-31.6 9.3-47.2 7-29.5 14.6-58.8 22-88.2.2-.9.7-1.7 1.4-2.8.3-.2.6 0 .6.5 0 1.7 0 3-.3 4.3l-24.2 99c-2.8 11.5-5.2 23-8 34.4h-.8Z",
    "data-index": 23
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M865.6 555.7c-3.5-2.4-7.9-4.6-10.8-8-11.5-13.7-16.5-30.2-20.7-47.2a149.7 149.7 0 0 0-26.6-58.8c-.6-.8-.7-2-1-3.5 14.7 16 22.5 35.7 27.9 56.6 3.6 14.3 6.7 29 15 41.6 4.6 6.8 10.6 12.7 16.2 19.3Z",
    "data-index": 24
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M352.8 120.1c0 1.1.3 2.7-.4 3.8a108 108 0 0 0-16.8 45.2c-1.1 10-1.1 20.3-.1 30.2 1 10.3 4 20.3 6 31.2l-.1 2.5-.4.4c-13.8-39.5-12-77.4 11.8-113.4Z",
    "data-index": 25,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M164 608.9c10 12.2 19.9 24.4 29.7 36.8 1 1.4 1.3 3.5 2 5.3-1.8-.7-4-1-5-2.2-10-12.3-20-24.9-30-37.7.1-.9.2-1.3.8-2.1 1.2-.3 1.8-.2 2.5-.1Z",
    "data-index": 26,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55579C",
    d: "M281.4 397.8c1.4-12.4 3.8-24.8 4.2-37.3a158 158 0 0 0-13-67 24 24 0 0 1-1.3-4.7c3.4 7.8 7.4 15.8 10 24.3 8.3 27.9 8.3 56 1.4 84.5-1 .3-1.1.3-1.3.2Z",
    "data-index": 27,
    style: {
      visibility: "visible"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M346.5 243.6c-.6-.1-.8-.5-1.4-1-.3 0-.3-.1-.2-.7.1-1.9 0-3.2.2-5a301 301 0 0 1 19.8-85.8l3.8-8.3s-.1-.1.2-.3c2.9-4.2 5.4-8.3 8.1-12.4l.2.2c-1 2.5-1.8 5.2-3.2 7.5-10.5 17-15.6 36-20 55-3 13.4-4.7 27.2-6.7 40.8-.5 3.2-.4 6.6-.8 10Z",
    "data-index": 28
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9E92CD",
    d: "m197.7 1052.6-1.4-.3c-2-.8-3.6-1.9-5.3-2.3-6.3-1.4-8-5.2-6.7-11.2 1.6-7.2 2.5-14.5 4-22 .4 2.4.5 5 .2 8.6-.9 5-1.4 9.3-1.9 13.5-1.9 7.1-1.9 7.1 8.6 10.3l2.5.9a5942 5942 0 0 0 38.9 11.2l2.8 1 15.5 2.2h2c.5-.2 1.1-.5 2.3-.7 2.2.7 3.8 1.3 5.4 2.2 0 1 0 1.5-.6 2-22.8-3.3-45-7.7-66.3-15.4Z",
    "data-index": 29,
    style: {
      visibility: "visible"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M478 569.1c.2.7.1 1.5-.5 2.5l-1.2.3-87.2 35.2c-2.2.9-4.4 1.7-7 2.5 9-4.8 18.3-10.2 28.2-14.2 22.3-9.1 44.9-17.5 67.7-26.3Z",
    "data-index": 30
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M792 424.1c-3.7-1.5-7.7-3.1-11.4-5.3-17-10-35.6-14.8-54.8-17.6l-10.7-1.1c-1.6 0-2.3 0-3.2-.3a68 68 0 0 1-1-2.3c29.2 2 57 8.4 81.1 26.6Z",
    "data-index": 31
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M149.7 652.1c6.7 10.7 13.5 21.3 20.1 32 .9 1.4.8 3.3 1.2 4.9-1.6-.8-3.9-1.1-4.7-2.4-7-10.6-13.6-21.3-20.6-32.5-.3-1-.3-1.4-.3-1.8l2.2-1c1 .1 1.6.5 2.1.8Z",
    "data-index": 32,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M66.8 389.8c6.3 12 12.3 23.6 18.2 35.7-1.2-.7-2.6-1.8-3.5-3.1A178.5 178.5 0 0 1 56 361.5c-.6-2.8-1.4-5.6-1.8-9l1-1.7 11.6 39Z",
    "data-index": 33,
    style: {
      visibility: "visible"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M520 520.6c-12.4 8.3-26.2 13-41.2 16-.2 4-.3 8-.8 12.3-1.8-11.5-3.4-23.3-5-35.6a152.1 152.1 0 0 1 20.7-5.6c-5.8 2.2-12 4.1-18.6 6.1l2.8 21c4.5-1 8.5-1.7 12.3-2.8 4-1.2 7.7-2.6 11.5-4l18.4-7.4Z",
    "data-index": 34
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9185BE",
    d: "M922.4 838.2c1-7.4 2.5-14.8 3.2-22.3 1-12.5 2.2-25 2.1-37.6 0-11.3-1.9-22.7-3-34v-6.1c1.4 8.8 3.6 18.2 4.1 27.6 1.3 24.5-.5 48.9-5.2 73.3-.8.2-1 .2-1.2 0v-.9Z",
    "data-index": 35,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M162.9 478.5c5.3 1 10.3 1.8 15.3 3 2.1.5 4 1.7 6 3.1-5.4-.5-10.9-1.5-16.3-2.3a108.5 108.5 0 0 1-48.2-20.5c2 .6 4.2 1.4 6.3 2.3l33.3 14.4c1 .4 2.1.1 3.6 0Z",
    "data-index": 36,
    style: {
      visibility: "visible"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M143.6 207.4a98.4 98.4 0 0 0-42.9 14.9 54 54 0 0 1-7.5 3.9 84 84 0 0 1 46.2-20c9.3-1.2 18.8-.8 28.7-1-.3.6-1 1.5-1.8 1.5l-22.7.7Z",
    "data-index": 37
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M221.1 542.7c-2-12.3-4.1-24.6-6-37-1.5-8.8-2.7-17.7-3.7-27 .6-.5.8-.5 1-.5l8.2 47c1 5.5 2 11 2.8 17.3-.4 1.4-.7 2-1 2.2l-1.2-2Z",
    "data-index": 38,
    style: {
      visibility: "visible"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M407.6 498.4c1.8.3 4.2.4 6 1.4a103.5 103.5 0 0 0 50.5 11.8c2.6 0 5.1 0 7.8.5a95.7 95.7 0 0 1-64.3-13.7Z",
    "data-index": 39
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M839.9 1377.8h.6c6 18.6 11.7 37.2 17.3 55.9.3 1 0 2.3-.4 3.4-.5 0-.9-.3-.9-.7-3.8-12.9-7.7-25.3-11.3-37.9-2-6.8-3.6-13.8-5.3-20.7Z",
    "data-index": 40,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M924.8 736.5c-1.2-2.8-2.6-5.8-3.4-9-3-13-8-25.3-15.7-36.4-1-1.4-1.5-3.2-2.2-5.3a93.5 93.5 0 0 1 21.3 50.7Z",
    "data-index": 41,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M184.3 485.4c1.6 2.3 4.3 4.7 5 7.7 2 9.1 3.8 18.4 4.9 27.8.4 4.2 1.8 6.8 5.4 8.8 1.2.7 2.2 1.8 2.9 3.1-1.9-.2-3.3-.7-4.8-1.3v-.3a23 23 0 0 0-3.3-2.4c0-.2-.3-.4-.8-.5l-6.3-36c-.4-2.3-1.9-4.4-3-7Z",
    "data-index": 42,
    style: {
      visibility: "visible"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M902.8 583c.2-1.8.9-3.6 1.5-5.6-8.8-3.8-17.8-7.4-26.6-11.4-2.9-1.3-5.2-3.9-7.7-6.3a106.9 106.9 0 0 0 39.5 15.5l1.8 2c-2.7 2-5.5 3.8-8.5 5.8Z",
    "data-index": 43
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M81.4 236.1c0 1.1 0 2.8-.9 3.8a125.6 125.6 0 0 0-21.2 36c-.8.4-1 .4-1.2.4A101 101 0 0 1 81.4 236Z",
    "data-index": 44,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M922.4 839.3h.9a663.5 663.5 0 0 1-4.8 32.7c-1 5.8-2.8 11.5-4.6 17.4 1-7 2.3-14.2 3.8-21.8l.4-3.7 4.3-24.6Z",
    "data-index": 45,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M138.1 656.5a82.1 82.1 0 0 0 7 45.2c.5 1.3.9 2.8 1.3 4.6-3.4-9.1-7.1-18.6-9.8-28.4-1.4-5-1-10.5-1-15.9 0-1.8 1.4-3.6 2.5-5.5Z",
    "data-index": 46,
    style: {
      visibility: "visible"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M830.6 624.7a94 94 0 0 0 37.7-14.8c1-.6 2.3-.8 4-1a112 112 0 0 1-36.9 17.6c-2.1-.4-3.5-1.1-4.8-1.8Z",
    "data-index": 47
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M198.9 951.3c.1-.5.6-.5.8 0 .3 1.6.3 2.8.3 4l-3.7 19.8-.7 2.5c-1.2 6.6-2.4 13.2-4 19.9a729 729 0 0 1 4.5-31.7c.7-4.7 1.8-9.4 2.8-14.5Z",
    "data-index": 48,
    style: {
      visibility: "visible"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M221.3 223.5c-2.8-1-5.5-2.6-8.4-3.7-10.5-4-21-8-31.7-12.3a82.6 82.6 0 0 1 40.1 16Z",
    "data-index": 49
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M710.6 397.3c.6.9 1 1.5 1.2 3l-1.3 9.8-.3.2c-1 1.9-1.4 3.6-2 5.4h-.2c-.6.9-.7 1.5-.9 2.2h-.2c-.9.5-1.3 1-1.8 1 1.6-6.2 3.3-11.9 5.4-18.8-5 .9-8.2 1.4-11.5 1.7l-.5-2 1.3-1.3c.8-.5 1.4-.6 1.9-.7 2.8-.3 5.7-.5 8.9-.5Z",
    "data-index": 50
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M55.2 350.3a3 3 0 0 1-.9 1.7c-1-14.6-1.7-29.3-2-44.3.4 2.2.4 4.6.6 7l2.3 35.6Z",
    "data-index": 51,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M236.6 1469.1v1.1a786.2 786.2 0 0 1-35.4-10.6c-.2-.3-.1-.4.3-.4 12 3.3 23.5 6.6 35 10Z",
    "data-index": 52,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M268.4 281.5a741 741 0 0 1-16-26c2.8 3.2 6 6.6 8.3 10.6 2.9 4.8 5.1 10 7.7 15.4Z",
    "data-index": 53,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M813.2 1457.1c-10.9 3.7-21.8 7.5-33 10.9-.5-.5-.5-.8-.1-1.2l14.6-4.5 18.5-5.3v.1Z",
    "data-index": 54,
    style: {
      visibility: "visible"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M318.3 626.8c-.2-1.4-.2-2.4-.1-3.8 2.2 6.9 4.4 14.3 6.6 21.8l1.7 7.4c.3.6.1 1 .1 1-1-1.6-2.4-3-2.8-4.6-2-7.1-3.6-14.3-5.5-21.8Z",
    "data-index": 55
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "m222.4 545 1-2c.3-.1.6.2.9 1.1l.7 5.7-3.1-2-.4-.4-6.8-5s-.2.2-.2-.1c-.6-.6-1.1-1-1.6-1.2 0 0-.2 0-.4-.4l-2.8-1.9-.5-.4-2.3-1.5s-.1.1-.2-.2l-1.4-1.4 10.4 5c1.6.9 3 1.8 5 2.5.4 0 .4 0 .4.3.4 1 .8 1.4 1.3 2Z",
    "data-index": 56
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M172.8 532.8c-.4 2.3-1.2 4.9-1.8 7.5-1 5.7.7 10.7 4.3 15.5-8.4-4.6-9.4-13-2.5-23Z",
    "data-index": 57,
    style: {
      visibility: "visible"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M732.8 350c-.4-.5-.8-1.6-.5-2.1 3.8-6.3 7.7-12.5 12-18.5-3.6 7-7.4 13.7-11.5 20.7Z",
    "data-index": 58
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M57.8 276.5c.5-.2.8-.2 1.3-.2a263 263 0 0 1-5.7 23.3c1.1-7.5 2.6-15.2 4.4-23Z",
    "data-index": 59,
    style: {
      visibility: "visible"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M707.6 383.5c-.1-1-.3-2.7.4-3.5 3.9-4.6 8-9 12.4-13.3-3.9 5.6-8.2 11-12.8 16.8Z",
    "data-index": 60
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M181 1451.5c-7.7-3.5-15.4-7-23.3-10.8-.2-.4-.1-.4.3-.4a959 959 0 0 1 23 11.1Z",
    "data-index": 61,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M142.7 623.2a354 354 0 0 1 3.7 22.9c-4.3-6.7-7.2-14.1-3.7-22.9Z",
    "data-index": 62,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M851.1 1440.3c-7.1 3.4-14.3 6.7-21.9 10-.5 0-.5 0-.2-.3a817.3 817.3 0 0 1 22.1-9.7Z",
    "data-index": 63,
    style: {
      visibility: "visible"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M721 366.6c1-6.8 5.6-11.6 11-16.1-3.3 5.4-7 10.7-11 16.1Z",
    "data-index": 64
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M281.3 398.3c.3-.4.5-.4 1-.4a269 269 0 0 1-7.3 23.2c1.9-7.3 4-14.9 6.3-22.8Z",
    "data-index": 65
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M155 574c-2.4 6.1-4.5 12.4-2 19.7-4.8-5.7-4.3-12 2-19.6Z",
    "data-index": 66,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M216.5 473c4.4-1.8 8.6-3.4 13.3-4.9a328 328 0 0 1-14.9 8c.2-.8.7-1.8 1.6-3Z",
    "data-index": 67,
    style: {
      visibility: "visible"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M244.4 552.4c-3.4-1.2-7-2.9-10.6-4.3-2-.8-4.2-1.3-6.7-2.3-.4-.8-.4-1.3-.3-1.8.5 0 1 .1 2 .5.8.4 1 .5 1.4.5a277 277 0 0 1 14.2 7.4Z",
    "data-index": 68
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M243.4 242.5a148 148 0 0 1-11.1-10.5 134 134 0 0 1 11.1 10.5Z",
    "data-index": 69
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M191.8 528c-4.2.6-8.7 1-13.7 1.4 3.6-5.2 8.5-3.7 13.7-1.4Z",
    "data-index": 70,
    style: {
      visibility: "visible"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M711.8 90.9a136 136 0 0 1-10-9.5c3.3 2.8 6.6 6 10 9.5Z",
    "data-index": 71
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M701.6 397.4c-.4.5-1 .6-1.8.9a121 121 0 0 1 6.2-13.8c-1.2 4.2-2.8 8.3-4.4 12.9Z",
    "data-index": 72
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "m828.8 1450.3-15.1 6.8c-.5 0-.5 0-.4-.5 5.2-2.3 10.3-4.3 15.4-6.3Z",
    "data-index": 73,
    style: {
      visibility: "visible"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M733.3 118a165 165 0 0 1-8.2-11c2.7 3.3 5.4 7 8.2 11Z",
    "data-index": 74
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M340 638.6c-2.4 3-5 6-8.2 9 2.4-3 5-6 8.2-9Z",
    "data-index": 75
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M893.8 591.9c2.4-3 5.1-6 8.3-8.9-2.4 3-5.1 6-8.3 8.9Z",
    "data-index": 76,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M829.3 1112.9c-.4-.2-.5-.4-.5-1.1 0-.4 0-.4.2-.7 1.2-1.9 2.1-3.6 3-5.3 1.3-2.1 2.6-4.3 4.3-6.5-2 4.4-4.3 9-7 13.6Z",
    "data-index": 77,
    style: {
      visibility: "visible"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M379 91.2a84 84 0 0 1-8.6 8.3 84 84 0 0 1 8.5-8.3Z",
    "data-index": 78
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M875.5 656.1c-3.6-2.4-7.3-5.1-11-8.2 3.6 2.3 7.2 5.1 11 8.2Z",
    "data-index": 79,
    style: {
      visibility: "visible"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M830.6 624.6a21 21 0 0 0 4.5 2.1c.4.4.4.8 0 1.6l-.7.4c-3.4-2-6.7-4.1-10-6.6 0-.4.1-.4.5-.3l5.7 2.8Z",
    "data-index": 80
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M252.7 254.7a77.6 77.6 0 0 1-8-9.3 84 84 0 0 1 8 9.3Z",
    "data-index": 81
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M367.2 102.1c-2 2.8-4.3 5.8-6.9 8.7 2-3 4.3-5.7 6.9-8.7Z",
    "data-index": 82
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M834.5 629c0-.3.2-.4.7-.5 3.6 2 7 4 10.3 6.4a88.7 88.7 0 0 1-11-5.9Z",
    "data-index": 83
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M855.6 641.6a77.7 77.7 0 0 1-10-6c3.3 1.6 6.6 3.6 10 6Z",
    "data-index": 84
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M698.3 77.4a63 63 0 0 1-8.3-6.3c2.9 1.7 5.5 3.9 8.3 6.3Z",
    "data-index": 85
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M721 101.2a85.9 85.9 0 0 1-7.1-7.6c2.3 2.2 4.6 4.8 7 7.6Z",
    "data-index": 86
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M359.3 111.1a69.8 69.8 0 0 1-5.6 8.6 66 66 0 0 1 5.6-8.6Z",
    "data-index": 87
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M147.4 709.4c2 3 3.8 6.4 5.7 10.3-2-3-3.8-6.5-5.7-10.3Z",
    "data-index": 88,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M909.4 906.3a12 12 0 0 1 0-5.4l.8-4.7c.5-.6 1-1.3 2-2-.7 3.8-1.6 7.8-2.8 12Z",
    "data-index": 89,
    style: {
      visibility: "visible"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M226.4 544c.3.5.3 1 .3 1.8-.5 2-1 3.8-1.9 5.7-1.3-.8-2.3-2-3-3.3 1 .2 1.8.7 3.2 1.6l-.6-5.4c.6-.4 1.1-.4 2-.4Z",
    "data-index": 90
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M738.6 126.4c-1.8-2-3.6-4.5-5.2-7.3 1.9 2 3.5 4.5 5.2 7.3Z",
    "data-index": 91
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M864.3 647.2c-2.7-1.3-5.6-3-8.6-5 2.7 1.4 5.6 3 8.6 5Z",
    "data-index": 92
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M158.6 610.4a51.2 51.2 0 0 1-8.5 3.7c2.5-1.3 5.3-2.7 8.5-3.7Z",
    "data-index": 93,
    style: {
      visibility: "visible"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M882.3 602.2a52 52 0 0 1 5.2-5.8 60.4 60.4 0 0 1-5.2 5.8Z",
    "data-index": 94
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M92.5 226.1a44.8 44.8 0 0 1-6 5.7c1.6-2 3.6-3.7 6-5.7Z",
    "data-index": 95
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M742.9 134.3v1.2c-1.5-2.5-3-5.2-4.4-8.4 1.5 2 3 4.4 4.4 7.2Z",
    "data-index": 96
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M164 608.5c-.7.3-1.3.2-2.4.2-1.1-1.6-2-3.3-3-5.3 1.8 1.3 3.6 3 5.4 5Z",
    "data-index": 97,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M900 680.6a36 36 0 0 1-5.4-4.8 36 36 0 0 1 5.5 4.8Z",
    "data-index": 98,
    style: {
      visibility: "visible"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M173.7 207.1c-.7-.4-1-.9-1.4-1.6 2.7.2 5.5.6 8.6 1.3-2.1.4-4.4.4-7.2.3Z",
    "data-index": 99
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M379 610.7c-2 1.5-4.3 3-7 4.5 2-1.5 4.3-3 7-4.5Z",
    "data-index": 100
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M157.5 1440.4a52 52 0 0 1-6.7-4c-.1-.4.1-.6.5-.6 2.4 1.5 4.3 3 6.3 4.5h-.1Z",
    "data-index": 101,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M881.3 661.7c-2-1.3-3.8-2.9-5.7-4.9 2 1.2 3.8 2.8 5.7 4.9Z",
    "data-index": 102,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M201 1459.3c-2.9-.9-5.6-1.8-8.7-3-.2-.4-.2-.4.3-.4 3.1 1 5.8 2.2 8.5 3.3l-.1.1Z",
    "data-index": 103,
    style: {
      visibility: "visible"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M232.9 808.8c.6-2.7 1.3-5.3 2.5-8.2.8.2 1.1.5 1.2 1.2l-3.3 7.4-.4-.4Z",
    "data-index": 104
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M145 652.3c.4.4.4.8.4 1.5-1.7.7-3.3 1.1-5.4 1.5 1.3-1 3-2 5-3Z",
    "data-index": 105,
    style: {
      visibility: "visible"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M384.5 86.7c-1.3 1.5-2.9 3-4.9 4.5 1.3-1.5 3-3 5-4.5Z",
    "data-index": 106
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M150.6 1436.2c-2-1-4-2-6.2-3.4-.2-.3-.2-.4.2-.4 2.4 1.1 4.3 2.3 6.3 3.4l-.3.4Z",
    "data-index": 107,
    style: {
      visibility: "visible"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M349 630.8c-1 1.5-2.2 3-3.8 4.5a21 21 0 0 1 3.7-4.5Z",
    "data-index": 108
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M232.2 231.3a23 23 0 0 1-5.5-3.7c1.8.9 3.6 2.1 5.5 3.8Z",
    "data-index": 109
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M318.3 621.7a40.5 40.5 0 0 1-3.5-6.1c1.2 1.6 2.3 3.6 3.5 6Z",
    "data-index": 110
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M226.6 226.9c-1.6-.6-3.4-1.4-5.3-2.7a19 19 0 0 1 5.3 2.7Z",
    "data-index": 111
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M146 618.5a15 15 0 0 1-2.6 4.5 13 13 0 0 1 2.6-4.5Z",
    "data-index": 112,
    style: {
      visibility: "visible"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M371.2 615.2c-1 1-2.3 1.9-3.8 2.6 1-1 2.2-1.8 3.8-2.6Z",
    "data-index": 113
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M870 559c-1.4-.5-3-1.4-4.4-2.6 1.4.5 2.8 1.4 4.4 2.7Z",
    "data-index": 114
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M149.7 651.7c-.5 0-1-.3-1.9-.7a18 18 0 0 1-1.4-4c1 1.1 2.1 2.7 3.3 4.7Z",
    "data-index": 115,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M903.5 685c-1.1-.8-2.3-2-3.4-3.6 1.1.8 2.2 2 3.4 3.7Z",
    "data-index": 116,
    style: {
      visibility: "visible"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M796.4 427.5c-1.4-.5-2.9-1.4-4.4-2.7a15 15 0 0 1 4.4 2.7Z",
    "data-index": 117
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M389 83.4c-1 1-2.1 2.3-3.8 3.4.9-1.2 2.2-2.2 3.8-3.4Z",
    "data-index": 118
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M161 732.7c1 .9 2.1 2.1 3.3 3.7-1.1-.8-2.2-2-3.4-3.7Z",
    "data-index": 119,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M192 1456c-1.7-.5-3.4-1-5.3-2-.2-.3-.1-.4.3-.4 2 .8 3.6 1.5 5.1 2.3Z",
    "data-index": 120,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "m186.4 1453.8-5.2-2c-.3-.3-.2-.3.2-.4 2 .7 3.6 1.5 5.2 2.2l-.2.2Z",
    "data-index": 121,
    style: {
      visibility: "visible"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M878.2 605.3c.7-1 1.7-2 3-2.8a10 10 0 0 1-3 2.8Z",
    "data-index": 122
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M191 1001.4c0 1-.2 2.5-.7 4 0-1.2.2-2.4.7-4Z",
    "data-index": 123,
    style: {
      visibility: "visible"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M725.1 106.4c-1-.6-2-1.6-2.8-3 1 .7 1.9 1.7 2.8 3Z",
    "data-index": 124
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M345 237.3v4.6c-1-1.2-1.7-2.9-2.5-5 0-.6.2-.7.5-.6l2 1Z",
    "data-index": 125,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M165.4 738.3a10 10 0 0 1 2.5 2.8 9 9 0 0 1-2.5-2.8Z",
    "data-index": 126,
    style: {
      visibility: "visible"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M802 433a12 12 0 0 1-3.3-2.6c1.1.5 2.2 1.4 3.4 2.6Z",
    "data-index": 127
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M744.8 328.9c.2-1.3.7-2.8 1.6-4a8.6 8.6 0 0 1-1.6 4Z",
    "data-index": 128
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M153 594.5c.8.8 1.6 2 2.3 3.7-.8-.8-1.6-2-2.3-3.7Z",
    "data-index": 129,
    style: {
      visibility: "visible"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M701.7 80.7c-1-.5-2.2-1.3-3.4-2.6a11 11 0 0 1 3.4 2.6Z",
    "data-index": 130
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "m236.8 801.5-1.1-1.2c-.3-.6-.2-1 0-1.7 1 .5 2 1.3 3.2 2.4.2.4 0 .4-.3.5h-1.8Z",
    "data-index": 131
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M372.7 463a7 7 0 0 1 2.2 2.5 8.2 8.2 0 0 1-2.2-2.6Z",
    "data-index": 132
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M370.5 459.6c.7.5 1.5 1.3 2.2 2.6a8.4 8.4 0 0 1-2.2-2.6Z",
    "data-index": 133
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M158.6 729.4c.8.5 1.5 1.3 2.3 2.6a8 8 0 0 1-2.3-2.6Z",
    "data-index": 134,
    style: {
      visibility: "visible"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M375 466.3c.7.5 1.4 1.3 2.2 2.6a8.3 8.3 0 0 1-2.3-2.6Z",
    "data-index": 135
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M326.7 653.1v-.5c.7-1 1.3-1.8 2.2-2.7.2.8 0 1.8-.7 3l-1.2.3h-.3Z",
    "data-index": 136
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M156.4 726a8 8 0 0 1 2.3 2.6 8 8 0 0 1-2.3-2.6Z",
    "data-index": 137,
    style: {
      visibility: "visible"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M312.7 611.5a7.2 7.2 0 0 1-2.3-2.6 6 6 0 0 1 2.3 2.6Z",
    "data-index": 138
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M857 1437.3c-.9.7-2 1.3-3.3 1.9-.4 0-.4 0-.3-.4 1.1-.9 2.1-1.4 3.1-2l.5.5Z",
    "data-index": 139,
    style: {
      visibility: "visible"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M875 607.6c.4-.7 1.3-1.6 2.6-2.3a8 8 0 0 1-2.7 2.3Z",
    "data-index": 140
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M144.2 1432.5c-.8-.4-1.6-.8-2.5-1.5-.2-.3 0-.6.6-.7 1 .7 1.4 1.4 2 2.1h-.1Z",
    "data-index": 141,
    style: {
      visibility: "visible"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M380.3 474c.7.2 1.5.7 2.4 1.6-.7-.2-1.4-.7-2.4-1.5Z",
    "data-index": 142
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M189.5 1010c.2.6 0 1.3-.3 2.1-.2-.6-.1-1.2.3-2Z",
    "data-index": 143,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M912.7 893.8a9 9 0 0 1 .5-4 9 9 0 0 1-.5 4Z",
    "data-index": 144,
    style: {
      visibility: "visible"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M309.3 605.9c-.7-.1-1.5-.6-2.2-1.5.7.1 1.4.6 2.2 1.5Z",
    "data-index": 145
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M155.3 599c.7 0 1.4.6 2.2 1.5-.7-.2-1.4-.7-2.2-1.6Z",
    "data-index": 146,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M157.2 571.7c-.2.7-.7 1.5-1.6 2.2.2-.7.7-1.5 1.6-2.2Z",
    "data-index": 147,
    style: {
      visibility: "visible"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M369.4 99.8a3 3 0 0 1-1.2 2c0-.7.5-1.3 1.2-2Z",
    "data-index": 148
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M798.7 429.7c-.7-.1-1.5-.6-2.3-1.5.8.1 1.5.7 2.3 1.5Z",
    "data-index": 149
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M232 812.3c0-1 .2-2 .7-3.2.2-.3.5 0 .6.4a12 12 0 0 1-1 3.1l-.4-.3Z",
    "data-index": 150
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M84.7 232.8c-.2.8-.8 1.6-1.8 2.3.2-.8.9-1.4 1.8-2.3Z",
    "data-index": 151,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "m342.4 236.4-1.3-2.7c-.1-.3.1-.6.6-.5.6 1 .8 2 1 3l-.3.2Z",
    "data-index": 152,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M815.2 1204.6c-.2-.5-.4-1.5-.3-2.7.3.6.4 1.4.3 2.7Z",
    "data-index": 153,
    style: {
      visibility: "visible"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M350 629.7c.1.3 0 .7-.5 1.1-.2-.4 0-.7.6-1Z",
    "data-index": 154
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M344.5 635.2c-.3.4-.9.8-1.8 1.2.2-.5.8-.9 1.8-1.2Z",
    "data-index": 155
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M245 244.8c-.7-.2-1.2-.7-1.6-1.6.7.2 1.2.7 1.5 1.6Z",
    "data-index": 156
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M157.4 601.1c.5.2.9.7 1.3 1.6-.5-.2-1-.7-1.3-1.6Z",
    "data-index": 157,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M84.7 426.2c.6.2 1 .9 1.5 1.9-.6-.2-1.2-.9-1.5-2Z",
    "data-index": 158,
    style: {
      visibility: "visible"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M272.8 425.7c-.2-.6 0-1.3.5-2 .2.5 0 1.2-.5 2Z",
    "data-index": 159
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M314.9 614.9c-.4-.2-.8-.7-1.2-1.6.4.2.8.7 1.2 1.6Z",
    "data-index": 160
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M274 423.4c-.3-.5-.1-1.2.4-2 .2.6 0 1.2-.5 2Z",
    "data-index": 161
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M271.7 427.9c-.2-.6 0-1.3.4-2 .2.5 0 1.2-.4 2Z",
    "data-index": 162
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M381.3 609.6c-.2.4-.7.8-1.6 1.1.2-.4.7-.7 1.6-1.1Z",
    "data-index": 163
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M836.9 1099c-.1-.5 0-1.2.5-2 .2.5 0 1.2-.5 2Z",
    "data-index": 164,
    style: {
      visibility: "visible"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M310.5 608.2c-.5-.2-.9-.7-1.2-1.6.4.2.8.7 1.2 1.6Z",
    "data-index": 165
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M873 609c0-.4.5-1 1.3-1.4 0 .5-.6.9-1.3 1.5Z",
    "data-index": 166
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M269.5 431.7c-.1-.4 0-1 .5-1.5.1.5 0 1-.5 1.5Z",
    "data-index": 167
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#44439C",
    d: "M270.5 430a3 3 0 0 1 .5-2c.2.6 0 1.2-.5 2Z",
    "data-index": 168
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M147.2 616.5c.1.4 0 1-.5 1.9-.2-.5 0-1.1.5-2Z",
    "data-index": 169,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M177.2 529.3c-.2.4-.8.8-1.8 1.2.3-.5.9-.9 1.8-1.2Z",
    "data-index": 170,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M155.2 723.8c.5.2.8.7 1.2 1.6-.4-.2-.8-.8-1.2-1.6Z",
    "data-index": 171,
    style: {
      visibility: "visible"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M369.3 457.3c.4.2.8.7 1.2 1.6-.4-.2-.8-.7-1.2-1.6Z",
    "data-index": 172
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M378.2 470.7c.4.2.8.8 1.2 1.7-.4-.2-.8-.7-1.2-1.7Z",
    "data-index": 173
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M176.4 557.7c.4.1.8.7 1.2 1.5-.4-.1-.8-.7-1.2-1.5Z",
    "data-index": 174,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M146.3 707c.4.2.8.7 1.2 1.6-.4-.2-.9-.7-1.2-1.5Z",
    "data-index": 175,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M153 720.4c.4.2.8.7 1.2 1.6-.4-.2-.8-.7-1.1-1.6Z",
    "data-index": 176,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M212.7 478.1h-1.2c.3-.3.9-.8 1.9-1 .1.3-.1.6-.7 1Z",
    "data-index": 177,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#988BC8",
    d: "M853.3 1439.2a9 9 0 0 1-1.9 1.1c-.3 0-.3 0-.2-.3.8-.5 1.4-.7 2-.9l.1.1Z",
    "data-index": 178,
    style: {
      visibility: "visible"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M302.6 599.2c-.3.2-.6 0-1-.5.3 0 .7 0 1 .5Z",
    "data-index": 179
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M303.7 600.3c-.3.2-.6 0-1-.5.3 0 .7 0 1 .5Z",
    "data-index": 180
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9E92CD",
    d: "M779.7 1467v1c0 .3-.4.5-.6.6-.1 0-.3-.3-.3-.6.2-.7.5-.9.9-1Z",
    "data-index": 181,
    style: {
      visibility: "visible"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBF97",
    d: "M230 544.8c-.1.2-.4 0-.8-.2.2-.3.4-.2.8.2Z",
    "data-index": 182
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M304.9 601.5c-.4.1-.7 0-1.1-.5.3-.2.7 0 1 .5Z",
    "data-index": 183
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M306 602.6c-.4.1-.7 0-1-.5.2-.1.6 0 1 .5Z",
    "data-index": 184
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M245.7 553.6c-.3 0-.6-.1-1-.6.2 0 .6 0 1 .6Z",
    "data-index": 185
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M246.5 553.8c0 .2-.3.3-.7.2.1-.2.3-.3.7-.2Z",
    "data-index": 186
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M307 603.7c-.3.1-.6 0-1-.5.3-.1.7 0 1 .5Z",
    "data-index": 187
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M722 102.9c-.3.2-.7 0-1.1-.4.3-.2.8-.1 1.2.4Z",
    "data-index": 188
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M157.4 570.9c.4 0 .6.1.8.3l-.5.5c-.2-.2-.3-.3-.3-.8Z",
    "data-index": 189,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M175.4 556.5c.3 0 .6.1 1 .6-.3 0-.6 0-1-.6Z",
    "data-index": 190,
    style: {
      visibility: "visible"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M301.5 598.1c-.3.2-.6 0-1-.5.2-.1.6 0 1 .5Z",
    "data-index": 191
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M300.4 597c-.4.2-.7 0-1-.5.2-.1.6 0 1 .5Z",
    "data-index": 192
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M299.2 596c-.3 0-.6-.2-1-.6.3-.1.7 0 1 .5Z",
    "data-index": 193
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M298.3 594.8c-.3 0-.4-.3-.4-.7.3.1.4.3.4.7Z",
    "data-index": 194
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M118 460.7c.4-.2 1 0 1.5.4-.3.2-.8 0-1.4-.4Z",
    "data-index": 195,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F83BD",
    d: "M887.8 667.4c-.2 0-.6-.3-1-.9.2 0 .6.3 1 .9Z",
    "data-index": 196,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M885 665c-.4.2-.8 0-1.4-.5.3-.1.7 0 1.3.5Z",
    "data-index": 197,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M883.5 664c-.4 0-.7-.1-1.1-.6.3-.1.7 0 1 .5Z",
    "data-index": 198,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M882.3 662.8c-.3.2-.6 0-1-.5.3-.1.7 0 1 .5Z",
    "data-index": 199,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M139.4 655.3c.1.3-.1.6-.6 1 0-.2 0-.6.6-1Z",
    "data-index": 200,
    style: {
      visibility: "visible"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M330 648.7c.2.3 0 .6-.5 1-.1-.3 0-.6.6-1Z",
    "data-index": 201
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M331.2 647.6c0 .2-.1.6-.6 1-.1-.3 0-.6.6-1Z",
    "data-index": 202
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M85.9 231.7c.1.3 0 .7-.5 1.1-.2-.3 0-.7.5-1Z",
    "data-index": 203,
    style: {
      visibility: "visible"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M382.6 476.2c.2 0 .4.3.3.7-.2 0-.3-.2-.3-.7Z",
    "data-index": 204
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M164.3 737c.2 0 .5.2 1 .7-.3 0-.6-.2-1-.6Z",
    "data-index": 205,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M154.2 722.6c.3 0 .6.1 1 .6-.2 0-.6-.1-1-.6Z",
    "data-index": 206,
    style: {
      visibility: "visible"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M377.2 469.5c.2 0 .6.1 1 .6-.2.1-.6 0-1-.6Z",
    "data-index": 207
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M894.8 675.1c-.4.1-.7 0-.9-.3 0 0 .2-.3.6-.5.3.1.4.3.3.8Z",
    "data-index": 208,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F83BD",
    d: "M890.2 669.6c-.2 0-.6-.1-1.1-.6.2-.1.6.1 1.1.6Z",
    "data-index": 209,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F83BD",
    d: "M889 668.5c-.3 0-.6-.2-1-.7.2 0 .5.2 1 .7Z",
    "data-index": 210,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M148.4 615.3c0 .2-.2.5-.7 1 0-.3.2-.6.7-1Z",
    "data-index": 211,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M149.5 614.2c0 .2-.2.5-.6 1-.1-.3 0-.6.6-1Z",
    "data-index": 212,
    style: {
      visibility: "visible"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB487",
    d: "M313.7 612.7c-.3 0-.6-.1-1-.6.3 0 .6 0 1 .6Z",
    "data-index": 213
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M803.3 434.2c-.3.1-.7 0-1.2-.6.3-.1.7.1 1.2.6Z",
    "data-index": 214
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#9488C7",
    d: "M341.2 637.3c.1.2 0 .6-.5 1.2-.2-.2 0-.6.5-1.2Z",
    "data-index": 215
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M806.5 437.6c-.2.1-.6 0-1-.6.2-.1.6.1 1 .6Z",
    "data-index": 216
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M805.4 436.5c-.2 0-.6-.1-1-.7.2 0 .6.2 1 .7Z",
    "data-index": 217
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#111118",
    d: "M804.3 435.4c-.2 0-.6-.2-1-.7.2-.1.6.1 1 .7Z",
    "data-index": 218
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M780 1466.8c-.7.3-1 .5-1.3 1-12.6 3-25 6-37.5 8.4a1318.5 1318.5 0 0 1-87.5 12.8c-9.3 1.1-18.7 2-28.1 2.5-25 1.2-49.9 2.5-74.8 3.3-15 .5-30 .2-45 .3-3 0-6.2.9-9.3.8-21.3-.2-42.6-.2-64-1.2a1136.3 1136.3 0 0 1-187.5-23.4c-1.8-.4-3.5-1.1-5.6-2.4-.4-2.2-.5-3.7-.5-5.3l.3-.2c2-10.9 3.6-21.5 5.3-32l.3-.3a513 513 0 0 0 3.7-18.7c2.4-13.8 5-27.6 7.2-41.4a2385 2385 0 0 0 13.4-96.2c1-8.5 1.6-17 2.4-25.3 1.8-17.5 4.2-34.8 5.2-52.3a389 389 0 0 0-4.2-72.3c-2.2-18-3.8-36-5.8-53.9 0-1-1.4-2-2.2-3v-2.4c-.3-2.4-.7-3.8-.9-5.2-3-24.4-5.7-48.8-9.2-73.1-3.6-25-5.7-50.2-5.6-75.6.2-23 3.3-45.7 9.7-67.8 1-3.8.7-6.3-4-6.9a6 6 0 0 1 1.3-2.9c1.5.1 3-.1 4.4-.4v.4c1.5 2.4 3 4.4 4.5 6.3v.4c.7 1.2 1.5 2.1 2.2 3v.4c1 2 2.2 3.5 3.4 5.1l-.1.4c.8 1.3 1.6 2.1 2.4 3 .3.1.6.4.6 1 0 .7.2 1 .4 1.2v.4l1.1 1.9v.3c.7 1.3 1.5 2.1 2.3 3v.3c.3.9.7 1.4 1 2v.3c1.5 2.8 3 5 4.5 7.4v.4c1.1 2 2.2 3.6 3.4 5.2v.4l1 3 .1.2 1.1.9v.4c1.8 3.4 3.7 6.5 5.6 9.6v.4a858 858 0 0 0 11.1 19.6v.5l4.5 8.5v.3l1.1.8v.4c1 2.3 2.2 4.3 3.3 6.3l.1.3 1 .8v.4c1.1 2.3 2.3 4.3 3.4 6.3v.3l1.1 2v.3l1.1 1.8v.4c1.5 2.4 3 4.4 4.5 6.3v.4c.3.8.7 1.4 1.1 1.9v.4c.7 1.6 1.5 2.8 2.2 4v.3l1 .9.2.9c.4.8.7 1 1 1.3v.3c.4.9.8 1.4 1.2 2v.3c1.4 2.7 3 5 4.4 7.4v.3c.4.9.8 1.4 1.2 2l-.1.3a210 210 0 0 0 5.6 9.6v.5c1.1 2.3 2.2 4.3 3.4 6.3 0 0-.1 0 0 .2l1 .9v.4l4.5 8.5v.4l10 17.4v.4l3.4 5.2v.3l1.1.8v.4l1.2 1.9-.1.4c1.1 2 2.3 3.5 3.4 5.1v.4c1.4 2.7 3 5 4.5 7.4l-.1.5 10 19.6.1.3 1.1.8v.4c1 2 2.2 3.6 3.4 5.2l-.1.4c1.5 2.7 3 5 4.5 7.4v.4c2.6 4.6 5.2 8.8 7.8 13v.4l7.8 13v.3a38 38 0 0 0 2.2 4l.1.4 1 .8v.4c1.1 2 2.3 3.6 3.4 5.2v.4c1.8 3 3.7 5.8 5.6 8.4 8.4 14.3 16.8 28.6 25.4 43.6a20 20 0 0 0 2.5 3.3s-.1 0 0 .4c.7 1.2 1.4 2 2.2 3v.3l1.1.8v.4c1.4 2.3 3 4.3 4.5 6.3l-.1.4 2.3 3v.3c.7 1.3 1.5 2.1 2.2 3v.3l1.1 1.9v.3l1.1.8.1.3 1 .8v.4a21 21 0 0 0 2.3 3v.3c.3.9.7 1.4 1.1 2v.3c.8.8 1.5 1.3 2.2 1.8v.4l1.1 1.9.1.3 1 .8v.3c.8.9 1.6 1.4 2.3 1.9v.4c.3.8.7 1.3 1.1 1.8v.2a2 2 0 0 0 1.1-.2c6.8 8.2 13.5 16.5 20.4 24.6 2.9 3.3 6.2 6.2 9.3 9.8.6.8 1.1 1 1.7 1.3.3 0 .5.2.8 1.1 2 2.3 3.9 4 5.7 5.6l.2.3c.9.5 1.6.6 2.3.8.3 0 .5.2.8 1 .5.7.9 1 1.2 1.3v.3c1.5 1.6 3 2.8 4.4 4.1l.2.3 2 .8v.4c1.2 1.2 2.3 2 3.4 3l.1.2c.4.5.7.7 1 .9l.1.3 4.4 3 .1.4 5.5 3s-.1 0 0 .4c1.1.8 2.2 1.3 3.3 1.8v.3l1.1.8.1.4c1.8 1.5 3.2 3 5 3.9a88 88 0 0 0 34.5 10.6 114 114 0 0 0 42-3.4c3.1-.9 5.8-3.2 8.6-4.9l.4.1 1.9-1.2.4.1c2-1.1 3.5-2.3 5.1-3.4h.4c1.3-.7 2.1-1.5 3-2.3l.4.1c1.2-.7 2-1.5 3-2.3l.3.1c1.6-.7 2.8-1.5 4-2.3h.4c.9-.8 1.4-1.5 1.9-2.2h.4c2-1.5 3.6-3 5.2-4.5h.3c.9-.4 1.4-.9 2-1.3 4.7-4.3 9.5-8.7 15-13.1 1-.5 1.3-.8 1.6-1.2h.3l.8-1 .3-.1.9-1.1.3-.1.8-1.3c0-.3.2-.5 1-.8.7-.5 1-.8 1.2-1.2h.3l.8-1.3c1.2-1.3 2.4-2.6 4.2-4.1.9-.6 1.1-1 1.4-1.2h.3l.8-1.2h.3l.8-1 .3-.2c.5-.6.7-1 .8-1.5.2-.4.4-1 1.3-1.5 4.6-1.3 7.6-3.3 7.6-8l.3-.1c.6-.4.8-.6.8-1l.3-.1c.6-.3.8-.6.8-1h.4c1.3-1.6 2.1-3 3-4.5l-.1-.1 8-2c-.5 1.7-.7 2.8-1.3 3.7-.5.7-1.8.8-2.3 1.4-1.9 2.6-5.5 6.3-4.8 7.7 1.7 3.3 5.3 6 10.1 4.5l-1.7-7.7 1.3-.6c.9 1 1.6 2.2 2.7 3 1.4 1.2 2.9 3 4.5 3 4 .3 8-.4 12-.4.8 0 1.7 1 3.6 2l-6.9 1.8-1.1 5.9-11.1-4v12.3l1 .5 3.4-8 8.5 7.8c1.8 0 .7-8.6 6.2-4.1-1.6 3.4-3.3 6.6-4.4 10-.4 1.3.8 3.2 1.2 4.8 1.8-.5 3.8-.8 5.2-1.8.8-.6.5-2.6.6-4 0-1.1-.7-2.8-.2-3.3 4.2-4.8 1.4-8.5-2.2-13 4-.6 8.3-4.6 7.2 3.7 0 .7 2.2 2 3.5 2.5 2 1 4 1.5 6.1 2.2-.8 2.4-1.8 4-1.8 5.8.1 7.2 2 8.6 9.3 7.3.6-.1 1.4-.7 1.6-.5 9.1 7.3 13-5 20-5.4 3.7-.2 7.4-1.2 11.1-1.7.2 0 .5.8.8 1.3-7.1 3.2-7.1 3.2-3.5 11.7l6.3-1.7 1.2 1-4.5 9.5 8.1 5.2c0-5 .5-9.8-.1-14.5-.5-4.4 4-10.3-1.9-12.3 0-3.1-.6-5.6.1-7.6 2-5.5 1.5-10.5-.4-15.9-.7-2.1 2.6-3.6 5.8-2.2-.1 31.8 4 63 10.4 94 4.7 22.5 10.7 44.8 16.4 67.5 2.1 7.1 3.7 14 5.7 21 3.6 12.5 7.5 25 11.3 37.8-1 1-2 1.5-3.1 2.4l-2.2 1.2c-7.5 3.4-14.7 6.5-22.2 10-5.4 2.3-10.5 4.3-15.7 6.6-6.3 2.1-12.5 3.9-18.6 5.7l-14.6 4.5Z",
    "data-index": 219,
    style: {
      opacity: 1,
      visibility: "visible"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F83BD",
    d: "M689.3 828.2s-.1.5-.5.8c-2 3-3.5 5.5-5 8l-1.5 3.1-.8 2.5-.4.2a67.6 67.6 0 0 0-3 6.5l-.2.2c-.5.4-.7.7-.9 1l-3.2 4.5c-.6 1.9-1 3-1.2 4.3l-.3.2-2 2.1-1.3 3-.9 2.5-.3.3c-.4.7-.6 1.4-.8 2l-.3.1-1.9 2.2-1.4 3c-1.7 3.4-3 6.3-4.2 9.2l-.2.1c-.6.3-.8.6-.9 1l-.3.2c-1.6 3-2.9 5.9-4.2 8.7l-.3.2c-4.3 7.5-8.1 14.8-12 22.1l-1.3 2.2c-3.5 6.8-6.8 13-9.7 19.3-2.9 6-5.3 12.4-7.9 18.6l-.3.2c-2.4 4.5-4.4 8.9-6.4 13.2l-.3.2c-2 3.4-3.6 6.6-5.2 9.8l-.3.3c-2 4.2-3.8 8-5.5 12l-1.2 2.2c-.9 2.2-1.4 4-2 5.7l-.3.2-3.6-2.3c2.5-7.2 4.9-14.6 8.2-21.5 8-16.7 16-33.4 24.8-49.7 23.5-44 46.4-88.2 71.5-131.2 15-25.4 33.5-48.7 50.5-73 .3-.4.9-.6 1.4-1 3.3 1.3 4.1 2.6 1.6 6a885.4 885.4 0 0 0-21.4 30c0 .4 0 .5-.4.7l-24.1 35.5-.3.2c-.5.8-.6 1.4-.8 2l-.4.2a388.4 388.4 0 0 0-10 15.3l-5.2 12.3h-.4l-1.8 1.3c-.3.5-.7 1-1 2.2l-.2 1.1Z",
    "data-index": 220
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M233.7 557.7c3.3-1.4 5.9-.4 8.7 2 12.8 11.2 26.3 21.6 38.8 33 7.7 7.2 14.2 15.7 21.1 23.6 2.7 3 5.2 6.3 7.9 9.8-2.7 5.1-4.5 1.4-6.3-.6-9.6-10.7-18.4-22.2-28.8-32.2-11.3-10.9-23.9-20.4-36-30.5a80.5 80.5 0 0 1-5.4-5.1Z",
    "data-index": 221
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA914F",
    d: "M585.6 1022.4c18.2 20.4 36.1 41 49.2 65.2l-1.3 1.6c-1.6-1-3.6-1.8-4.7-3.2-10.6-14.5-21-29.1-31.8-43.5-4-5.5-9-10.4-13.6-16.2.7-1.7 1.4-2.8 2.2-4Z",
    "data-index": 222,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M635.4 1274.1c-2.4 1.6-5.1 4-8.2 4.8a114 114 0 0 1-42 3.4c-12.5-1-23.7-5-34.5-10.6-1.8-1-3.2-2.4-5-4 3.2 1.2 6.6 2.6 9.8 4.4 17.5 9.8 36.5 9.9 55.5 8.1 8.1-.7 16-4 24.4-6.1Z",
    "data-index": 223,
    style: {
      visibility: "visible"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M327 653.7c.2-.5.4-.5 1-.5a1377 1377 0 0 1 7.8 39.5c.3 1.8-.1 3.7-.5 5.8-3-14.6-5.7-29.5-8.3-44.8Z",
    "data-index": 224
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M335.8 702.9c1 3.2 2.4 6.8 3.3 10.5 2 9 3.8 18 5.7 27.5-1.3-2.9-3.3-6-4-9.5-2-9.3-3.4-18.7-5-28.5Z",
    "data-index": 225
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "m181.8 541.3 2.7-4.7c.6 1.7 1.8 3.5 1.6 5a19 19 0 0 1-3 7.2c-.6.9-2.4 1-3.6 1.4 0-1.2-.4-2.4-.1-3.5.5-1.8 1.5-3.4 2.4-5.4Z",
    "data-index": 226,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M756.3 1084.6c1.5.4 3 .8 5.1 1.6l12.6 7.4-.2.3c-7.3-3.2-14.6-6.3-22-9.8-.2-.4 0-.6.4-.6l4 1.1Z",
    "data-index": 227,
    style: {
      visibility: "visible"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M304.8 910.2Z",
    "data-index": 228
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M385.1 1055.2c-3.4-6-6.7-12.4-10-19.3 3.3 6 6.7 12.4 10 19.3Z",
    "data-index": 229,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M361.7 1012.8a287 287 0 0 1-10-17 284 284 0 0 1 10 17Z",
    "data-index": 230,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M716.2 1067.2c2.2.3 4.5 1 7.5 2l8 5.4-.1.2c-5-2.4-10.2-4.8-15.4-7.6Z",
    "data-index": 231,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M780.9 1097.3c3.5-.5 5.1.8 3 4.4a69.2 69.2 0 0 1-5 7.3c.6-2 1.8-4 2.4-6.3.4-1.6-.1-3.4-.4-5.5Z",
    "data-index": 232,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M401.7 1083a214.6 214.6 0 0 1 0 .1Z",
    "data-index": 233,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M409.6 1096.4c-2.6-3.8-5.2-8-7.8-12.6 2.6 3.8 5.1 8 7.8 12.6Z",
    "data-index": 234,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "m585.6 1022-2.4 4a24.6 24.6 0 0 1-4.2-4.5c3.8 1.8 5-2.2 7.5-3.7 0 1.2-.4 2.5-.9 4.2Z",
    "data-index": 235,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M590.6 1009.9c1.6-4 3.6-8 6-12.2-1.7 4-3.7 8-6 12.2Z",
    "data-index": 236,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M620.2 1013.3c.7.9 1.4 1.8 2.1 3a103 103 0 0 1-10-7c.6-.4 1-.5 2.1-.2l5.8 4.2Z",
    "data-index": 237,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M696 1055.6a29 29 0 0 1 2.1 2 98 98 0 0 1-11-4.9c.8-.4 1.7-.4 3.1 0a311 311 0 0 0 5.9 3Z",
    "data-index": 238,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "M705.6 1215.1c.4 4.6-2.6 6.7-7 7.7 2-2.5 4.3-5 7-7.7Z",
    "data-index": 239,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M778.1 1109.1a61.2 61.2 0 0 1-4.8 8.8c1.2-2.8 2.8-5.8 4.8-8.8Z",
    "data-index": 240,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M342.7 978.3a97.1 97.1 0 0 1-5.6-9.3 95 95 0 0 1 5.6 9.3Z",
    "data-index": 241,
    style: {
      visibility: "visible"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M293.6 890.2a96.2 96.2 0 0 1-5.5-9.3c1.8 2.7 3.7 5.8 5.5 9.3Z",
    "data-index": 242
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M260.3 833.3c-1.5.7-3 1-4.2.6l.8-5.8.4-.3c1 1.7 2 3.4 3 5.5Z",
    "data-index": 243
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M745.8 1161.6c.4.7.4 1.6 0 3-1.1 2-2 3.4-3 4.7-.8.8-1.7 1.5-3 2.2a109 109 0 0 1 6-9.9Z",
    "data-index": 244,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M421.8 1116.5a71 71 0 0 1-5.5-8.1c1.8 2.3 3.6 5 5.5 8Z",
    "data-index": 245,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M648.2 1032.6c1-.3 2.2-.4 4 0a35 35 0 0 1 4.8 4.2l-.3.3-8.5-4.5Z",
    "data-index": 246,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M640.3 1026.6c1.8 1.3 3.7 2.6 5.5 4.2a55 55 0 0 1-8.8-4.7c-.2-.4 0-.6.3-.6l3 1.1Z",
    "data-index": 247,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M351.7 995c-1.6-2.3-3-5-4.6-8.2 1.6 2.3 3.1 5 4.6 8.2Z",
    "data-index": 248,
    style: {
      visibility: "visible"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M309.3 919.2c-1.5-2.3-3-5-4.5-8.2 1.5 2.3 3 5 4.5 8.2Z",
    "data-index": 249
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M700.5 1059.4c1.5 0 3.1.3 5.3 1a29 29 0 0 1 3.6 3.1l-.3.3a70 70 0 0 1-8.6-4.4Z",
    "data-index": 250,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M394 1069.7c-1.5-2-3-4.3-4.5-7 1.5 1.9 3 4.2 4.5 7Z",
    "data-index": 251,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M336 966a60 60 0 0 1-4.5-7c1.5 2 3 4.3 4.5 7Z",
    "data-index": 252,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M515.5 1243.6c-1.8-1.3-3.7-3-5.6-5a32 32 0 0 1 5.6 5Z",
    "data-index": 253,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M324.9 946a39 39 0 0 1-4.5-6 39 39 0 0 1 4.5 6Z",
    "data-index": 254,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M739.6 1078.4c.4-.4.9-.5 2-.2l6.8 4.2v.1c-3-1.2-5.8-2.5-8.8-4.1Z",
    "data-index": 255,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M777.4 1093.5c1.1 1 2.2 1.8 3.3 3.1-2.1-.5-4.2-1.3-6.7-2.4-.2-.3 0-.5.4-.6h3Z",
    "data-index": 256,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M375 1035.2a63 63 0 0 1-4.4-7.1c1.4 2 3 4.3 4.4 7Z",
    "data-index": 257,
    style: {
      visibility: "visible"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M282.5 870.1c-1.5-2-3-4.2-4.5-7 1.5 2 3 4.3 4.5 7Z",
    "data-index": 258
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M214.6 542.9c2.3 1 4.4 2.6 6.8 4.4a45 45 0 0 1-6.8-4.4Z",
    "data-index": 259
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M264.6 840a43 43 0 0 1-4.4-6c1.5 1.7 3 3.7 4.4 6Z",
    "data-index": 260
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M457.5 1174.5a43 43 0 0 1-4.4-6 42 42 0 0 1 4.4 6Z",
    "data-index": 261,
    style: {
      visibility: "visible"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M313.8 927a33.3 33.3 0 0 1-3.4-6 40 40 0 0 1 3.4 6Z",
    "data-index": 262
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M662.2 1256.4a35.7 35.7 0 0 1-4.8 4.3c1.2-1.4 2.9-2.8 4.8-4.3Z",
    "data-index": 263,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "m711.7 1063.4 4.3 3.1c-2-.5-4.2-1.3-6.6-2.4-.3-.3-.1-.5.3-.6h2Z",
    "data-index": 264,
    style: {
      visibility: "visible"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M318.2 934.8a34.5 34.5 0 0 1-3.4-6c1.2 1.6 2.3 3.6 3.4 6Z",
    "data-index": 265
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M665 1041.5c1.4 0 3 .3 5.1 1 .8.9 1.1 1.4 1.4 2l-.3.3-6.3-3.3Z",
    "data-index": 266,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M643.2 1269.7c-1.2 1-2.8 2.2-4.8 3.3 1.2-1.1 2.9-2.2 4.8-3.3Z",
    "data-index": 267,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M365 1018.4a23.7 23.7 0 0 1-3.3-4.8c1.1 1.2 2.3 2.8 3.4 4.8Z",
    "data-index": 268,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M772.5 1118c-.5 1.8-1.3 3.5-2.6 5.5a21 21 0 0 1 2.6-5.5Z",
    "data-index": 269,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M764.8 1130.4c-.5 1.7-1.4 3.5-2.7 5.4.6-1.7 1.5-3.5 2.7-5.4Z",
    "data-index": 270,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M748.4 1161.5h-1.9c.5-1.8 1.4-3.5 2.7-5.4.3-.2.4-.1.4.3l-1.2 5.1Z",
    "data-index": 271,
    style: {
      visibility: "visible"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M241.3 803.6c1.1 1.5 2.3 3 3.4 5 0 .4-.2.7-.5.5a53.6 53.6 0 0 1-3-5.5Z",
    "data-index": 272
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M389.5 1061.9c-1-1.2-2.2-2.8-3.3-4.8 1 1.2 2.2 2.8 3.3 4.8Z",
    "data-index": 273,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M370.6 1027.3a24.9 24.9 0 0 1-3.4-4.8c1.1 1.2 2.2 2.8 3.4 4.8Z",
    "data-index": 274,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M197.9 531.9c1.3.2 2.7.7 4.5 1.3.4 0 .6 0 .5.1.1.6.4 1 .6 1.5l-.2.2c-1.8-1-3.5-1.8-5.4-3.1Z",
    "data-index": 275,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M346.1 985a34.3 34.3 0 0 1-3.4-6c1.2 1.6 2.3 3.6 3.4 6Z",
    "data-index": 276,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M673.8 1044.5c1.3.9 2.7 1.8 4.2 3-2-.4-4-1.3-6.5-2.4-.3-.3-.1-.5.3-.5l2-.1Z",
    "data-index": 277,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M524.5 1251.4a21 21 0 0 1-4.5-3.7c1.5.8 3 2 4.5 3.7Z",
    "data-index": 278,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M416.3 1107.6a27 27 0 0 1-3.4-4.8c1.1 1.2 2.2 2.8 3.4 4.8Z",
    "data-index": 279,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M541 1263.7c-1.6-.5-3.4-1.4-5.3-2.7 1.6.6 3.4 1.5 5.3 2.7Z",
    "data-index": 280,
    style: {
      visibility: "visible"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M285.8 875.7c-1-1.2-2.2-2.8-3.3-4.8 1 1.2 2.2 2.8 3.3 4.8Z",
    "data-index": 281
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M605.9 1004.7c1.3.5 2.8 1.4 4.2 2.7a21 21 0 0 1-4.2-2.7Z",
    "data-index": 282,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "M711.2 1208.4c-.5 1.4-1.3 2.8-2.6 4.3.5-1.4 1.4-2.8 2.6-4.3Z",
    "data-index": 283,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M769.2 1123.6c-.5 1.4-1.4 3-2.6 4.4.5-1.4 1.4-3 2.6-4.4Z",
    "data-index": 284,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M758.1 1141.6a26 26 0 0 1-2.7 5.3c.6-1.6 1.5-3.4 2.7-5.3Z",
    "data-index": 285,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M535.6 1260.3c-1.4-.5-2.8-1.4-4.4-2.6a15 15 0 0 1 4.4 2.6Z",
    "data-index": 286,
    style: {
      visibility: "visible"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M270.2 849a27.2 27.2 0 0 1-3.3-4.9c1 1.2 2.2 2.9 3.3 4.9Z",
    "data-index": 287
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M251.7 818.9c1 1.3 2 2.6 3 4.4 0 .4-.1.4-.5.4a21 21 0 0 1-2.9-4.5l.4-.3Z",
    "data-index": 288
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M754.8 1147.2c-.2 1.2-.7 2.7-1.6 4.2.2-1.3.7-2.7 1.5-4.2Z",
    "data-index": 289,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M530 1255.8a9.8 9.8 0 0 1-3.3-2.5c1 .4 2.2 1.3 3.3 2.5Z",
    "data-index": 290,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M328.2 952.7a16 16 0 0 1-2.2-3.8 16 16 0 0 1 2.2 3.8Z",
    "data-index": 291,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M411.9 1101c-.8-1-1.6-2.2-2.3-3.8.8.8 1.6 2.1 2.3 3.7Z",
    "data-index": 292,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M654.4 1262.9c-.9.8-2 1.6-3.7 2.3.8-.8 2-1.6 3.7-2.3Z",
    "data-index": 293,
    style: {
      visibility: "visible"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M254.7 823.6c.8 1.2 1.6 2.3 2.5 3.9.1.3-.2.5-.6.4-1-1.4-1.5-2.8-2-4.2h.1Z",
    "data-index": 294
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M247 811.3c.7 1.2 1.5 2.3 2.2 4 0 .4-.2.7-.6.5-.8-1.6-1.3-3-1.8-4.4h.1Z",
    "data-index": 295
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M344.8 741.6a8 8 0 0 1 2.3 2.7 8.5 8.5 0 0 1-2.3-2.7Z",
    "data-index": 296
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M347 745c.8.5 1.6 1.3 2.3 2.6a8.5 8.5 0 0 1-2.2-2.6Z",
    "data-index": 297
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M349.3 748.3c.7.5 1.5 1.4 2.2 2.6a8.8 8.8 0 0 1-2.2-2.6Z",
    "data-index": 298
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M249.3 815.6a17 17 0 0 1 2.3 3c.1.3-.1.5-.6.4-1-1-1.5-2-2-3l.3-.4Z",
    "data-index": 299
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M633.6 1023.7c.5-.4 1-.4 2-.1.8.8 1 1.4 1.4 2l-.3.3c-1.1-.6-2.1-1.2-3.1-2.2Z",
    "data-index": 300,
    style: {
      visibility: "visible"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M276.9 860.1a8.8 8.8 0 0 1-2.2-2.6c.7.5 1.4 1.4 2.2 2.6Z",
    "data-index": 301
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M272.5 852.3a9.3 9.3 0 0 1-2.3-2.6c.8.5 1.5 1.4 2.3 2.6Z",
    "data-index": 302
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M544.4 1266a8 8 0 0 1-3.2-1.6c1 .1 2 .7 3.2 1.6Z",
    "data-index": 303,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M752.5 1151.4c.1 1-.2 1.9-.8 3.1-.6.4-.8.4-1 .3l-.4-.3c.6-1 1.2-2 2.2-3Z",
    "data-index": 304,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M449.8 1163.3a7.7 7.7 0 0 1-2.3-2.5c.8.4 1.6 1.3 2.3 2.5Z",
    "data-index": 305,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M452 1166.7a7.7 7.7 0 0 1-2.3-2.6c.8.5 1.6 1.3 2.3 2.6Z",
    "data-index": 306,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M738 1173.8a9 9 0 0 1-1.5 3.2c.1-1 .6-2 1.5-3.2Z",
    "data-index": 307,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M459.7 1177.9a8.3 8.3 0 0 1-2.2-2.7 7 7 0 0 1 2.2 2.7Z",
    "data-index": 308,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M462 1181.2a8.3 8.3 0 0 1-2.3-2.6c.8.5 1.5 1.4 2.3 2.6Z",
    "data-index": 309,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M467.6 1189a8.6 8.6 0 0 1-2.3-2.6c.8.5 1.5 1.4 2.3 2.6Z",
    "data-index": 310,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M736.2 1075.6v1c-1.4-.2-2.8-.8-4.4-1.6-.2-.2-.1-.3.3-.4l4.1 1Z",
    "data-index": 311,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M650 1265.2a8 8 0 0 1-2.7 2.2 9 9 0 0 1 2.7-2.2Z",
    "data-index": 312,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M646.6 1267.4c-.5.7-1.3 1.5-2.6 2.3.5-.8 1.4-1.5 2.6-2.3Z",
    "data-index": 313,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M761.5 1136a8 8 0 0 1-1.6 3.2c.1-1 .7-2 1.6-3.2Z",
    "data-index": 314,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M475.3 1199c-.6-.1-1.4-.6-2.1-1.5.7.2 1.4.7 2.1 1.5Z",
    "data-index": 315,
    style: {
      visibility: "visible"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M244.8 808.9c.7.5 1.3 1.1 2 2.1.1.3 0 .4-.3.4-1-.7-1.5-1.4-2-2.1l.3-.4Z",
    "data-index": 316
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M266.9 843.4a9.3 9.3 0 0 1-2.2-2.6c.7.5 1.4 1.4 2.2 2.6Z",
    "data-index": 317
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M656.6 1260.8c-.1.6-.6 1.4-1.5 2.1.2-.7.7-1.4 1.5-2.2Z",
    "data-index": 318,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "m603.6 1001-.1 1a6 6 0 0 1-2.4-1.6c-.2-.3 0-.4.4-.4 1 .3 1.6.6 2.1 1Z",
    "data-index": 319,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M470.9 1193.5c-.7-.2-1.4-.7-2.2-1.5.7 0 1.4.6 2.2 1.5Z",
    "data-index": 320,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M735.7 1177c.4.3.5.5.3 1.2-.8.8-1.4 1-2 1.1h-.1c.5-.8 1-1.5 1.8-2.3Z",
    "data-index": 321,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "m205.3 535.2 1.5 1.5a9 9 0 0 1-3.4-1.4c-.1-.3 0-.5.4-.5l1.6.4h-.1Z",
    "data-index": 322,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M206.8 537.3c.8 0 1.5.4 2.4 1-.7 0-1.6-.3-2.4-1Z",
    "data-index": 323,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M209.5 539.2c1 .2 1.9.7 3 1.5a7 7 0 0 1-3-1.5Z",
    "data-index": 324,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M194.5 529.2c1 .3 2 1 3.2 2-1-.3-2-1-3.2-2Z",
    "data-index": 325,
    style: {
      visibility: "visible"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M352.6 752.8c.6.2 1.2.8 1.5 1.6-.7-.3-1-.8-1.5-1.6Z",
    "data-index": 326
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M572.4 1014.7c.5 0 1.2.1 2 .6-.5 0-1.1 0-2-.6Z",
    "data-index": 327,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M588.3 1015.3c-.2-.7 0-1.7.5-3 .1.8 0 1.8-.5 3Z",
    "data-index": 328,
    style: {
      visibility: "visible"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M287 879a7 7 0 0 1-1.2-2.6c.5.5.9 1.4 1.3 2.7Z",
    "data-index": 329
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M751.5 1083.9c-1-.3-1.8-.5-3-1.1-.1-.3-.1-.3.3-.4 1.3.3 2.1.7 3 1l-.3.5Z",
    "data-index": 330,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M736.4 1077.2c.7-.2 1.7 0 2.9.5a6 6 0 0 1-3-.5Z",
    "data-index": 331,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M622.6 1017c.4-.2 1 0 2 .5-.6.1-1.2 0-2-.5Z",
    "data-index": 332,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M574.4 1015.9c.5.1.8.7 1.2 1.6-.4-.2-.9-.7-1.2-1.6Z",
    "data-index": 333,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M587.1 1017.6c0-.5.1-1.1.6-2 .1.5 0 1.2-.6 2Z",
    "data-index": 334,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M468.8 1191.3c-.5-.2-.9-.7-1.2-1.6.4.2.8.7 1.1 1.6Z",
    "data-index": 335,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M624.8 1018.1c.5-.1 1.1 0 2 .5-.6.2-1.2 0-2-.5Z",
    "data-index": 336,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M331.6 958.3c-.4-.2-.8-.7-1.2-1.6.4.2.8.7 1.2 1.6Z",
    "data-index": 337,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M337.1 968.3c-.3-.2-.7-.7-1-1.6.3.2.6.7 1 1.6Z",
    "data-index": 338,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M589.4 1012c-.1-.4 0-1 .5-1.9.2.5 0 1.2-.5 2Z",
    "data-index": 339,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M646 1031.4a4 4 0 0 1 2 .6c-.5.1-1.2-.1-2-.6Z",
    "data-index": 340,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M476.6 1201.3c-.5-.2-.9-.7-1.2-1.6.4.2.8.7 1.2 1.6Z",
    "data-index": 341,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M610.3 1008a4 4 0 0 1 2 .6c-.5 0-1.2 0-2-.6Z",
    "data-index": 342,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M472.1 1195.7c-.4-.2-.8-.7-1.2-1.6.4.2.9.7 1.2 1.6Z",
    "data-index": 343,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M698.4 1058.3c.5-.2 1.1 0 2 .5-.6 0-1.3 0-2-.5Z",
    "data-index": 344,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M766 1128.2a4 4 0 0 1-.6 2c-.1-.5.1-1.2.6-2Z",
    "data-index": 345,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M739.2 1171.7c.1.4 0 1-.5 1.9-.2-.5 0-1.1.5-2Z",
    "data-index": 346,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M732.9 1181.7v-1c0-.7.2-1 .7-1.3.3-.1.3 0 .3.3-.3 1-.7 1.5-1 2Z",
    "data-index": 347,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M367.3 1021.8c-.4-.2-.8-.7-1.2-1.6.4.2.8.8 1.2 1.6Z",
    "data-index": 348,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M629.3 1021.4c.4-.1 1 0 1.9.6-.5 0-1.1 0-2-.6Z",
    "data-index": 349,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M631.5 1022.6c.5-.2 1.1 0 2 .5-.6.1-1.2 0-2-.5Z",
    "data-index": 350,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M463.2 1183.5c-.5-.2-.8-.8-1.2-1.6.4.2.8.7 1.2 1.5Z",
    "data-index": 351,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "m658.1 1036.6 1 1c-.5.2-1.2 0-2.1-.3-.3-.2-.1-.5.2-.5l1-.2Z",
    "data-index": 352,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M659.3 1038.2c.6-.2 1.2 0 2 .5-.5.1-1.2 0-2-.5Z",
    "data-index": 353,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M662.7 1040.4c.5-.2 1.1 0 2 .5-.5.1-1.2 0-2-.5Z",
    "data-index": 354,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M678.3 1048.2c.5-.1 1.1 0 2 .5-.5.1-1.2 0-2-.5Z",
    "data-index": 355,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M680.5 1049.3c.5-.1 1.2 0 2 .5-.5.2-1.2 0-2-.5Z",
    "data-index": 356,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M682.8 1050.5c.5-.2 1.1 0 2 .5-.6 0-1.2 0-2-.5Z",
    "data-index": 357,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M685 1051.6c.5-.2 1.1 0 2 .5-.6.1-1.2 0-2-.5Z",
    "data-index": 358,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M517.7 1244.8c-.4.1-1.1 0-2-.5.5-.1 1.1 0 2 .5Z",
    "data-index": 359,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M526.5 1252.6c-.5.1-1.1 0-2-.5.6-.2 1.2 0 2 .5Z",
    "data-index": 360,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M664.5 1255c-.2.3-.7.8-1.6 1.3.2-.5.7-.8 1.6-1.3Z",
    "data-index": 361,
    style: {
      visibility: "visible"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M212.8 541.5c.6-.1 1.1.2 1.8.8-.5 0-1.2-.2-1.8-.8Z",
    "data-index": 362
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M637.7 1273c-.2.3-.7.7-1.6 1 .2-.3.8-.7 1.6-1Z",
    "data-index": 363,
    style: {
      visibility: "visible"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M278 862.4c-.3-.2-.7-.7-1-1.6.3.2.6.7 1 1.6Z",
    "data-index": 364
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M274.7 856.8c-.4-.2-.7-.7-1.1-1.6.4.2.7.7 1.1 1.6Z",
    "data-index": 365
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M319.4 937c-.5-.1-.8-.6-1.2-1.5.4.2.8.7 1.2 1.6Z",
    "data-index": 366
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M326 948.2c-.4-.1-.8-.7-1.1-1.6.3.2.7.8 1 1.6Z",
    "data-index": 367,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M320.5 939.3c-.4-.2-.8-.7-1.2-1.6.4.2.8.7 1.2 1.6Z",
    "data-index": 368,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M508.8 1237a2 2 0 0 1-1.3-.7c.5.1.8.3 1.3.8Z",
    "data-index": 369,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M758.5 1140.7c.3 0 .5.1.6.3l-.5.4c-.2 0-.2-.5 0-.7Z",
    "data-index": 370,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M749.5 1155.9c0-.4.2-.8.6-1.2.2-.2.4 0 .4.3-.2.7-.5.9-1 1v-.1Z",
    "data-index": 371,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M683.5 1238.5c0 .2-.1.5-.6 1 0-.3.1-.6.6-1Z",
    "data-index": 372,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M684.6 1237.2c0 .2-.1.6-.6 1.1 0-.2.1-.6.6-1.1Z",
    "data-index": 373,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M473.1 1196.9c-.3 0-.6-.1-1-.6.3-.1.6 0 1 .6Z",
    "data-index": 374,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M686.8 1235.2c0 .2-.2.5-.8 1 0-.3.3-.6.8-1Z",
    "data-index": 375,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M688 1233.9c0 .2-.2.5-.6 1-.1-.2.1-.5.6-1Z",
    "data-index": 376,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M693.5 1228.5c0 .2-.2.5-.8 1 0-.3.2-.6.8-1Z",
    "data-index": 377,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M694.6 1227.3c.1.3 0 .6-.6 1 0-.2.2-.5.6-1Z",
    "data-index": 378,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M477.3 1201.5c0 .2-.3.4-.7.3 0-.3.3-.3.7-.3Z",
    "data-index": 379,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M682.4 1239.6c0 .2-.2.5-.6 1-.1-.3 0-.6.6-1Z",
    "data-index": 380,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M695.7 1226.2c.1.3 0 .6-.6 1 0-.2.2-.6.6-1Z",
    "data-index": 381,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M696.9 1224.7c0 .3-.1.7-.6 1.3-.1-.2 0-.6.6-1.3Z",
    "data-index": 382,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "M708 1212.8c.2.4 0 .7-.6 1 0-.3 0-.6.5-1Z",
    "data-index": 383,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "M706.8 1214c.3.3 0 .5-.5.9 0-.3 0-.6.5-1Z",
    "data-index": 384,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M531.1 1257c-.3.2-.6 0-1-.5.3 0 .6 0 1 .5Z",
    "data-index": 385,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M545.6 1267.1c-.3.1-.6 0-1-.6.2 0 .6.1 1 .6Z",
    "data-index": 386,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M453 1167.9c-.2 0-.5-.1-1-.6.3 0 .6.1 1 .6Z",
    "data-index": 387,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M464.2 1184.6c-.3.1-.6 0-1-.6.2 0 .6.1 1 .6Z",
    "data-index": 388,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M465.3 1185.8c-.3 0-.6-.2-1-.6.2-.1.5 0 1 .6Z",
    "data-index": 389,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M519.9 1247c-.2 0-.6-.2-1-.8.2 0 .5.3 1 .9Z",
    "data-index": 390,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M681.2 1240.7c0 .3-.3.6-1 1 0-.3.3-.6 1-1Z",
    "data-index": 391,
    style: {
      visibility: "visible"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M288 880.3c-.2 0-.5-.1-1-.6.3-.1.6 0 1 .6Z",
    "data-index": 392
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M310.3 920.4c-.2 0-.5-.1-1-.6.3 0 .6.1 1 .6Z",
    "data-index": 393
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M314.8 928.2c-.3.1-.6-.1-1-.6.2 0 .6.1 1 .6Z",
    "data-index": 394
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M239.1 801.3c.4.1.7.3 1 .9 0 .3 0 .3-.3.2-.6-.3-.8-.6-.8-1h.1Z",
    "data-index": 395
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M240.2 802.5c.4 0 .7.2 1 .8 0 .3 0 .3-.2.2a2 2 0 0 1-1-1h.2Z",
    "data-index": 396
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M351.6 751.5c.2 0 .5.2 1 .7-.3 0-.6-.2-1-.7Z",
    "data-index": 397
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M273.6 854.7c-.2 0-.3-.3-.3-.7.1-.1.3.4.3.7Z",
    "data-index": 398
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M628 1020.3c.3-.1.6 0 1 .6-.2 0-.6-.1-1-.6Z",
    "data-index": 399,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M661.5 1039.2c.3 0 .6.2 1 .6-.3.1-.6 0-1-.6Z",
    "data-index": 400,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M386.1 1056.4c-.2 0-.5-.1-1-.6.3 0 .6.1 1 .6Z",
    "data-index": 401,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M577.9 1020.3c.2-.1.5 0 1 .6-.3 0-.6-.1-1-.6Z",
    "data-index": 402,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M412.9 1102.1c-.3.1-.6 0-1-.6.2 0 .6.1 1 .6Z",
    "data-index": 403,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M329.2 953.9c-.2 0-.5-.2-1-.7.3 0 .6.2 1 .7Z",
    "data-index": 404,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M330.4 956c-.3.1-.6-.1-1-.7.2 0 .5.2 1 .8Z",
    "data-index": 405,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M347.1 986.2c-.2 0-.5-.1-1-.6.3 0 .6.1 1 .6Z",
    "data-index": 406,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M604.6 1003.5c.2 0 .5.1 1 .6-.2 0-.5-.1-1-.6Z",
    "data-index": 407,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M575.7 1018c.2 0 .5.2 1 .6-.3.1-.6-.1-1-.6Z",
    "data-index": 408,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M366 1019.6c-.2.1-.5 0-1-.6.3 0 .7.2 1 .6Z",
    "data-index": 409,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M576.8 1019.2c.2-.1.5 0 1 .6-.3 0-.6-.2-1-.6Z",
    "data-index": 410,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M626.9 1019.2c.3-.1.6 0 1 .6-.3 0-.6-.1-1-.6Z",
    "data-index": 411,
    style: {
      visibility: "visible"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M482.3 669c8 1.6 16.1 4.4 24.5 5.1 10 .9 20.2 1 30.1-.4 38.9-5.6 75-19.3 109.7-38.4-1.1 1.4-2.3 3.4-4 4.4a361.7 361.7 0 0 1-69.3 28c-20.3 6.1-41 9.9-62.1 8.8a60 60 0 0 1-29-7.5Z",
    "data-index": 412
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "M922.4 839c-1.4 8.2-2.7 16.2-4.3 24.5-3.7-2-5-5-3.2-9.3 1-2.3 1-5 2-7.3 1.3-3 3.1-5.7 5-8.6.5 0 .5.5.5.8Z",
    "data-index": 413,
    style: {
      visibility: "visible"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M474 586.4c-2.4 9-5.3 18.1-7.9 27.3a64.4 64.4 0 0 0 1.5 37.9c-1.5-3-4-6.3-4.4-9.9-1.6-18.1 1-35.7 8.5-52.4.4-1 1.2-1.8 2.2-2.9Z",
    "data-index": 414
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M791 604c-1 0-2.3.5-3.2.1-9.3-4.3-18.5-8.7-27.8-13.2-.6-.3-.8-1.1-1.3-2.2 0-.5.1-.6.5-.5a3457.1 3457.1 0 0 1 31.8 15.7Z",
    "data-index": 415
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M758.7 588.3c-1.7-.1-3.5 0-4.9-.6-7.6-3.5-15.2-7.2-22.8-11.3-.1-.5.2-.9.6-.8l27.2 12.5-.1.2Z",
    "data-index": 416
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M807.6 613a305 305 0 0 1-16.7-8.7c0-.4.1-.4.5-.4 5.8 3 11.2 5.8 16.4 8.8l-.2.3Z",
    "data-index": 417
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M716.4 574.4c-.2-1.2 0-2.5.4-4 .6-.5 1-.6 1.9-.6 2.5 1.3 4.8 2.3 6.9 3.6l-.6.7-8.6.3Z",
    "data-index": 418
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M476.4 572.3c.1-.4.4-.5 1-.5-.7 4.7-1.6 9.3-2.9 14.3l1.9-13.8Z",
    "data-index": 419
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M822 620.8c-3.3-1.7-6.6-3.3-9.9-5.4.1-.4.1-.4.5-.3a211 211 0 0 1 9.7 5.4l-.2.3Z",
    "data-index": 420
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M654 632c2.3-2 5-3.9 8.2-5.7a66 66 0 0 1-8.2 5.6Z",
    "data-index": 421
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2A5D7",
    d: "m729 797 1.3-4 1.6.5-2 5.1a4 4 0 0 1-1-1.6Z",
    "data-index": 422
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M647.3 635.3c1.6-1.2 3.6-2.3 6-3.4a34.4 34.4 0 0 1-6 3.4Z",
    "data-index": 423
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M730.7 576.1c-2-.3-3.7-.8-5.6-1.6 0-.5.1-.7.8-1 2.2.6 3.7 1.3 5.3 2l-.5.6Z",
    "data-index": 424
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M468.7 654.6c.8.8 1.6 2 2.3 3.7-.8-.8-1.6-2-2.3-3.7Z",
    "data-index": 425
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M662.9 626.3c.2-.7.7-1.3 1.5-2.1-.2.6-.7 1.4-1.5 2.1Z",
    "data-index": 426
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M812.2 615c-1.5-.4-3-.8-4.5-1.6-.1-.4 0-.6.5-.6 1.6.7 2.8 1.5 4 2.2Z",
    "data-index": 427
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M471 659c.7.2 1.4.7 2.4 1.6-.7-.2-1.6-.7-2.4-1.5Z",
    "data-index": 428
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M476.5 664.6c.7.1 1.5.7 2.2 1.5-.7-.1-1.4-.6-2.2-1.5Z",
    "data-index": 429
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "M824.4 621.7c-.7 0-1.4-.1-2.2-.6-.1-.3 0-.5.4-.5l2 1-.2.1Z",
    "data-index": 430
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M478.9 666.8c.5-.2 1.1 0 2 .5-.6.1-1.2 0-2-.5Z",
    "data-index": 431
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M467.6 652.3c.3.2.7.7 1.1 1.6-.4-.2-.8-.7-1.1-1.6Z",
    "data-index": 432
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C9EC",
    d: "m715.1 575.7.3-.5c.2.3.2.4-.3.5Z",
    "data-index": 433
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M475.5 663.4c.2 0 .5.1 1 .6-.3 0-.6-.1-1-.6Z",
    "data-index": 434
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M474.3 662c.3 0 .6.3 1 .9-.2 0-.6-.3-1-.9Z",
    "data-index": 435
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M481 667.8c.3 0 .7.1 1 .6-.2.1-.6 0-1-.6Z",
    "data-index": 436
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2975B",
    d: "M520 520.6c-6 2.5-12.2 5-18.3 7.3-3.8 1.5-7.6 3-11.5 4-3.8 1.2-7.8 2-12.3 3l-2.8-21c6.6-2 12.8-4 19-6.2 5-2 10-3.4 15.7-4.6a168 168 0 0 0 15-5c6.5-2.8 12.8-5.5 18.8-8.5 3.4-1.7 6.5-4 9.7-6 0 0 0 .1.4 0 .8-.7 1.3-1.5 1.8-2.2h.5c1.5-.7 2.8-1.5 4-2.2l.3-.1.8-1 .3-.1.9-1h.3l1.9-1.2h.2l.9-1h.4l1.8-1.5c.1-.3.3-.5 1.1-.7l2.3-1.2.2-.1c.5-.4.7-.7.9-1l.2-.1 1-1h.2a4 4 0 0 0 .9-1l22-18.3 1.7 1.7c-13.9 16-26.4 33-43.7 46.1-.7.2-1 .4-1.2.6h-.3l-.8 1h-.4c-.8.4-1.3.8-1.8 1.2h-.4c-.9.8-1.4 1.5-1.9 2.2h-.3c-.9.4-1.4.8-1.9 1.1h-.4a12 12 0 0 0-1.8 2.3h-.4c-1.6.7-2.9 1.4-4 2.2h-.5c-.8.8-1.3 1.5-1.8 2.2h-.5c-2 1.1-3.5 2.3-5 3.4h-.4c-.9.3-1.4.7-2 1l-.2.2-.9 1h-.4c-2.7 1.5-5 3-7.3 4.5Z",
    "data-index": 437
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#6869A4",
    d: "m699 402.1 11.5-2-5.5 18.7c0 .4 0 .3-.2.4-.5.9-.7 1.5-.9 2.2h-.3c-.9 1-1.4 2.2-2 3.3h-.1l-1 1-.3.2c-1.2 1.5-2 3-3 4.4h-.2l-1 1.2c-.4.6-1 1.2-2.2 2-1.9 1.2-3.1 2.4-4.4 3.5h-.3a20 20 0 0 0-4.1 3.4l-.4-.1c-2 1-3.6 2.2-5.2 3.3h-.3c-1 .4-1.4.8-2 1.1h-.3l-5.3 2.3h-.4c-3.2 0-5.9.2-9 .3l-1.5-.2-.2-1.4a44 44 0 0 1-.6-7.7c5-2.3 9.4-4.5 14-6.8h.2l.9-1 .2-.2c.5-.4.7-.7.9-1h.3c1.2-.7 2.1-1.5 3-2.3h.3l.9-1.6c.2-.4.5-.5 1.2-.5 1-.4 1.5-.8 2-1.2 0 0 0 .1.4 0l4.1-4.4h.3l.8-1.1.3-.2c.5-.8.6-1.5.8-2.2 0 0 0 .1.4 0 .9-1 1.4-2.1 1.9-3.2h.2l.9-1.1h.3c.9-1.2 1.4-2.3 1.9-3.4h.3c1.3-1.9 2.2-3.7 3-5.6h-.2Z",
    "data-index": 438
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA914F",
    d: "m422.1 279.7 2-1h2.1v.3c.2 1.9.5 3.3.4 4.7l-2.6 23.8-.3.2c-.7 1.2-1 2.1-1.2 3.1-6.6 15.3-13 30.6-19.8 45.8-6.7 15.3-.2 25.6 16.5 25.9.7 0 1.6-.3 2.2 0 1.3.7 2.4 1.8 3.5 2.6-1.2.9-2.6 2.6-3.7 2.4-5.5-1-11-2.5-17.1-4l-1.1-.6-5.4-6.6c-4-7.4-1.1-14-.2-20.7l.3-.2c3.1-6 5.9-11.8 8.6-17.7l.3-.2c.5-1.2.6-2.2.8-3.1l.3-.2c1-1.5 1.4-2.9 2-4.3l.2-.2c.9-2 1.4-3.6 2-5.4l.3-.2a94.2 94.2 0 0 0 10-44.4Z",
    "data-index": 439,
    style: {
      stroke: "#ea914f"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA914F",
    d: "M669 315c-4.6 8-8.7 15.9-13 23.6-.7 1.2-2 2.2-3 3.3-.4-1.4-1.6-3-1.2-4.2 6-19.6 17-34.5 37.4-40.5 2-.6 4.2-.5 6.3-.7l.9 2c-1.6.9-3 2.2-4.6 2.7a47.6 47.6 0 0 0-22.9 13.8Z",
    "data-index": 440
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA914F",
    d: "M461.8 428c-18.5 8.9-40.8 8.7-44.3-1 1.6.2 3 0 4.2.5 17 6.2 32 .8 46.3-8.3 1.1-.7 2-1.7 3.3-2.1 1-.4 2.1 0 3.2 0-.2 1-.2 2.4-.8 2.8-3.8 2.8-7.7 5.3-11.9 8Z",
    "data-index": 441,
    style: {
      strokeWidth: 2,
      stroke: "#e28d4d"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M708.9 287.4c.4-.3.6 0 1.2.5l2.5 3.2v.3l3.4 6.3v.4c.7 4 2 7.5 2.3 11.2 1.8 21.2-5.3 40-16.4 57.5l-.3-.1c2.1-4.9 4-9.9 6.3-14.6a82.8 82.8 0 0 0 8.9-33.4c.3-8.9-.6-18-6-26-1-1.4-1.4-3.3-2-5.3Z",
    "data-index": 442
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "m631.5 304.3-2.5 6c-4.6.2-4.4-2.7-4.3-5.5.4-5.5 1-11 1-16.6 0-4.6-.1-9.3-1.2-13.7-.5-1.9-3.3-3.6-5.4-4.6-9-4.1-18.3-8-27.5-12.3.1-.7.2-.9.7-.9l3.1 1s.2 0 .3.3c10.5 4.6 20.8 8.8 31 13.1v38.6a35 35 0 0 1 4.1-6l.7.6Z",
    "data-index": 443
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M682.7 527.2c-1.5-2.2-3.5-4.1-4.3-6.5-5-16.3-9.8-32.7-14.6-49-.3-1.2 0-2.6.4-4.3.5-.3.7-.3 1 .2.5 2.8.6 5.2 1.4 7.5L683 527l-.3.2Z",
    "data-index": 444
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "m531 260.7-14.6-4.3c-11-3.4-22.4-3.9-33.9-3.5a33 33 0 0 1-6.8-.8c-.2-.5-.1-.6.3-.5a91.5 91.5 0 0 1 55 9.1Z",
    "data-index": 445
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M705 283c-5.6-2.6-11-6-16.8-7.6-10-3-20-1.4-29.4 3.4-1 .4-2 .6-3.6.8-.5 0-.7-.2-.4-.5 16-9.4 31.7-9.2 47.3 0 0 0 0 .2.3.5 1 1.3 2 2.2 2.8 3.2l-.2.3Z",
    "data-index": 446
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA914F",
    d: "m642.6 404.8-8.1-3.3.7-2.5 19.2 2.4c.6 0 .7.4.6.8-.2 1.4-.2 2.4-.8 3.4l-11.6-.8Z",
    "data-index": 447
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M642.7 405.2c3.6-.2 7.3 0 11.6.9a568 568 0 0 1 4.8 30.1l.2 1v.8l1 7.4c-1.5-5-3.3-10.1-4.3-15.5-1.1-6.5-1.4-13.1-2.5-19.6-.3-1.4-2.4-2.8-4-3.4-2-.8-4.4-1-6.8-1.7Z",
    "data-index": 448
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M482 239.5c3.8-1.3 7.6-3.5 11.6-3.8a45 45 0 0 1 33.9 9.2c0 .4-.1.6-.5.5l-7.2-3.6a54.5 54.5 0 0 0-37.7-2.2l-.1-.1Z",
    "data-index": 449
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M402.8 247.3c-1.2.7-2.5 2.1-3.6 2a92.4 92.4 0 0 0-37.2.1c-6.4 1.4-8-.2-7.3-6.2.4-.2.6 0 .6.4.3 3.8 1.5 5.1 5.4 4.3a74 74 0 0 1 15.4-1.6c8.9 0 17.7.6 26.6 1h.1Z",
    "data-index": 450
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M421.7 280a89 89 0 0 1-9.5 44.1c1.1-4.9 3-10 4-15.1 2-9.5 3.4-19.2 5.5-29Z",
    "data-index": 451,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M370.5 313.1c-6-5.6-2-23.8 7.2-26.1 2.1-.6 4.8 1.2 7.2 2.4 0 .5-.3.7-.6.5-5.7-3.7-11.8.3-13.3 6.8-1.1 5.2-.3 10.8-.3 16.3l-.2.1Z",
    "data-index": 452,
    style: {
      visibility: "visible"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M565.6 244a951 951 0 0 1-28.8-16.4c0-.5.2-.7.5-.6l3.5 1.8.2.2 3.3 1.9.2.2c2.6 1.7 5 3 7.5 4.3l.2.3c3.4 2 6.6 3.6 9.8 5.3l.2.2 3.6 2.6-.2.2Z",
    "data-index": 453
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M552.9 483.6c-2.8 2-5.9 4.3-9.3 6-6 3-12.3 5.7-18.9 8.5a754 754 0 0 1 28.2-14.5Z",
    "data-index": 454
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F4FC",
    d: "m665 467.2-.8-.3c-1.4-6.4-2.5-12.7-3.6-19.4.4-.4.9-.3 1.6.1 1.5.8 2.6 1.2 3.7 2a186.9 186.9 0 0 1-.8 17.6Z",
    "data-index": 455
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m718.3 569.6-1.7.5c-5.2-4-10-8.2-15-13l-1.3-2.9c1.8 1.2 3.7 2.3 5.4 3.7a236 236 0 0 1 12.4 10.5c.3.6.2 1.2.2 1.2Z",
    "data-index": 456
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M488.7 322c-9.3-3-12.3-18.2-4.8-26.5.5 0 .7 0 .5.5-4.5 10-3.5 18 3 24.3l1.5 1.5-.2.2Z",
    "data-index": 457
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M591.4 257.3c-8.7-4-17.2-8.3-25.7-12.9 0-.4 0-.5.5-.5a432 432 0 0 1 13.7 6.5c4.1 2.3 8 4.2 12 6.2l-.5.7Z",
    "data-index": 458
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M424.3 307.3c.5-7.7 1.5-15.7 2.3-23.6.1-1.4-.2-2.8-.4-4.6.7.2 2.2 1 2.1 1.5-1.1 8.8-2.4 17.6-4 26.7Z",
    "data-index": 459,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M655 401.3c1.4-.8 3-1.7 4.6-2.3 6.6-2.3 13.3-4.4 20.6-6.5.7.2.9.4.7.8-8 5.5-16.7 7.5-25.8 8.5 0 0 0-.3-.2-.5Z",
    "data-index": 460
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M385 289.8c5.8 2.7 6 8.5 6.3 13.4.3 3.8-2.1 7.9-3.9 11.8-.7-.1-.8-.3-.7-.7 4-8.8 3.8-16.7-2-24.2l.2-.3Z",
    "data-index": 461,
    style: {
      visibility: "visible"
    }
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M366 234c6.7-5.5 14.4-3.3 21.8-2.9 2.7.2 5.3 2.1 8 3.7.2.5 0 .8-.5.7a37.8 37.8 0 0 0-29-1.2l-.3-.3Z",
    "data-index": 462
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M397 355.7c-.5 6.6-3.4 13.2.3 20.4-.6.2-1.8.2-1.9-.1-2-6.8-3.1-13.6 1.6-20.3Z",
    "data-index": 463,
    style: {
      stroke: "#ea914f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M406 337.9a234 234 0 0 1-8.3 17.5c2.4-5.7 5.1-11.5 8.2-17.5Z",
    "data-index": 464,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M476.4 178.5c0 .3.2.6.8 1l.7 1c-3-2-6.2-3.7-8.8-6.2-2.7-2.6-4.8-5.9-6.9-9.2.3-.3.8 0 .8 0s0-.2 0 0c.5.6.8.8 1.1 1v.2c.5.6.8.8 1.1 1 0 .4.2.7.8 1.2l1.4 1.1 3 3.3 1.5 1.2a82.3 82.3 0 0 0 4.5 4.4Z",
    "data-index": 465
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M437.4 134.8a368 368 0 0 1-10-15.3c.2-.5.4-.7.7-.5a191 191 0 0 1 3.5 4.9v.2c.4.9.8 1.4 1.2 2v.2l2.2 3.1v.3l2.2 3 .1.3.4 1.5-.3.3Z",
    "data-index": 466
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M385 317.6c-2.3 1.1-5.3 3.6-7 3-2.9-1.2-5-4.3-7.5-7 0-.5.1-.5.5-.4 5 6.6 7.2 7.3 13.8 4.2l.2.2Z",
    "data-index": 467,
    style: {
      visibility: "visible"
    }
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M632.3 300.3c.7-1.8 1-4 2.2-5.4a92 92 0 0 1 9.8-8.5c.4 0 .3.2 0 .5l-1 1.5h-.2c-.5.3-.8.7-1 1h-.1c-.6.5-.8.8-1 1.1 0 0 .2 0-.1.1a3 3 0 0 0-1 1s.2.1-.1.2l-1 1s.2 0-.1.2c-.9.8-1.4 1.5-1.9 2.2l-.2.1c-1.7 1.8-3 3.4-4.3 5Z",
    "data-index": 468
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M388.4 117c-3.4 4.4-7 8.8-10.8 13.3-.4 0-.5-.1-.5-.6 1.2-2.2 2.5-4 3.7-6l.2-.1c1.7-1.9 3-3.6 4.3-5.4h.1c.5-.5.8-.8 1-1.2h.1c.6-.3.8-.6 1.3-.6l.6.6Z",
    "data-index": 469
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M504.3 297.5c3.4 5.3 3.1 10.8.3 16.5-.5 0-.7 0-.6-.5 0-5.4-.3-10.4-.3-15.5l.6-.5Z",
    "data-index": 470
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M523.9 498a100 100 0 0 1-13.7 5 180 180 0 0 1 13.7-5Z",
    "data-index": 471
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M426.3 116.9c-1.9-3-3.8-6.1-5.6-9.7.2-.5.4-.7.7-.4a219 219 0 0 1 5 10l-.1.1Z",
    "data-index": 472
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M536.7 251.8c3.3 2.4 6.3 5 3.5 9.8-.4.1-.5 0-.4-.4-1-2.7-2-5-3.1-7.5l-.6-1.4.6-.5Z",
    "data-index": 473
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M463 164.6c0 .4-.5.2-.8.1-.2-.4-.3-.7-1-1.2l-1.4-1.1v-.2l-1-1s0 .2-.1-.1a3 3 0 0 0-1-1v-.2l-1-1v-.2l-.6-1.2c2.3 2.2 4.6 4.5 6.9 7.1Z",
    "data-index": 474
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M393.1 110.3c.4 0 .6-.1 1.2-.8l1-1.4h.1a3 3 0 0 0 1-1h.3l1.5-.5.2.3c-2.3 2.5-4.7 5-7.6 7.5-.7-.2-.8-.3-.8-.7.5-.5.7-.8.8-1.1l.1-.1c.5-.4.8-.8 1-1.1h.1c.6-.4.9-.8 1.1-1.1Z",
    "data-index": 475
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "m632.2 300.3 4.4-5a84.3 84.3 0 0 1-4.8 8.8c-.5 0-.6-.1-.8-.8.3-1.4.6-2.3 1-3.2 0 0 0 .2.2.2Z",
    "data-index": 476
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M487.6 292c2.7-3.4 5.8-4.8 9.8-1.4 0 .5-.2.7-.6.6l-9 1-.2-.3Z",
    "data-index": 477
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M474.3 250.7c-4.4-3.5-1.6-5.6 1.8-7.8.4 0 .4 0 .4.4-.2.7-.3 1.1-.7 1.7-.6 2-1 3.6-1.3 5.4l-.2.3Z",
    "data-index": 478
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M692.7 545a97.4 97.4 0 0 1-5.5-8.6c.1-.5.3-.7.6-.5l1.3 1.6v.3l3.8 7-.2.2Z",
    "data-index": 479
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "m485.3 186.5 2 2c.6.6.8.9.9 1.4l-.7.7c-2.1-2.1-4.2-4.2-6-6.6l1.3.2s.2-.1.2.1l1 1s.2-.2.2 0c.3.7.7 1 1 1.2Z",
    "data-index": 480
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M497.6 322c-2.6 3.6-5.5 2.9-8.7.4-.2-.4 0-.5.5-.5h8l.2.1Z",
    "data-index": 481
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M446.3 147c-1.8-2-3.7-3.9-5.3-6.4.3-.8.4-1 .7-.9.4.6.7.8 1 1 0 0 .1-.2.2.1.8 1.3 1.5 2.2 2.2 3v.2c.5.6.8.8 1.1 1v.2l.4 1.6-.3.2Z",
    "data-index": 482
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M530 222.8c-2.6-1.6-5.2-3.2-7.8-5.2 0-.5.2-.6.5-.5l1.4.5s.2-.1.3.2c1 .9 2 1.5 3 2l.2.2c.4.5.8.6 1.2.8v.2l1.4 1.6-.3.2Z",
    "data-index": 483
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M696 375.5c1.7-2.8 3.3-5.7 5.3-8.7.3-.1.5 0 .5.4-1.8 3.2-3.6 6-5.4 8.6-.2 0-.4-.3-.4-.3Z",
    "data-index": 484
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M520.4 520.5c1.9-1.4 4.2-3 7-4.4-2 1.5-4.3 3-7 4.4Z",
    "data-index": 485
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M494.2 194.2c0 .4.1.6.9 1l1.6 1.8-.2.2c-2.2-1.6-4.4-3.2-6.6-5.3 0-.5.2-.7.5-.6l1.4.7s.1-.2.1.1c.4.5.8.7 1.1.9 0 0 .1-.1.1.2l1 1Z",
    "data-index": 486
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M502 201.7a52.2 52.2 0 0 1-5.5-4.1c0-.4.1-.5.5-.5l1.4.5s.2-.1.2.2l1.1.8v.2l2.5 2.7-.1.2Z",
    "data-index": 487
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M648.3 281.4c.1.2.3.4.9.7 1 0 1.4-.3 2-.4l.3.3c-1.7 1.4-3.5 2.9-5.5 4 .2-.8.7-1.3 1.1-1.8l.4-.2c.6-1 .7-1.8.8-2.6Z",
    "data-index": 488
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M503.2 316.5a62 62 0 0 1-5.2 5.6c-.4 0-.5-.2-.4-.5.5-.8 1-1.2 1.7-1.7l2.1-2.2 1.6-1.4.2.2Z",
    "data-index": 489
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M497.5 291c2 1 3.8 2.2 5.5 4-.3.8-.5 1-.8.9-.3-.6-.6-.8-1.1-1.2a55.8 55.8 0 0 0-3.9-3.4l.3-.4Z",
    "data-index": 490
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M482.9 183.8c-.4.3-.8.2-1.3-.2-.2 0-.3 0-.4-.3l-1.3-1.2-1.8-1.6c-.3-.3-.4-.4-.6-.9a30 30 0 0 1 5.4 4.2Z",
    "data-index": 491
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M697.1 551.8c-1.4-2-3-4-4.4-6.4 0-.4.1-.5.5-.3 1.7 2.2 3 4.2 4.3 6.4l-.4.3Z",
    "data-index": 492
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M539.9 261.8c-2 4.2-4.7 2-7.3.2 0-.7.2-.8.7-.8l6.4.3.2.3Z",
    "data-index": 493
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M686 535c-1.1-2.3-2.2-4.6-3.3-7.4 0-.4.2-.6.5-.4 1.5 2.5 2.5 4.8 3.4 7.2l-.6.7Z",
    "data-index": 494
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M416.2 98H411c-.5-.2-.6-.3-.4-.6 2-1 3.7-1.8 5.5-2.5v.2l.4 2.6-.3.3Z",
    "data-index": 495
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M689.3 384.5c1.3-1.9 2.5-3.7 4.2-5.5.5 0 .6.2.5.5l-.5 1.4-.2.2-3.6 3.7-.4-.3Z",
    "data-index": 496
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M508.7 207.2a38.5 38.5 0 0 1-5.4-4.1c0-.5.2-.7.5-.6l1.4.6s.1-.2.1.1c.4.5.8.7 1.2.9v.2l2.5 2.6-.3.3Z",
    "data-index": 497
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "m456.1 157.4.6 1.3c-1.5-.9-3-2-4.5-3.7.2-.7.3-.8.7-.7l2.2 1.9v.2c.4.5.8.7 1.1 1Z",
    "data-index": 498
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M531.5 513.8c1.2-1 2.8-2.2 4.8-3.3a26.7 26.7 0 0 1-4.8 3.3Z",
    "data-index": 499
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M440.9 140.2c-1.3-1.4-2.4-3-3.5-5 0-.4.2-.6.6-.5a51 51 0 0 1 3.6 4.8l-.7.7Z",
    "data-index": 500
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M420.7 106.8a38.6 38.6 0 0 1-3.3-6.3c.1-.5.3-.6.6-.3 1.2 2.2 2.1 4.3 3 6.3l-.3.3Z",
    "data-index": 501
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M411.5 324.5a17 17 0 0 1-1.6 5.2c.2-1.5.7-3.3 1.6-5.2Z",
    "data-index": 502,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M513.2 210.6c-1.5-.9-3-1.7-4.4-3 0-.4.1-.6.5-.6l1.5.5.2.2 2.4 2.7-.2.2Z",
    "data-index": 503
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M517.7 214c-1.5-1-3-1.8-4.5-3 0-.4.1-.6.5-.5a8 8 0 0 1 1.5.4l.2.3 2.5 2.5-.2.2Z",
    "data-index": 504
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M683.8 390c1.2-1.4 2.5-2.8 4.1-4.3.4 0 .5 0 .4.3l-.3 1.6-.2.1c-.5.4-.7.8-1 1.1 0 0 .2 0 0 0-.6.4-.8.8-1 1.1h-.3l-1.6.2h-.1Z",
    "data-index": 505
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M539.3 508.3c.8-.8 2-1.5 3.7-2.3-.8.8-2 1.6-3.7 2.3Z",
    "data-index": 506
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M450.8 152.6c-1-.9-2-1.8-3-3.2.1-.6.3-.8.6-.7.4.5.7.7 1 .8 0 0 .2-.1.2.2.3.5.7.7 1 1 0 0-.1-.1 0 .2l.4 1.5-.2.2Z",
    "data-index": 507
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M402.9 240.6c.5 1.8 1 3.5 1.3 5.3-.4.2-.5 0-.5-.3-.3-1.8-.8-3.2-1-4.7l.2-.3Z",
    "data-index": 508
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M409.3 330c-.2 1.3-.7 2.7-1.5 4.2.1-1.2.6-2.6 1.5-4.1Z",
    "data-index": 509,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M559.6 479.1c-.8.8-2 1.6-3.7 2.3a22 22 0 0 1 3.7-2.3Z",
    "data-index": 510
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M700.3 554.2c.4.8.7 1.6 1 2.7a9 9 0 0 1-2.7-2.8c.2-.7.3-.8.7-.7.4.5.7.7 1 .8Z",
    "data-index": 511
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M654.7 279.6c-.8.8-1.6 1.6-2.8 2.3-.4 0-.6-.1-.6-.4.4-.5.5-.8.6-1.1l.5-.2 2.1-.8.2.2Z",
    "data-index": 512
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M360.5 237.3a10 10 0 0 1 3-2.1c.5 0 .7.3.4.5-1.2.8-2.2 1.4-3.2 1.8l-.2-.2Z",
    "data-index": 513
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M396 235.2a8 8 0 0 1 3.4 1.8c0 .5-.2.7-.5.6l-3.2-2 .4-.4Z",
    "data-index": 514
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M536.7 227.2a8.6 8.6 0 0 1-3.3-1.8c0-.5.2-.6.5-.6 1.2.8 2.2 1.4 3 2.1l-.2.3Z",
    "data-index": 515
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M410.6 97.9c-.8.8-1.6 1.6-3 2.2-.4 0-.6-.3-.4-.5 1.2-.9 2.2-1.4 3.2-2l.2.3Z",
    "data-index": 516
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M693.9 379c.4-1.2.9-2.3 1.8-3.4.3 0 .5.1.5.5-.7 1.3-1.4 2.2-2 3l-.3-.1Z",
    "data-index": 517
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M533.4 225c-1.1-.5-2.2-1-3.3-1.8-.2-.4 0-.5.4-.5l1.5.4.2.2 1.4 1.5-.2.2Z",
    "data-index": 518
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M404 102.4c-.5.8-1 1.5-2 2-.7-.2-.9-.3-.8-.6.6-.4.8-.7.9-1 0 0-.2-.1.2-.2l1.5-.4.2.2Z",
    "data-index": 519
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M519.8 214.6c0 .2.2.4.5.6-.8 0-1.7-.3-2.6-.9 0-.4.1-.5.5-.5l1.6.8Z",
    "data-index": 520
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M407.3 100.1c-.8.9-1.7 1.6-3 2.3-.3 0-.4-.1-.4-.4l1.4-1.6h.2l1.5-.6.3.3Z",
    "data-index": 521
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M555.2 481.5c-.2.6-.7 1.4-1.5 2.1.1-.7.6-1.4 1.5-2.1Z",
    "data-index": 522
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M548.2 502.7c.1-.7.6-1.4 1.5-2.2-.1.7-.7 1.4-1.5 2.2Z",
    "data-index": 523
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M543.7 506c.2-.7.7-1.4 1.6-2.1-.2.6-.7 1.3-1.6 2Z",
    "data-index": 524
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M532.2 248.5c1 .5 2 1 3 2 0 .5-.3 1-.5.8l-1.3-1-1.4-1.7.2-.1Z",
    "data-index": 525
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M537 510.5c.2-.7.7-1.4 1.6-2.2-.2.7-.7 1.4-1.6 2.2Z",
    "data-index": 526
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M646.7 284.2c0 .5-.5 1-1.1 1.7-.2.3-.5.3-.7.3.4-.6 1-1.3 1.8-2Z",
    "data-index": 527
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M422.9 310.7c-.1-.9.1-1.8.7-3 .1.8-.1 1.8-.7 3Z",
    "data-index": 528,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M355 243c.4-.8 1-1.6 1.8-2.3.4 0 .5.1.4.4-.7 1-1.3 1.5-2 2l-.2-.1Z",
    "data-index": 529,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M407 334.6c.2.7 0 1.7-.4 2.9-.2-.8 0-1.7.5-3Z",
    "data-index": 530,
    style: {
      visibility: "visible",
      stroke: "#ea914f"
    }
  }), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M637.2 295.2c.1-.7.6-1.4 1.4-2.3-.1.7-.5 1.5-1.4 2.3Z",
    "data-index": 531
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M399.5 237.4c.7.4 1.5 1 2.2 1.9 0 .4-.2.5-.5.3l-2-2 .3-.2Z",
    "data-index": 532
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M387 315.2a6 6 0 0 1-1.7 2.3c-.3.1-.4 0-.4-.4l.3-1.6h.3l1-.9.6.6Z",
    "data-index": 533,
    style: {
      visibility: "visible"
    }
  }), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M390.5 114.6c-.4.8-1 1.5-1.8 2.2-.4 0-.5 0-.7-.6a10 10 0 0 1 1.8-2.3l.7.7Z",
    "data-index": 534
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M476.5 242.9c.5-.4 1-.7 1.9-1 .4 0 .4 0 .2.3-.8.5-1.4.6-2 .8l-.1-.1Z",
    "data-index": 535
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M529.2 515c.2-.4.7-.8 1.6-1.1-.2.4-.7.7-1.6 1.1Z",
    "data-index": 536
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M484.3 295.4c.1-.8.3-1.4 1-2 .6.2.7.3.7.7l-1.4 1.5-.3-.2Z",
    "data-index": 537
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M358.2 238.4c.5-.4 1-.7 2-1.1.3 0 .4.2.3.5-.5.7-1 1-1.7 1.2l-.6-.6Z",
    "data-index": 538
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M485.5 293.2a4 4 0 0 1 1.7-1.3c.4 0 .5.2.4.5-.5.7-1 1-1.5 1.5l-.6-.7Z",
    "data-index": 539
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M489.9 191.5a4 4 0 0 1-2.2-.7c0-.4.1-.5.7-.8 1 .4 1.3.8 1.7 1.2l-.2.3Z",
    "data-index": 540
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M357.2 240.7c.1-.7.3-1.3.7-2.1.4 0 .6 0 .7.6-.4.8-.9 1.2-1.3 1.6l-.1-.1Z",
    "data-index": 541,
    style: {
      visibility: "visible"
    }
  }), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M452 154.7c-.5-.4-.9-.9-1.2-1.8 0-.3.1-.4.5-.4.7.6 1 1 1.4 1.5l-.7.7Z",
    "data-index": 542
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M426 278.4c-.3.3-.8.3-1.6.2.3-.1.9-.3 1.7-.2Z",
    "data-index": 543,
    style: {
      stroke: "#ea914f"
    }
  }), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M447.6 149.1c-.6-.3-1-.9-1.3-1.7 0-.4.2-.5.5-.4.7.5 1 1 1.4 1.5l-.6.6Z",
    "data-index": 544
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M479.7 240.7c.6-.4 1-.8 2-1.2.3 0 .3 0 .2.4a5 5 0 0 1-2 .8h-.2Z",
    "data-index": 545
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M708.2 285.3c0 .4.2.7.5 1.3-.4 0-1-.3-1.4-1 0-.4.1-.5.3-.5l.6.2Z",
    "data-index": 546
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M520.4 216c.5-.3.8-.1 1.5.3.4.3.5.7.5.7l-.2.2c-.7-.2-1.3-.6-1.8-1.2Z",
    "data-index": 547
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M570.8 471.4c-.2.3-.8.7-1.7 1.1.2-.4.8-.8 1.7-1.1Z",
    "data-index": 548
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M527.6 245.2a3 3 0 0 1 2 1c0 .5-.2.7-.6.6l-1.6-1.3.3-.3Z",
    "data-index": 549
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M417.4 100.1a7 7 0 0 1-1.2-1.8c0-.3.2-.5.6-.4.5.8.7 1.4.9 2l-.3.2Z",
    "data-index": 550
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M427.5 119c-.5-.4-.9-.9-1.2-1.8 0-.3 0-.4.4-.3a7 7 0 0 1 1.1 1.9l-.3.3Z",
    "data-index": 551
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M364 235.2c.3-.5.9-.9 1.7-1.2.3 0 .5.2.4.5-.7.6-1.3.8-2 1l-.2-.3Z",
    "data-index": 552
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M574.3 468.2c0 .3-.2.6-.7 1 0-.4.2-.6.7-1Z",
    "data-index": 553
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M698.4 553.8a4 4 0 0 1-1.3-1.7c0-.3.3-.5.6-.5.7.6 1 1 1.4 1.6l-.7.6Z",
    "data-index": 554
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M546 503.9c.1-.4.6-.8 1.5-1.2-.2.4-.7.8-1.6 1.2Z",
    "data-index": 555
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M564.1 475.8c-.1.4-.7.8-1.5 1.2.1-.4.7-.8 1.5-1.2Z",
    "data-index": 556
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M503 295.4c.6.4 1 .9 1.3 1.8 0 .3-.4.6-.7.6-.7-.6-1-1.2-1.2-1.7l.7-.7Z",
    "data-index": 557
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M550.4 500.5c.2-.4.7-.8 1.6-1.1-.2.4-.7.8-1.6 1.1Z",
    "data-index": 558
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M680.6 392.4c.3-.6.8-1 1.8-1.2.4.1.6.3.5.6l-1.7 1.2-.6-.6Z",
    "data-index": 559
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M567.5 473.4a4 4 0 0 1-1.6 1.3c.2-.4.7-.8 1.6-1.3Z",
    "data-index": 560
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M401.6 104.5c-.3.6-.9 1-1.8 1.2-.4 0-.5-.1-.4-.4l1.6-1.3.6.5Z",
    "data-index": 561
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M504.2 314.2a5 5 0 0 1-.7 2.1c-.3.2-.5 0-.5-.3.3-1 .6-1.5 1-2l.2.2Z",
    "data-index": 562
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M535.4 250.8c.5 0 .8.2 1.2.7 0 .3-.3.6-.7.6-.6-.2-.8-.4-1-.7l.5-.6Z",
    "data-index": 563
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M403 383.2c0-.3.5 0 .7 0 0 .2-.4.2-.7 0Z",
    "data-index": 564,
    style: {
      stroke: "#ea914f"
    }
  }), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M687.2 536c-.5 0-.8-.1-1.1-.7 0-.4.2-.5.7-.6.6.3.7.7.7 1l-.3.3Z",
    "data-index": 565
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M529.8 246.4c.6 0 .9.1 1 .8 0 .3-.1.6-.4.5-.6-.2-.9-.4-1.1-.7l.5-.6Z",
    "data-index": 566
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M682.7 391.2c0-.5.2-.8.8-1 .3-.2.3-.1.3.2-.3.6-.5.8-.8 1.1l-.3-.3Z",
    "data-index": 567
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M403.8 246.1c0 .5-.1.8-.7 1.1-.3.1-.3 0-.3-.2.2-.7.5-1 .9-1l.1.1Z",
    "data-index": 568
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M639.2 292.8c-.1-.3 0-.6.5-1.1.2.2 0 .6-.5 1.1Z",
    "data-index": 569
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M475.4 251.7c-.4 0-.7-.2-1-.8-.1-.2 0-.4.4-.4.6.3.7.6.8 1l-.2.2Z",
    "data-index": 570
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M688.3 385.6c0-.4.2-.7.8-1 .2-.1.5 0 .4.4-.4.5-.8.6-1.1.7l-.1-.1Z",
    "data-index": 571
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M531 247.4c.5 0 .8.2 1 .8.2.3 0 .4-.3.4l-1-.8.3-.4Z",
    "data-index": 572
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M640.3 291.6c-.2-.3 0-.6.5-1 .2.2 0 .6-.5 1Z",
    "data-index": 573
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M552.5 499.3c0-.2.2-.5.7-1 0 .2-.2.6-.7 1Z",
    "data-index": 574
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M707.3 285.2a2 2 0 0 1-1-.8c0-.4 0-.5.3-.5.2 0 .6.2.7.4l.1.8-.1.1Z",
    "data-index": 575
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M399.4 105.7c0 .5-.1.8-.7 1.1-.3.1-.4 0-.4-.4.3-.6.6-.8 1-.8l.1.1Z",
    "data-index": 576
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M643.7 288.3c-.2-.3.1-.7.7-1.3 0 .3-.1.8-.7 1.3Z",
    "data-index": 577
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M565.3 474.8c0 .2-.1.5-.6 1 0-.3.2-.6.6-1Z",
    "data-index": 578
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M560.8 478.1c.1.3 0 .6-.5 1-.1-.2 0-.5.5-1Z",
    "data-index": 579
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M706.1 284c-.4 0-.7-.1-1-.7-.1-.2 0-.4.4-.4.6.3.8.6.9 1l-.3.2Z",
    "data-index": 580
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M562 477c0 .3-.2.6-.6 1 0-.2.1-.5.6-1Z",
    "data-index": 581
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M532.3 261.7c-.5 0-.8-.1-1.1-.7-.1-.3 0-.4.3-.4l1.4.4-.6.7Z",
    "data-index": 582
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M572 470.3c0 .3-.1.6-.6 1 0-.2.1-.6.6-1Z",
    "data-index": 583
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M573.1 469.3c.1.2-.1.5-.6.9 0-.2.2-.5.6-1Z",
    "data-index": 584
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M553.6 498.2c0-.1.3-.3.7-.4 0 .2-.4.4-.7.4Z",
    "data-index": 585
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M480 182.5c.2-.1.6.2 1.1.8-.2 0-.6-.2-1.2-.8Z",
    "data-index": 586
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M641.4 290.5c-.2-.3 0-.6.5-1 .1.2 0 .6-.5 1Z",
    "data-index": 587
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M459.9 162.7c.3 0 .6.2 1 .7-.1 0-.5-.1-1-.7Z",
    "data-index": 588
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M458.8 161.5c.3 0 .6.2 1 .7-.2.1-.6-.1-1-.7Z",
    "data-index": 589
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M457.7 160.4c.3-.1.6.1 1 .7-.2 0-.5-.2-1-.7Z",
    "data-index": 590
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M456.7 159.2c.3 0 .6.2 1 .7-.2 0-.6-.1-1-.7Z",
    "data-index": 591
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M503.2 202.7c-.4 0-.7-.2-1-.8-.1-.2 0-.4.3-.3.7.1 1 .4 1 .8l-.3.3Z",
    "data-index": 592
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M478.7 241.8c0-.4.2-.7.8-1 .2-.1.3 0 .3.2l-1 1v-.2Z",
    "data-index": 593
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M642.5 289.4c-.2-.3 0-.7.6-1.1 0 .3-.1.7-.6 1Z",
    "data-index": 594
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88F4B",
    d: "M528 516c0-.2.2-.5.6-1 0 .3-.1.6-.6 1Z",
    "data-index": 595
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M401.7 239.6c.4 0 .7.2 1 .8.2.2 0 .4-.3.4-.7-.3-.8-.6-.9-1l.2-.2Z",
    "data-index": 596
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M343 236.3c-.5-1-.7-2-1.2-3.2-.3-.7-.3-1.2-.2-2.1.7-1.4 1.9-2.4 2.1-3.5 3.8-18.2 7.1-36.5 11.4-54.6 1.6-7.2 5.2-14 8.5-21.3l1-.1a301.6 301.6 0 0 0-19.5 85.4c-.7.1-1.3-.2-2.1-.6Z",
    "data-index": 597
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m694 379.5 2.4-3.3c1.8-3 3.6-5.8 5.4-9 11.2-18 18.3-36.7 16.5-58-.3-3.6-1.6-7-2.4-11.1 1.5 4 4.1 8.3 4.5 12.9 1.7 21-6.3 39.4-16.4 57-2.7 4.7-6.4 8.7-10 13-.3-.5-.2-.9 0-1.5Z",
    "data-index": 598
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m682.9 391.8 1-1.4c.4-.3.8-.4 1.6-.6-.7 1.5-1.4 3.8-2.8 4.5-8 3.9-16.3 7.3-26.2 11.7 1.3 7.9 3 17.4 4.5 27.6a7 7 0 0 1-1.9 2.4l-4.3-30c0-1.4 0-2.4.2-3.8 9.2-1.4 18-3.4 26-9l1.9-1.4Z",
    "data-index": 599
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M654.8 279a9 9 0 0 1-2.4 1.2c-.3-.5-.5-1.2-.2-1.5 10.1-10.5 38.2-11.5 49.3-1.8.4.3.6.9.8 1.8a44.9 44.9 0 0 0-47.5.4Z",
    "data-index": 600
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M631.5 300.1a7 7 0 0 1-.7 3 655 655 0 0 1-4.1 6.6v-38.3c1 2.5 3 5.5 3 8.5.4 6.5-.3 13.1-.4 19.7l2.2.5Z",
    "data-index": 601
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M626.8 270.7a566.6 566.6 0 0 1-31-12.8c3.7.8 7.8 1.8 11.7 3.2 5.2 1.8 10.3 3.8 15.3 6 1.5.7 2.7 2 4 3.6Z",
    "data-index": 602
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M428 119c-.5-.8-.7-1.4-1.3-2.1l-5.3-10.1c-1.3-2.3-2.2-4.4-3.4-6.6l-1.1-2.4c-.5-.9-.6-1.6-.9-2.7 1.9 2.4 4 4.9 5.6 7.8a352 352 0 0 1 10.1 20.5c-1.2-1-2.3-2.6-3.6-4.4Z",
    "data-index": 603
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M380.4 123.7c-.8 2-2 3.8-3.4 6a273 273 0 0 1-8.2 12.9c.8-7.8 5.7-13.6 11.6-18.9Z",
    "data-index": 604
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M592.3 256.7c-4.3-2-8.3-4-12.3-6.4 5.1 2 10.4 4.3 15.5 7-1 .2-2-.2-3.2-.6Z",
    "data-index": 605
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M579.7 249.7c-4.4-1.7-8.7-3.7-13.5-5.9-1.5-.8-2.7-1.5-4-2.6 5.7 2.5 11.6 5.3 17.5 8.5Z",
    "data-index": 606
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m407.2 99.6-1.6.8c1.3-4.3 7-7.7 10.5-5.9-1.8 1.1-3.5 1.9-5.5 2.9-1.2.8-2.2 1.3-3.4 2.2Z",
    "data-index": 607
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M562 240.6c-3.2-1.3-6.4-3-9.8-5 3.2 1.3 6.6 3 9.9 5Z",
    "data-index": 608
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M533.9 224.8c-.8-.5-1.2-.9-1.8-1.5 2.9 1.4 5.9 3 8.8 5-1.2 0-2.2-.6-3.6-1.3l-3.4-2.2Z",
    "data-index": 609
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M441.7 139.7c-1.2-1.7-2.3-3.3-3.7-5-.4-.6-.5-1-.7-1.7 3.1 1 6 2.5 5.6 7.2-.5.3-.8 0-1.2-.5Z",
    "data-index": 610
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M668.3 432.5c2.4-1.5 4.8-3 7.5-4.3.3.3 0 .8 0 .8h-.2l-.8 1.1h-.3c-.5.4-.7.8-.8 1.2l-.3-.2c-2 .4-3.4 1-5 1.6l-.1-.2Z",
    "data-index": 611
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M688.3 386c.4-.4.8-.5 1.3-.9 1.2-1.4 2.3-2.7 3.7-4a43 43 0 0 1-5 6.6c-.2-.5-.2-1 0-1.7Z",
    "data-index": 612
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m659.1 436.2 2-2.2a50 50 0 0 1 6.7-1.5c.5 0 .6.2.3.5-3 1.5-6 2.7-8.8 3.9l-.2-.7Z",
    "data-index": 613
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M364.9 151.1c-.2.4-.7.4-.9.4 1.2-3 2.6-5.8 4.3-8.7-.8 2.6-2 5.3-3.4 8.3Z",
    "data-index": 614
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M706.6 284c-.3-.5-.5-.8-1-1.2-1.2-1-2.1-2-3.2-3.1 3.1-2.2 3.8.4 4.8 3.1v1.3l-.6-.2Z",
    "data-index": 615
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m453 154.3-1.7-1.8c-.4-.5-.5-.9-.8-1.5 1.5 1.3 3.1 2.8 4.7 4.7-.8 0-1.4-.7-2.3-1.4Z",
    "data-index": 616
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M552 235c-2.5-.9-5-2.2-7.5-3.9 2.4 1 5 2.2 7.6 4Z",
    "data-index": 617
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m390 113.7-2.2 2.3-1.2 1c.9-1.4 2.1-3 3.7-4.5.4.4.2.7-.3 1.2Z",
    "data-index": 618
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M503.8 202.5c-.4-.5-.6-.8-1.3-1a21 21 0 0 1-2.8-2.7c1.8 1 3.7 2.2 5.6 3.8-.5.3-.8.1-1.5-.1Z",
    "data-index": 619
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M384.9 118.2a29 29 0 0 1-3.9 5.4 29 29 0 0 1 3.9-5.4Z",
    "data-index": 620
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M716 297.3a39.2 39.2 0 0 1-3.4-5.9 39 39 0 0 1 3.4 5.9Z",
    "data-index": 621
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M399.4 105.3c-.5.3-.8.5-1.2 1-.5.4-.8.6-1.5.8 1.4-1.4 3-3 5-4.5.3.5 0 .8-.5 1.2l-1.8 1.5Z",
    "data-index": 622
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M490.4 191.3c-.7-.5-1-1-1.8-1.5-.5-.4-.7-.7-1-1.2 1.3.6 2.8 1.6 4.3 3-.5.2-.8 0-1.5-.3Z",
    "data-index": 623
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m448.4 148.7-1.5-1.8c-.4-.5-.5-1-.8-1.6 1.1 1 2.3 2.1 3.5 3.8-.5.3-.8.1-1.2-.4Z",
    "data-index": 624
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M515.3 210.5c-.5.3-.9.1-1.6-.1-1-.9-1.9-1.6-2.8-2.7 1.4.6 3 1.5 4.4 2.8Z",
    "data-index": 625
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M510.9 207c-.5.3-.9.2-1.5 0-1.1-1-2-1.7-2.9-2.7a17 17 0 0 1 4.4 2.8Z",
    "data-index": 626
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M519.9 214.1c-.5.2-.9 0-1.6-.4-1.2-.8-2-1.5-3-2.6 1.4.7 3 1.6 4.6 3Z",
    "data-index": 627
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M688 418.8a24 24 0 0 1-4 4.5c-.3-.2-.3-.6 0-1.5l1-1.6h.2c.7-.4 1-.8 1.2-1l1.5-.4Z",
    "data-index": 628
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M681.3 424.5c-.3 0-.6.2-1.1.8-.6.7-.8 1.1-1 1.5h-.3c-.8.2-1.2.5-1.7.7 1.3-1.3 2.5-2.6 4-3.7.3.4.2.6.1.7Z",
    "data-index": 629
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M690.5 413.5c1-1.4 1.8-2.8 3.1-4.3.4 0 .5 0 .4.4l-.3 1.5-.2.1c-.5.4-.7.8-.9 1.1l-.2.1-1.6 1.3-.3-.2Z",
    "data-index": 630
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M498.5 197.2c-.5.2-.8 0-1.5-.2a10 10 0 0 1-1.7-1.7c1 .3 2.1.9 3.2 1.9Z",
    "data-index": 631
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M544.3 230.5c-1-.2-2-.7-3.3-1.5 1 .1 2.2.6 3.3 1.5Z",
    "data-index": 632
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M404.9 100.3c0 .5-.4 1-1 1.6-.5.4-1 .6-1.6.8.5-.8 1.3-1.6 2.6-2.4Z",
    "data-index": 633
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M532 222.7c-.4.2-.8.1-1.5-.1-.7-.5-1.1-1-1.7-1.6a8 8 0 0 1 3.3 1.7Z",
    "data-index": 634
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M527.5 219.4a7 7 0 0 1-3.2-1.6 7 7 0 0 1 3.2 1.6Z",
    "data-index": 635
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M712.7 290.6a9.8 9.8 0 0 1-2.4-2.7c.7.5 1.6 1.4 2.4 2.7Z",
    "data-index": 636
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M435.1 129a8.5 8.5 0 0 1-2.3-2.7 8 8 0 0 1 2.3 2.7Z",
    "data-index": 637
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M437.3 132.3a8.4 8.4 0 0 1-2.3-2.6c.8.5 1.6 1.3 2.3 2.6Z",
    "data-index": 638
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M677.1 427.6c.6-.3 1-.6 1.8-.8-.5.7-1.4 1.5-2.6 2.2-.4 0-.2-.5 0-.7.4-.2.6-.3.8-.7Z",
    "data-index": 639
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M698.2 400.1c.5.3.7.9.8 1.7 0 .3.2.4 0 .5l-1.6 1.4-.1-.2c.2-1 .4-2 .9-3.4Z",
    "data-index": 640
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M445.2 143.4a8.7 8.7 0 0 1-2.4-2.6c.7.5 1.6 1.4 2.4 2.6Z",
    "data-index": 641
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M707.3 284.3v-1c.5.4 1 1 1.2 1.9h-.9c-.2-.1-.3-.6-.3-.9Z",
    "data-index": 642
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M689.4 415.7c.2-.7.3-1.5.8-2.2.3 0 .5.1.5.5l-.4 1.6h-.1l-.8.1Z",
    "data-index": 643
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M522.7 217c-.3 0-.4-.4-.5-.6.6 0 1.4.2 2 .8-.4.2-.8 0-1.5-.1Z",
    "data-index": 644
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M694 409.1c.5-1 1-2.1 1.9-3.2.3-.1.4 0 .3.3l-.3 1.6-.2.1-1.6 1.3h-.1Z",
    "data-index": 645
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M651.4 280.2c.4.5.3.8-.2 1.2a5 5 0 0 1-1.8.8c.4-.8 1-1.5 2-2Z",
    "data-index": 646
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M696.2 405.8a6 6 0 0 1 .7-2.2c.4 0 .5 0 .5.4l-1.1 1.8Z",
    "data-index": 647
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M681.7 424.6c-.3-.2-.2-.4 0-.8a3 3 0 0 1 1.8-.5c-.3.5-.9.9-1.8 1.3Z",
    "data-index": 648
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M689.4 416c0-.3.5-.5.7-.5.1.7 0 1.4-.5 2.2-.3-.3-.3-.8-.2-1.6Z",
    "data-index": 649
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M648 281.6c.2.6 0 1.4-.5 2.4-.2-.5 0-1.3.5-2.4Z",
    "data-index": 650
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M432.9 125.7c-.5-.2-.9-.7-1.3-1.6.4.2.8.7 1.3 1.6Z",
    "data-index": 651
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M395 108.2c0 .2-.2.6-.7 1.1 0-.2.1-.6.6-1.1Z",
    "data-index": 652
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M392.8 110.4c0 .2-.2.6-.8 1 0-.2.2-.6.8-1Z",
    "data-index": 653
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M391.6 111.5c0 .2-.2.6-.7 1 0-.2.2-.6.7-1Z",
    "data-index": 654
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M386 117c.2.4 0 .7-.6 1.2 0-.3.1-.7.6-1.1Z",
    "data-index": 655
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M446.2 144.7c-.3.1-.6-.1-1-.7.2 0 .5.2 1 .7Z",
    "data-index": 656
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M687.2 388.8c0-.3.1-.7.6-1.1.1.2 0 .6-.6 1Z",
    "data-index": 657
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M686 389.9c0-.3.2-.7.7-1.1.1.3 0 .6-.6 1Z",
    "data-index": 658
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M528.7 220.5c-.3.1-.7 0-1.2-.5.3-.2.7 0 1.2.5Z",
    "data-index": 659
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M396.1 107c.1.4-.1.7-.6 1.2-.1-.3 0-.7.6-1.1Z",
    "data-index": 660
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M476.3 178.1c-.3.1-.6-.1-1.1-.6.2-.1.6.1 1 .6Z",
    "data-index": 661
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M471.8 173.8c-.3 0-.6-.2-1.1-.8.2 0 .6.2 1.1.8Z",
    "data-index": 662
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M467.3 169.3c-.2 0-.5-.2-1-.7.2-.1.6.1 1 .7Z",
    "data-index": 663
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M465.1 167c-.2.1-.5-.1-1-.7.2 0 .6.2 1 .7Z",
    "data-index": 664
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M464 165.8c-.2.1-.5-.1-1-.6.2 0 .6.1 1 .6Z",
    "data-index": 665
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M456.2 157c-.3.1-.7-.1-1.1-.7.3 0 .6.2 1 .7Z",
    "data-index": 666
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M684.7 420.3c.1.3 0 .7-.6 1.3 0-.3.1-.7.6-1.3Z",
    "data-index": 667
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M450.6 150.3c-.3.1-.7 0-1.1-.6.3-.1.7 0 1 .6Z",
    "data-index": 668
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M686 419.2c.1.2-.1.6-.7 1 0-.3.2-.6.8-1Z",
    "data-index": 669
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M689 417.8c.1.4 0 .7-.5 1.1-.2-.3 0-.7.5-1Z",
    "data-index": 670
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M506.4 203.8c-.3 0-.7-.1-1.1-.6.2-.1.6 0 1 .6Z",
    "data-index": 671
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M499.7 198.3c-.4 0-.7-.1-1.2-.6.3-.1.7 0 1.2.6Z",
    "data-index": 672
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M494.1 193.9c-.3 0-.6-.2-1-.8.2 0 .6.2 1 .8Z",
    "data-index": 673
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M493 192.7c-.3 0-.7-.1-1.2-.6.3-.2.7 0 1.2.6Z",
    "data-index": 674
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M485.2 186.2c-.3 0-.7-.2-1-.9.2 0 .6.3 1 .9Z",
    "data-index": 675
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M484 184.9c-.3.1-.6 0-1.1-.6.3-.1.7 0 1.1.6Z",
    "data-index": 676
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M709.8 793.6c7.5-11.8 15.5-23.6 23.7-35.5 1.6 2.9 2.2 6.5 4.2 8.9 2 2.2 5.3 3 9.4 5.1l-1.3 5.4c-2.8-1-5.6-1.8-8.3-2.9-.7-.3-.8-1.8-1.4-2.3-1.6-1.2-3.4-2-5.1-3l-.7 4.8c-.1 1 0 2.1 0 3.2l-1.5-1c-2 2-3.8 4.5-6.2 5.9-5 2.9-4.3 12-12.8 11.4Z",
    "data-index": 677
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M790.9 842.8a112 112 0 0 1-.7 4c-3-1.7-5.8-3-8.3-4.6-.7-.4-1-2-.7-2.8 1-2.9 2.5-5.6 4.6-10.2.6 5.9 8.2 6.7 5 13.6Z",
    "data-index": 678
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M622.8 956.2c2.2-6 4.6-12.4 7.5-18.5 2.9-6.4 6.2-12.5 9.6-19-.8 5.3-1.3 10.7-5.3 15.7-4.4 5.4-6.6 12.5-9.8 18.9-.5 1-1.1 1.8-2 2.9Z",
    "data-index": 679
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M909.8 896.2c.2 1.3 0 2.6-.4 4.2l-8.4 3.1-1.6-.6 4.5-10.7c1.8 1.3 3.6 2.6 5.9 4Z",
    "data-index": 680,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M896.6 894.3c-.8 2-1.8 5-2.6 4.9-2.6 0-5.2-1.2-7.7-2.2-.2 0 .1-3.1.9-3.6 3-1.8 6.4-3.3 9.4.9Z",
    "data-index": 681,
    style: {
      visibility: "visible"
    }
  }), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M641.7 916.2c3.5-7.3 7.3-14.6 11.6-22.1a48.5 48.5 0 0 1-11.6 22Z",
    "data-index": 682
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M804 881.5a35 35 0 0 1-5-7.5c-.3-.8 1.4-2.4 2.5-4.2 1.5 3.5 2 6.5 3.8 8 1 .9 4-.5 6-1l.4 1.6c-2.4 1-4.8 2-7.7 3Z",
    "data-index": 683
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M868.5 1018.9c-2.2 6.7-4.8 13.5-7.4 20.7-.7-.8-2.2-2.3-1.9-3.2 2.2-5.6 4.6-11 7-16.3.3-.6 1.3-.8 2.3-1.2Z",
    "data-index": 684,
    style: {
      visibility: "visible"
    }
  }), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "m807.4 913.2-.9-6.9c4.9 1.6 7.3 7 5 10-.4.5-2 1-2.2.8-.8-1-1.2-2.3-1.9-4Z",
    "data-index": 685
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M875 918.9c2.6 5.7 2.5 5.8-7 5.5-.9-5.5 2.4-6.1 7-5.5Z",
    "data-index": 686,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M777.4 1093.1c-.8.4-1.6.4-2.9.4-4.5-2.3-8.5-4.6-12.6-7.3 0-.5.2-.8.2-.8 5 2.9 12 1.3 15.3 7.7Z",
    "data-index": 687,
    style: {
      visibility: "visible"
    }
  }), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M818.5 873c-1.9-3-4.4-5.5 0-9.5.8 3.4 1.6 6.2 2 9 .4 2.8.5 5.7.8 9.2-3.7-2.1-4-4.9-2.8-8.6Z",
    "data-index": 688
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M812.7 1192.8c.4 3.3.4 6.7.4 10.6a11 11 0 0 1-4 1.2c-.4-4.5-1.8-9 3.6-11.8Z",
    "data-index": 689,
    style: {
      visibility: "visible"
    }
  }), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M761.2 884.5c.8-3.4 1.9-6.7 3.2-10 .2-.3 1.8-.4 2.5 0 .6.3 1.4 1.7 1.1 2a64 64 0 0 1-6.8 8Z",
    "data-index": 690
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M693 823.7a97 97 0 0 1 4.9-12c.8 4.6 2.4 9.9-4.8 12Z",
    "data-index": 691
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M699.8 809.2c2.3-4.3 5-8.7 8.1-13.2.1.7-.2 1.6-.3 2.5 0 5.3-1 9.9-7.8 10.7Z",
    "data-index": 692
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "m729.5 860.8-2.8-5 1-1.3 8.6 6.3-.9 2.1c-2-.5-3.9-1.1-6-2Z",
    "data-index": 693
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M752.2 1083.5c-1.3-.4-2.1-.8-3.4-1.1a61.5 61.5 0 0 1-6.8-4.2c.5-.6 1.5-1.4 2-1.3 3.8 1.2 7.4 2.5 11 4 .7.4.8 1.9 1.3 3.3-1.3 0-2.5-.3-4.1-.7Z",
    "data-index": 694,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "m785.6 1229.7 4-4.1c1.5 6.5.3 8.1-6.9 8.5l2.9-4.4Z",
    "data-index": 695,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "m862.2 897.2-.5 4-1.4.6c-1.2-2.2-2.5-4.3-3.3-6.6-.2-.4 1.6-1.5 2.5-2.2.9 1.2 1.8 2.5 2.7 4.2Z",
    "data-index": 696,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M823 1113.3c-.7 3.9-1.6 7.4-2.8 11.2-1-1.3-2.8-3.3-2.4-4.4 1.1-2.6 3.2-4.7 5.1-6.8Z",
    "data-index": 697,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M736.2 1075.2c-1.2 0-2.5-.3-4-.6a85.7 85.7 0 0 1-8-5.3 10.2 10.2 0 0 1 12 6Z",
    "data-index": 698,
    style: {
      visibility: "visible"
    }
  }), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M737 852.7c-.8-2.6-2-5.3 2-5.4.9 0 2.5 1.6 2.6 2.5.2 2.8-.8 4.8-4.6 3Z",
    "data-index": 699
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M886.3 972a47 47 0 0 1-2.6 8.7c-3.6-4.7-3.2-5.8 2.6-8.6Z",
    "data-index": 700,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M736.8 1213.2c.5 3.4-1 4.6-3.6 3.4-1.1-.4-1.6-2.3-2.3-3.5 1.9-.1 3.8-.2 5.9.1Z",
    "data-index": 701,
    style: {
      visibility: "visible"
    }
  }), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M684.1 837a62 62 0 0 1 4.7-7.8c.8 1.2 2 3.2 1.7 3.5-1.7 1.7-4 3-6.4 4.4Z",
    "data-index": 702
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M814 1170.2c.2 3.3.2 6.3.2 9.8a6 6 0 0 1-2.9-.5c.7-3.2 1.6-6.4 2.7-9.3Z",
    "data-index": 703,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M730.8 1205.5a38.8 38.8 0 0 1-5.2 4.6l-1.6-2.2c0-4.2 3.8-2.6 6.8-2.4Z",
    "data-index": 704,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "m604 1001-2.4-1.1a20 20 0 0 1 1.5-5.4c4.6 4.1 4.6 4.1 1 6.5Z",
    "data-index": 705,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M616 969.6c1.7-4.2 3.7-8.6 6-13-1.6 4.1-3.6 8.5-6 13Z",
    "data-index": 706,
    style: {
      visibility: "visible"
    }
  }), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M756.6 912.4c.4 1.8.4 3.7.4 5.7l-2 .3-3.3-3.1 5-3Z",
    "data-index": 707
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M783 1242.6c-.6-1-1.1-1.9-1-2.6a8 8 0 0 1 1.6-3.2c.1-.2 1.7.2 1.8.5.3 1 .6 2.4.2 3.4-.2.8-1.4 1.3-2.5 1.9Z",
    "data-index": 708,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M840.6 866.7c2.1.4 4 1 6 1.7l-.8 1.6c-2.5.4-5.5 2-5.2-3.3Z",
    "data-index": 709,
    style: {
      visibility: "visible"
    }
  }), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M713.5 832.6c-1 1.8-2.3 3.1-3.8 4.7-2-5.6-1.7-6 3.8-4.7Z",
    "data-index": 710
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "m899.9 913.2-.2 3.6-1.2.8-3.4-4.3c1.5-.1 3-.3 4.8 0Z",
    "data-index": 711,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M604.9 992a98 98 0 0 1 5-12c-1.4 3.8-3 7.9-5 12Z",
    "data-index": 712,
    style: {
      visibility: "visible"
    }
  }), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M742.7 844c.2-1.8.6-3.3 1-4.8h1.4l1.8 3.5c-1.3.5-2.6 1-4.2 1.2Z",
    "data-index": 713
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "m776.1 1233.8 4.4-3 1.2 1.7-4.3 3.6c-.5-.6-1-1.3-1.3-2.3Z",
    "data-index": 714,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "m873.2 934.2 5 1.5-2.2 2.8-4.4-.8c.4-1.1.8-2.3 1.6-3.5Z",
    "data-index": 715,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M732.9 1182.1c.3-1 .7-1.5 1-2.4l2.1-1.2-.3 6c-1-.7-1.9-1.3-2.8-2.4Z",
    "data-index": 716,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M812.6 1206.2c.5 1.8.5 3.8.5 6.1-1.1-.4-3.1-1.3-3.1-2.1 0-1.4 1.4-2.7 2.6-4Z",
    "data-index": 717,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M610.6 979.7a69 69 0 0 1 4.8-9.8 69 69 0 0 1-4.8 9.8Z",
    "data-index": 718,
    style: {
      visibility: "visible"
    }
  }), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M708 859.5c.3-1.3.8-2.2 1.3-3.2l2.2 3.7c-1 0-2.1 0-3.5-.5Z",
    "data-index": 719
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M798.7 1221.1c.7-1.4 1.5-2.5 2.3-3.6l1.7 2.4a14 14 0 0 1-4 1.2Z",
    "data-index": 720,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M749.6 1156.4c.4-.5.7-.7 1-1.3.3-.2.5-.2 1-.2 2.7 3.5.6 5.2-2.8 6.6 0-1.6.4-3.1.8-5.1Z",
    "data-index": 721,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M783.5 1209.2c1.3.8 2.4 1.9 3.6 3l-2.1 1.3c-.6-1.3-1.2-2.7-1.5-4.3Z",
    "data-index": 722,
    style: {
      visibility: "visible"
    }
  }), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "m717.5 863-3.5 3-1.2-1 3.4-4.3c.5.7 1 1.3 1.3 2.3Z",
    "data-index": 723
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M719.2 855c1.2 0 2.2.3 3.2.6l-2.3 3.7-1.4-.4c0-1.2.1-2.4.5-4Z",
    "data-index": 724
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M678.5 849.2c.5-2 1.4-4.1 2.6-6.4 1.5 2.8 2.2 5.5-2.6 6.4Z",
    "data-index": 725
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M659.6 883.7a62 62 0 0 1 3.7-8.6c-.9 2.7-2.1 5.6-3.7 8.6Z",
    "data-index": 726
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M654 893.8c.9-2.7 2.2-5.6 3.8-8.6a76 76 0 0 1-3.8 8.6Z",
    "data-index": 727
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M786 877.8c.4 1.6.5 3 .6 4.5l-2.5-.3c.5-1.4 1-2.9 1.8-4.2Z",
    "data-index": 728
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M760 1220.8v-4.7c3.3 3.1 3.3 3.1 0 4.7Z",
    "data-index": 729,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M658.1 1036.2c0 .4-.5.5-.8.5-1.6-1.3-3-2.6-4.6-4.2 2.5-.3 5.3-.6 5.4 3.7Z",
    "data-index": 730,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M850.2 863.7c-.2-1 0-2 0-3l2.7 1a10 10 0 0 1-2.7 2Z",
    "data-index": 731,
    style: {
      visibility: "visible"
    }
  }), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M730.1 842.1c.4 1.6.4 3 .4 4.5l-2-.2c.4-1.5.8-3 1.6-4.3Z",
    "data-index": 732
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M620.2 1012.8c-1.7-.8-3.5-2-5.4-3.7 2.3 0 5.8-1.4 5.4 3.7Z",
    "data-index": 733,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M878.4 995.4c-.5 1.8-1.4 3.5-2.5 5.4-.7-2.1-2.6-5.2 2.5-5.4Z",
    "data-index": 734,
    style: {
      visibility: "visible"
    }
  }), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M721 873.4a10 10 0 0 1-.7 3.6l-2-1c.8-1 1.6-1.9 2.7-2.6Z",
    "data-index": 735
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M778.7 1223.2c.7 1 1 2.3 1.3 3.4h-2.3a13 13 0 0 1 1-3.4Z",
    "data-index": 736,
    style: {
      visibility: "visible"
    }
  }), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M843.8 876.6c-.4 1-1 1.7-1.6 2.4l-1-2.6c.8 0 1.6-.1 2.6.2Z",
    "data-index": 737
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M673 859.3a11 11 0 0 1 .6-4c.9.3 1.6 1 2.2 1.6-.8.8-1.6 1.6-2.8 2.4Z",
    "data-index": 738
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M696 1055.2c-1.7-.4-3.4-1.4-5.4-2.6a22 22 0 0 1 5.4 2.6Z",
    "data-index": 739,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M637.3 1025.5c-.6-.5-1-1-1.3-2 2-.6 4.8-2.2 4.3 2.7-.9 0-1.7-.3-3-.7Z",
    "data-index": 740,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M813.7 1185c.1 1.2-.2 2.4-.5 4a9.3 9.3 0 0 1-2.2-2c.8-.6 1.5-1.3 2.7-2Z",
    "data-index": 741,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M874 1005.5a12 12 0 0 1-1.5 4.2 12 12 0 0 1 1.5-4.2Z",
    "data-index": 742,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M775.3 1242.7c-1-.6-1.6-1.2-2.2-1.8l1.7-.7c.3.9.6 1.7.5 2.5Z",
    "data-index": 743,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M711.6 1063c-.4.4-1 .4-1.8.4a20 20 0 0 1-3.6-3 22 22 0 0 1 5.4 2.6Z",
    "data-index": 744,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M831.6 1105.8c-.5 1.7-1.4 3.4-2.6 5.3.5-1.6 1.3-3.4 2.6-5.3Z",
    "data-index": 745,
    style: {
      visibility: "visible"
    }
  }), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M809.4 896c-1-.3-1.7-.6-2.4-1l1.7-1c.4.7.7 1.3.7 2Z",
    "data-index": 746
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M721.3 838.2c-.8.8-1.6 1.1-2.4 1.5 0-.5-.2-1-.3-1.4a5 5 0 0 1 2.7 0Z",
    "data-index": 747
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M743.3 1169.3c.5-1.3 1.4-2.7 2.6-4.3a17 17 0 0 1-2.6 4.3Z",
    "data-index": 748,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M902 924.2c-.2 1.3-.7 2.6-1.5 4.2.1-1.2.6-2.7 1.4-4.2Z",
    "data-index": 749,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M862.8 912.3c.3-1 .9-1.8 1.4-2.5l1.1 1c-.8.6-1.5 1.2-2.5 1.5Z",
    "data-index": 750,
    style: {
      visibility: "visible"
    }
  }), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M811.6 888.3a5 5 0 0 1-2.4-.4l.4-1.3c.7.5 1.4 1 2 1.7Z",
    "data-index": 751
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M712.2 874.6c.6.4 1 1 1.3 1.7l-.9.4a6 6 0 0 1-.4-2Z",
    "data-index": 752
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M809.5 868.1c-.6.3-1.1.2-1.7.2l.4-1.5c.5.3 1 .6 1.3 1.3Z",
    "data-index": 753
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M727.5 903.8c.4-.7.9-1 1.4-1.4l.3 1.5c-.5 0-1 .2-1.7-.1Z",
    "data-index": 754
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M887.3 906.6c-.6-.4-1-1-1.4-1.6l1-.5c.2.7.4 1.3.4 2.1Z",
    "data-index": 755,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M857.3 949.2c.4-.6 1-1 1.7-1.4l.4 1a6 6 0 0 1-2 .4Z",
    "data-index": 756,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M755.4 1228.2c-.3-.6-.3-1.2-.2-1.7l1.5.3c-.3.5-.7 1-1.3 1.4Z",
    "data-index": 757,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M780 1215.6c-.3.6-1 1-1.6 1.3l-.4-.9a6 6 0 0 1 2-.4Z",
    "data-index": 758,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M673.7 1044c-.4.5-1 .5-1.8.5-.7-.6-1-1.1-1.4-2 1 .3 2 .7 3.2 1.6Z",
    "data-index": 759,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M852.8 932.5c.5.1.8.4 1.1.8l-.4.3c-.3-.3-.6-.6-.7-1.1Z",
    "data-index": 760,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M842.8 836.6c.5.1.8.4 1 .8l-.3.3c-.3-.3-.6-.6-.7-1.1Z",
    "data-index": 761,
    style: {
      visibility: "visible"
    }
  }), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M791.3 877.8c-.5-.2-.8-.5-1.1-.8l.3-.4c.3.3.7.7.8 1.2Z",
    "data-index": 762
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M816 1152.7c.4.4.4.9.4 1.8-.6 0-1.1-.4-1.7-.7a6 6 0 0 1 1.4-1.1Z",
    "data-index": 763,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M870.8 1013.3c.1.6 0 1.2-.5 2-.1-.5 0-1.3.5-2Z",
    "data-index": 764,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M670.9 1002a2 2 0 0 1 1.3-.2v.6c-.5 0-.9 0-1.3-.3Z",
    "data-index": 765,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M870 931.4a2 2 0 0 1-.3-1.3h.5c0 .5 0 .9-.3 1.3Z",
    "data-index": 766,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M882.8 915.8a2 2 0 0 1-.8 1.1l-.4-.4c.3-.3.7-.6 1.2-.7Z",
    "data-index": 767,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M854.8 915.1a2 2 0 0 1 1.3-.2v.5c-.4 0-.9 0-1.3-.3Z",
    "data-index": 768,
    style: {
      visibility: "visible"
    }
  }), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M819.2 895.8a2 2 0 0 1-.8 1l-.3-.3c.3-.3.6-.6 1.1-.7Z",
    "data-index": 769
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M827 894.6c-.1.6-.4.9-.8 1.1l-.3-.3c.3-.3.6-.6 1.1-.8Z",
    "data-index": 770
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M748 890c0-.6.4-.9.7-1.1l.4.3c-.3.3-.7.6-1.2.7Z",
    "data-index": 771
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M815 1165c.3.4.3.9.3 1.7-.6 0-1.1-.3-1.7-.7.4-.3.7-.7 1.4-1Z",
    "data-index": 772,
    style: {
      visibility: "visible"
    }
  }), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M665.2 871.6a5 5 0 0 1 1.5-2 5 5 0 0 1-1.5 2Z",
    "data-index": 773
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M670.8 861.6a5 5 0 0 1 1.5-2.1 5 5 0 0 1-1.5 2Z",
    "data-index": 774
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M708.6 795.6c-.1-.4 0-1 .5-1.8.1.4 0 1-.5 1.8Z",
    "data-index": 775
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M681.8 842.4c-.1-.4 0-1 .5-1.9.1.4 0 1-.5 2Z",
    "data-index": 776
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M667.3 869.2c-.1-.4 0-1 .5-1.8.1.4 0 1-.5 1.8Z",
    "data-index": 777
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M668.4 867c0-.5.1-1.1.5-2 .1.5 0 1.1-.5 2Z",
    "data-index": 778
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M690.8 824.8a4 4 0 0 1 1.5-1.1c-.2.4-.7.7-1.5 1.1Z",
    "data-index": 779
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M815.2 1161.6c.2.1.2.3.2.8-.2 0-.5-.1-.6-.3 0 0 .1-.3.4-.5Z",
    "data-index": 780,
    style: {
      visibility: "visible"
    }
  }), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M658.4 884.9c-.2-.3 0-.6.5-.9.2.3 0 .6-.5.9Z",
    "data-index": 781
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M689.5 828.1c-.2 0-.2-.3-.2-.7.2-.1.4 0 .6.3l-.4.4Z",
    "data-index": 782
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5D7",
    d: "M677.3 850.4c0-.2.1-.5.6-1 0 .3-.2.6-.6 1Z",
    "data-index": 783
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#14141D",
    d: "M718.7 569.8c-.4-.2-.3-.8-.3-1a229 229 0 0 1 18.5 6.8C749 580.9 761.2 586 773 592c17 8.5 33.6 17.6 50.4 26.5a36 36 0 0 1 7.3 5.6c-2-.4-3.8-1.4-6-2.3l-2.1-1.3-10-5.4c-1.7-.8-2.9-1.6-4.4-2.4l-16.8-8.8-32.3-15.7-27.6-12.6-5.5-2.3a169 169 0 0 1-7.4-3.5Z",
    "data-index": 784,
    style: {
      opacity: 1
    }
  }), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "M687.8 536c-.3-.6-.4-1-.8-1.5-1.3-2.5-2.3-4.8-3.7-7.3-5.8-17.6-11.3-34.8-16.7-52.1-.8-2.3-.9-4.7-1.4-7.5-.1-.4-.1-.4.1-.7.3-2 .3-3.7.3-5.4.1-3.8.2-7.6.7-12 .9-.6 1.4-.6 2-.2v1c-4 28.4 7.6 53.1 17.8 78.2 1.1 2.7 2.2 5.4 3.1 8.6-.5 0-.8-.5-1.4-1.2Z",
    "data-index": 785
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#16152E",
    d: "m699.3 553.4-1.5-1.9-4.5-6.5a92.6 92.6 0 0 1-4.2-7.2c.8.1 2.1.3 2.6 1 3 4.8 5.9 9.7 8.7 15-.4.3-.7 0-1.1-.4Z",
    "data-index": 786
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M668.7 450.3c-.4-.1-.4-.4-.2-1 1.3-1.2 2.2-1.7 3.1-2.3h.3c2-.6 3.7-1.4 5.3-2.2h.3c.9-.3 1.4-.8 2-1.2h.2c1.6-.4 2.7-1 3.9-1.4l.1.1a642 642 0 0 1-15 8Z",
    "data-index": 787
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M710.8 409.9c.1-2.8.6-5.9 1.2-9.4.8-.4 1.5-.4 2.6-.5-1 3.3-2.2 6.5-3.8 9.9Z",
    "data-index": 788
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M703.8 423.5c-.8 1.4-1.7 3-3 4.3-.5 0-.6-.2-.5-.5l.3-1.5h.3c.5-.4.7-.8.8-1.1l.3-.1 1.6-1.4.2.3Z",
    "data-index": 789
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M708.6 415.5a17 17 0 0 1 1.6-5.2c-.2 1.5-.7 3.3-1.6 5.2Z",
    "data-index": 790
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M691.5 436.6c-1.2 1.2-2.4 2.4-4 3.5-.5 0-.6-.2-.4-.4l2.4-2.8.3.1c.8-.1 1.3-.2 1.7-.4Z",
    "data-index": 791
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "m691.6 436.7-1.8.3c.9-1.1 2.1-2.3 3.8-3.4 0 .4-.3.8-1.1 1.7l-1 1.6s.1-.2 0-.2Z",
    "data-index": 792
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M687 440a13 13 0 0 1-2.9 2.4c-.4 0-.5-.2-.3-.4l1.2-1.7h.3l1.6-.4.1.2Z",
    "data-index": 793
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m705 419.2 1.8-1.3a7 7 0 0 1-1.5 3.3c-.4 0-.5 0-.4-.4l.2-1.7v.1Z",
    "data-index": 794
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M699.3 429c-.5.7-1 1.5-1.9 2-.3-.3-.1-.8-.1-.8h.2l1.7-1.3h.1Z",
    "data-index": 795
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M704.9 421.2c-.2.6-.3 1.3-.8 2.1-.3.2-.4 0-.4-.3l.3-1.6.2-.1.6-.2Z",
    "data-index": 796
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M707.4 417.7c-.1-.5 0-1.1.5-2 .2.6 0 1.2-.5 2Z",
    "data-index": 797
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M700.4 427.9a2 2 0 0 1-.8 1c-.3 0-.4 0-.3-.3.3-.6.5-.8.9-1l.2.3Z",
    "data-index": 798
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M691.8 436.7c0-.2.1-.6.6-1.2 0 .2-.1.6-.6 1.2Z",
    "data-index": 799
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M697 430.3c.3 0 .1.4 0 .7 0 .2-.5.3-.7.4 0-.3.2-.6.7-1Z",
    "data-index": 800
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5CA5",
    d: "M253.8 433.3a19 19 0 0 1 1.6-5.2 19 19 0 0 1-1.6 5.2Z",
    "data-index": 801
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F4FC",
    d: "M221.9 452.4c-.3 0-.6 0-1.1.8l-6.5 5.8h-.3c-3.6 1.3-6.6 3.2-9.8 4.5-25 9.9-47.5 3.3-68.5-11.2-1.9-1.3-4-2.3-5.9-3.4l.2-.3c-.3-.5-.8-.6-1.3-.7l.1-.3a25 25 0 0 0-4.6-4.1v-.3c-.4-.5-.8-.7-1.1-.8v-.3c-.4-.5-.8-.7-1.1-.9l-.1-.3c-2.6-2.8-5.1-5.2-7.7-7.5l.1-.4c-.3-.5-.7-.6-1.2-.8l.3-.2c-2.1-3.2-4.6-6-7-8.7l.2-.3c-1.4-2.4-3-4.4-4.6-6.4l.2-.2c-.6-1.6-1.6-2.9-2.5-4.1v-.3c-.4-.6-.8-.7-1.1-1 0 0 0 .2.2-.2a45 45 0 0 0-3.6-6.3v-.3c-.4-1-.7-1.4-1.1-2v-.3l-2.2-4.1v-.4a38 38 0 0 0-2.2-4.1l.2-.3a6.4 6.4 0 0 0-1.4-3v-.4a189.9 189.9 0 0 1-12-93c1.5-11.8 5.7-23.2 8.7-34.7l.3-.2c1.7-3 3-5.8 4.3-8.7l.2-.1c.5-1 .8-2 1-3.1l3.3-4.4 2.2-2.3.2-.2.9-1 .2-.2c1.3-1.5 2.2-2.9 3.1-4.3h.2c.5-.5.7-.8.8-1.1l.3-.1c.5-.4.7-.7.9-1h.3c1.3-1.2 2.2-2.2 3.1-3.3l.2.2c.9-.3 1.4-.8 2-1.4h.2c.5-.5.7-.8.8-1.1h.3c.6-.4.8-.8 1-1 0 0-.2-.1.2 0 4.4-1.7 8.2-4.2 12.3-5.6 19.3-6.8 37.8-3.4 55.8 5.3 2.7 1.3 5.5 2.4 8.3 3.6v.3c1 1 2.2 1.4 3.4 2l-.1.2c.3.6.8.7 1.2.9a140.5 140.5 0 0 1 36.3 41.2c1 1.6 1.9 2.4 2.7 3.3l-.3.3c.3 1.2.9 2.1 1.4 3v.3c.4.5.8.7 1.1.9l-.1.3a5 5 0 0 0 1.2 1.9l-.1.3c.3.9.7 1.4 1.2 2l-.1.2c.3 1 .7 1.4 1.2 2l-.2.3a43 43 0 0 0 2.7 6.1l4.4 12.6a182.3 182.3 0 0 1 5.3 92.2c-1.8 8.7-5.2 17-7.8 25.6h-.4c-3.8 5.4-7.3 10.9-11 16.5l-.8 1.4h-.2c-.5.4-.7.8-.9 1.2h-.2c-.5.4-.7.7-.9 1 0 0 .1.1-.3.2-.6.8-.8 1.4-1 2l-.2-.1c-.6.3-.7.7-.8 1.2l-.3-.2c-1 .3-1.5.9-2.1 1.4m-108.6-64.6c6.7-1.8 12.2-7.8 13-13.6a87.2 87.2 0 0 0-2.9-34.4 63.4 63.4 0 0 1 4.6-47.9c4.6-8.6 9.5-17 8.8-27.6-.5-6.7-3-15.1-8.4-18.1a16.3 16.3 0 0 0-19.2 1.4 43.8 43.8 0 0 0-13 18.3 127 127 0 0 0-8.7 43.8c-1.2 21.8 1 43.3 9.8 63.6 3 6.8 6.6 13.3 16 14.5Z",
    "data-index": 802,
    style: {
      visibility: "visible"
    }
  }), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M241.3 427.9c2.3-8.6 5.7-17 7.5-25.7a184 184 0 0 0-5-91.9c.8.8 2 1.8 2.3 3 11 38.3 12.2 76.4-3.7 114.3-.3.4-.5.4-1 .3Z",
    "data-index": 803
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M187.5 231.5a62 62 0 0 1-8.2-3.2c-18-8.7-36.5-12.1-55.8-5.3-4.1 1.4-8 3.9-12.3 5.7 5-3.1 10.2-6.1 16.3-9.2l4.4-1.2h2c11.9.4 23.7-1.3 34.7 3.6 6.4 2.8 12.6 6.2 19 9.6Z",
    "data-index": 804
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M239.3 297.2a22.5 22.5 0 0 1-3-6 21 21 0 0 1 3 6Z",
    "data-index": 805,
    style: {
      visibility: "visible"
    }
  }), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M190.9 233.8a6.6 6.6 0 0 1-3.4-1.5c1.1 0 2.2.6 3.4 1.5Z",
    "data-index": 806
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M231 279.4a7.7 7.7 0 0 1-2.3-2.6c.8.5 1.6 1.4 2.4 2.6Z",
    "data-index": 807,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M232.3 282.7a5.2 5.2 0 0 1-1.5-2.6c.6.5 1 1.4 1.5 2.6Z",
    "data-index": 808,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M236.7 290.6c-.6-.2-1-.7-1.4-1.6.6.2 1 .7 1.4 1.6Z",
    "data-index": 809,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M235.6 288.4c-.6-.2-1-.7-1.4-1.6.6.1 1 .7 1.4 1.6Z",
    "data-index": 810,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M234.5 286.1c-.6-.1-1-.6-1.4-1.5.6.1 1 .6 1.4 1.5Z",
    "data-index": 811,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M233.3 284c-.3.1-.7 0-1-.6.2-.2.6 0 1 .5Z",
    "data-index": 812,
    style: {
      visibility: "visible"
    }
  }), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M192 235c-.3.1-.8 0-1.2-.6.4-.2.8 0 1.2.6Z",
    "data-index": 813
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M84.8 262c-2.6 11.4-6.8 22.8-8.2 34.6a188.5 188.5 0 0 0 12 93 189 189 0 0 1-5.3-9.6c-3.1-13.3-6.7-26.1-8.6-39.3-4-27-2-53.5 10.1-78.7Z",
    "data-index": 814,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M89.4 253c-1 2.9-2.2 5.8-3.9 8.8 1-2.9 2.2-5.9 3.9-8.8Z",
    "data-index": 815,
    style: {
      visibility: "visible"
    }
  }), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E60AC",
    d: "M132 218c-1.3.7-2.5 1-4.1 1.4.1-1.7.6-3.3 1.6-6.5 1.2 2.3 1.8 3.5 2.4 5Z",
    "data-index": 816
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M100.5 237.4c-.5 1.4-1.4 2.8-2.7 4.3.6-1.3 1.4-2.8 2.7-4.3Z",
    "data-index": 817
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M106.1 231.9c-.5 1-1.4 2.1-2.7 3.3.6-1 1.4-2.2 2.7-3.3Z",
    "data-index": 818
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M90.8 250a6 6 0 0 1-.8 3c0-1 .2-2 .8-3Z",
    "data-index": 819,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M96.1 243c-.2.7-.8 1.3-1.7 2 .2-.6.8-1.4 1.7-2Z",
    "data-index": 820,
    style: {
      visibility: "visible"
    }
  }), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M108.3 230.6c-.2.7-.7 1.2-1.6 1.6.2-.7.7-1.2 1.6-1.6Z",
    "data-index": 821
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M97.2 241.9c.2.3 0 .7-.6 1 0-.3 0-.7.6-1Z",
    "data-index": 822,
    style: {
      visibility: "visible"
    }
  }), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M101.6 236.3c.2.3 0 .6-.5 1-.2-.3 0-.6.5-1Z",
    "data-index": 823
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M109.4 229.6c.2.3 0 .6-.5 1-.1-.2 0-.6.5-1Z",
    "data-index": 824
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M110.6 228.5c.2.3 0 .7-.5 1.1-.2-.3 0-.7.5-1Z",
    "data-index": 825
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M102.7 235.2c.2.3 0 .6-.5 1-.1-.3 0-.6.5-1Z",
    "data-index": 826
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "m239.8 802.4 1.1 1.2c1.2 1.8 2 3.6 3.3 5.5.8.9 1.3 1.6 2.2 2.3.9 1.4 1.4 2.8 2.2 4.4 1 1.2 1.4 2.2 2.3 3.3 1.2 1.6 2 3.1 3.3 4.6.9 1.4 1.4 2.8 2.2 4.3a16 16 0 0 1-.4 5.5c-.8 1.3-1.3 2.3-1.6 3.9-.5 2.5-1.3 4.4-2.3 6.5a22 22 0 0 0-.8 4.8c-.3 1.2-.7 2-1.3 3.2-.6 1.2-.7 2.2-.9 3.5v.7c-1.9 8-4.7 15.8-5.5 24a394.5 394.5 0 0 0-2.2 45.9c.4 15.8 2.5 31.5 4.1 47.3 1.7 16.1 3.8 32.2 5.8 48.3.7 6.2 1.8 12.4 2.8 18.5l.5 5.9c-4.5-1.3-8.1-2.1-11.6-3.3-5-1.8-10-3.2-14 1.8-2.3 2.8-4.1 2.7-6-.5-.8-1.3-2.4-2.2-3.9-3.4l2.4-6-8 .4 3.6 7.1-2.2 1c-.9-2-2.4-4.2-2.6-6.3-.3-4.2-2-5.3-5.8-4-1.6.6-3.3 1.3-4.8 1.2-1.5-.2-3.5-.9-4.3-2-.6-1-.5-3.4.3-4.5 3.3-4.6 6-10 13.4-8.8 1.3.2 3.4-.3 4.1-1.2 1.1-1.4 1.4-3.5 2-5.3-1.5-.5-3-1.5-4.4-1.3-5 .5-9.8 1.5-14.7 2.2l-.6-2c2.8-1.6 5.8-3 8.5-4.9 1.8-1.3 5-3.7 4.7-4.6-1-2.7-3.3-5-5.2-7.2-1.1-1.4-3.4-2.3-3.7-3.7-.3-1.3 1.3-3.1 2.5-4.4 1.4-1.7 3.3-3 6-5.4l-9.4-2 5.4-3.5c1-.6 2.2-1.1 3.2-1.9.2-.1-.5-1.8-.7-1.8l-3.3.9c-1.1.3-3 1.1-3.2.8a7.4 7.4 0 0 1-1.5-4.2c.2-2.9 1-5.8 1.2-8.7 0-1.7-.8-3.4-1.6-5.1-.4-1.3-.4-2.5-.4-4.1 2.6-12 5-23.4 7.8-34.9l24.2-99c.3-1.2.2-2.6.3-4.3l1.1-3.4c1-2.8 2-5.2 3.2-7.9.7-.3 1.2-.3 2-.3l1.2 1Z",
    "data-index": 827,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9185BE",
    d: "m252.4 843.8 2.2-6.2c4.6 0 5 2.5 3.9 6.3a248.5 248.5 0 0 0-9.7 67.8c-.1 25.4 2 50.5 5.6 75.6 3.5 24.3 6.1 48.7 9.2 73 .2 1.5.6 3 1 4.9-1.6-.1-3.2-.7-5-1.5-3.3-20.8-6.5-41.4-9.2-62a782.6 782.6 0 0 1-6.7-97.6c.4-14 3.3-28 5-42.1l.4-5.5c0-.4 0-1 .3-1.4l1-3.4c.2-1 .6-1.8 1.2-3.3.5-2 .6-3.3.8-4.6Z",
    "data-index": 828,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "m239 1062.3-2-1-2.2-5 20.8-5.6 1.2 13.3c-.5.5-1 .5-1.9 0-2.5-7.2-4.2-8.7-9.5-7-2.5.8-4.3 3.5-6.4 5.3Z",
    "data-index": 829,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M207 1040.6c4.9 3.6 9.5 7.4 14.1 11.1-3.3 3.5-4.7 3.7-11.4-1-3-2-5.6-5.5-2.8-10Z",
    "data-index": 830,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M187 1039c.1-4.3.6-8.6 1.5-13.2 1.1 3 1.8 6.5 2.8 9.9 1.3 4.3-.7 4.4-4.3 3.2Z",
    "data-index": 831,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M197.7 1049.7c-.6.2-1.2 0-2-.5.2-.8.6-1.4 1-2 .4.7.7 1.4 1 2.5Z",
    "data-index": 832,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M241.8 1046.4c0 .8-.2 1.4-.5 2l-.9-.5a4 4 0 0 1 1.4-1.5Z",
    "data-index": 833,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M233 1046.8a2 2 0 0 1-1.4.2v-.5c.5 0 1 0 1.4.3Z",
    "data-index": 834,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3A7D9",
    d: "M195.9 977.5c-.2-.5 0-1.2.4-2a3 3 0 0 1-.4 2Z",
    "data-index": 835,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M129.9 449.3c1.9.7 4 1.7 5.8 3 21 14.5 43.4 21 68.5 11.2 3.2-1.3 6.2-3.2 9.7-4.6a8 8 0 0 1-1.6 3 67 67 0 0 1-32.5 8.3c-4.9-.2-9.7-1.3-15-2-13.1-4-25-9.4-35-18.9Z",
    "data-index": 836,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M114.2 433.8c2.6 2 5.1 4.3 7.7 7.1-2.5-2-5.1-4.4-7.7-7.1Z",
    "data-index": 837,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M106.4 423.7c2.4 2.4 4.9 5.1 7 8.2-2.5-2.3-4.8-5-7-8.2Z",
    "data-index": 838,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M102 417c1.6 1.6 3.2 3.6 4.6 6a29.9 29.9 0 0 1-4.7-6Z",
    "data-index": 839,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M124.1 443.9c1.7.8 3.3 2 4.8 3.6a16 16 0 0 1-4.8-3.6Z",
    "data-index": 840,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M95.1 404.9c1.4 1.5 2.7 3.5 3.8 5.9a25.6 25.6 0 0 1-3.8-6Z",
    "data-index": 841,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M99.6 412.7c1 .8 2 2 2.7 3.7-1-.9-2-2.1-2.7-3.7Z",
    "data-index": 842,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M89.6 393.7c.9.8 1.5 2 2.3 3.7-.8-.8-1.6-2-2.3-3.7Z",
    "data-index": 843,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M91.8 398.2a14 14 0 0 1 2.3 3.7c-.8-.8-1.6-2-2.3-3.7Z",
    "data-index": 844,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M88.4 390.4c.7.4 1.3 1.3 1.6 2.6-.7-.5-1.2-1.4-1.6-2.6Z",
    "data-index": 845,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M94 402.6c.5.2.8.7 1.2 1.6-.4-.2-.8-.7-1.2-1.6Z",
    "data-index": 846,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M98.6 411.4c.3-.1.7 0 1 .6-.2.1-.6 0-1-.6Z",
    "data-index": 847,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M128.7 448.2c.5-.2 1-.1 1.3.4-.5.2-.8 0-1.3-.4Z",
    "data-index": 848,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M123 442.7c.4-.2.8 0 1.2.5-.4.2-.8 0-1.1-.5Z",
    "data-index": 849,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M122 441.6c.3-.2.7 0 1 .5-.3.1-.7 0-1-.5Z",
    "data-index": 850,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M113.2 432.6c.4-.2.8-.1 1.2.4-.5.2-.9 0-1.2-.4Z",
    "data-index": 851,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M205.5 534.8c-.5.3-.9.2-1.6 0-.6-.5-.9-.9-1-1.6 1 .2 1.8.7 2.6 1.6Z",
    "data-index": 852,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC8A6",
    d: "M144.6 1432.4c-.9-.7-1.4-1.4-2.2-2.2 3.7-26.6 7.7-53.3 11.8-79.8l13.3-88c4.4-28.6 9.1-57.1 13.3-85.7 3-20.8 5.2-41.7 8-62.5 2.8-20.3 6-40.5 8.9-61.2a360.4 360.4 0 0 0 66.3 15c.5 0 .6 0 .6.5.4 4.9.7 9.3 1.2 13.7 2 18.2 4.4 36.3 6.3 54.5 1.5 14.2 3.4 28.4 3.3 42.6 0 17.4-1.4 34.8-3.3 52.1a2527 2527 0 0 1-9.7 79.1c-3.6 26.5-7.8 52.8-11.8 79.1l-6.1 41.7-.3.3a1141 1141 0 0 0-5.3 32l-.3.3c-.5 1.4-.7 2.7-1 4l-1 1c-11.6-3-23.1-6.4-35-9.7l-9-3.3-5.6-2.3-5.6-2.2-23.4-11.1-6.7-4.5c-2.4-1.1-4.3-2.3-6.7-3.4Z",
    "data-index": 853,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M237.8 1468.2c0-1.6.3-2.9.8-4.4.3 1.4.4 3 .4 5-.4.2-.7 0-1.2-.6Z",
    "data-index": 854,
    style: {
      visibility: "visible"
    }
  }), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#24247A",
    d: "M229.9 444.1a379 379 0 0 1 10.7-16.3c-3 5.9-6.4 11.8-10.2 17.4-.4-.5-.5-.8-.5-1Z",
    "data-index": 855
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M214.7 459.1a58 58 0 0 1 6-5.7 57.7 57.7 0 0 1-6 5.7Z",
    "data-index": 856
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M225.7 450c-.2-.5 0-1.1.6-1.9.2.5 0 1.2-.6 2Z",
    "data-index": 857
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M222.3 452.6c.2-.7.8-1.3 1.7-1.7-.2.7-.8 1.3-1.7 1.7Z",
    "data-index": 858
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M224.6 451.2c-.2-.5 0-1 .5-1.3.2.5 0 1-.5 1.3Z",
    "data-index": 859
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M227 448c-.2-.4 0-.7.5-1.1.1.3 0 .7-.5 1.1Z",
    "data-index": 860
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M228 446.9c0-.4 0-.8.6-1.2.1.4 0 .8-.5 1.2Z",
    "data-index": 861
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B6D",
    d: "M229.6 444.3c.3.1.4.4.4 1.2-.1.4-.3.4-.9.3-.1-.5 0-.9.5-1.5Z",
    "data-index": 862
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M239.4 1062.3c1.7-1.8 3.5-4.5 6-5.3 5.3-1.7 7-.2 9.1 7-4.8-.2-9.7-1-15-1.7Z",
    "data-index": 863,
    style: {
      visibility: "visible"
    }
  }), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#55579C",
    d: "M222.3 544.7c-.4-.2-.8-.7-1.2-1.5.4.1.8.6 1.2 1.5Z",
    "data-index": 864
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M244.8 1431a1836 1836 0 0 1 5.8-41.4c4-26.3 8.2-52.6 11.8-79 3.6-26.4 7-52.7 9.7-79.2 1.9-17.3 3.3-34.7 3.3-52 .1-14.3-1.8-28.5-3.3-42.7-1.9-18.2-4.2-36.3-6.3-54.5-.5-4.4-.8-8.8-1.2-13.8.7.6 2 1.5 2.1 2.6 2 18 3.6 36 5.8 53.9 3 24 5.7 48.1 4.2 72.3-1 17.5-3.4 34.8-5.2 52.3-.8 8.4-1.4 16.8-2.4 25.3a2179.4 2179.4 0 0 1-13.4 96.2l-7.2 41.4a513 513 0 0 1-3.7 18.7Z",
    "data-index": 865,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9996E3",
    d: "M239.2 1463.4c1.3-10.4 3-21 5-31.8-1.4 10.3-3 21-5 31.8Z",
    "data-index": 866,
    style: {
      visibility: "visible"
    }
  }), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M659.3 437.2c2.9-1.5 5.7-2.7 8.9-4.1a25 25 0 0 1 5.1-2c-4 2.4-8.6 4.6-13.5 7-.4-.3-.5-.4-.5-1Z",
    "data-index": 867
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M671.1 447c-.4.6-1.3 1.1-2.6 1.9h-2.2a9 9 0 0 1-3.8-1.2 46 46 0 0 1 8.6-.7Z",
    "data-index": 868
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "m696.2 406.2 1.2-2.2c.5-.7 1-1.2 1.6-1.7-.5 1.8-1.4 3.6-2.7 5.5-.3-.4-.2-.9-.1-1.6Z",
    "data-index": 869
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M684.6 440.3c0 .5-.3 1-.9 1.6-1.3.8-2.4 1.3-4 1.8 1.3-1.2 2.9-2.3 4.9-3.4Z",
    "data-index": 870
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M676.8 444.7a21 21 0 0 1-4.8 2.4 21 21 0 0 1 4.8-2.4Z",
    "data-index": 871
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M687.1 439.7c-.6.4-1 .5-1.8.7a18 18 0 0 1 3.8-3.5c-.4.9-1 1.7-2 2.8Z",
    "data-index": 872
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M700.3 427.3c-.5.5-.7.7-1 1.3l-1.8 1.6c.6-1.3 1.5-2.8 2.7-4.3.3.3.3.7 0 1.4Z",
    "data-index": 873
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M694 409.6a6 6 0 0 1 1.7-1.7c-.2 1-.7 2.1-1.6 3.2-.3-.4-.2-.8 0-1.5Z",
    "data-index": 874
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M703.6 421.4c.3.4.2.8 0 1.5-.5.7-1 1.1-1.6 1.7a8 8 0 0 1 1.6-3.2Z",
    "data-index": 875
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M690.8 415.6c-.4-.4-.3-.8 0-1.5.5-.7.9-1.2 1.6-1.7a8 8 0 0 1-1.6 3.2Z",
    "data-index": 876
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M705 420.8c-.2.3-.6.5-.8.5 0-.6 0-1.2.6-2 .2.2.2.7.1 1.5Z",
    "data-index": 877
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M679 443.6c-.1.4-.6.9-1.5 1.2.2-.4.7-.8 1.6-1.2Z",
    "data-index": 878
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M692.9 412.2c-.1-.2 0-.6.6-1 0 .3-.1.6-.6 1Z",
    "data-index": 879
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M701.5 424.7c0 .3-.1.7-.6 1-.1-.2 0-.6.6-1Z",
    "data-index": 880
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M675 430c0-.2.2-.5.7-1 0 .3-.1.6-.6 1Z",
    "data-index": 881
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M679.6 426.7c-.2-.3 0-.7.5-1.2.1.2 0 .6-.5 1.2Z",
    "data-index": 882
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7AC4",
    d: "M674 431.2c-.2-.3 0-.7.5-1 .1.2 0 .5-.5 1Z",
    "data-index": 883
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m533.3 261.2-1.7-.7c-17.6-9-36-11.4-55.6-9-.5-.4-.6-.7-1.2-1 0-1.9.4-3.6 1-5.4.5-.1.6 0 .7.5-.5 4.2 2.1 4.3 4.6 3.9 17.2-3 33.1 1.6 48.8 7.8 2 .8 4 1 5.8 1.3l1-4.6c1 2.2 2.1 4.5 3 7.2-2 .3-4 .2-6.4 0Z",
    "data-index": 884
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m478.6 242.2 1.2-1.2 2.2-1a53 53 0 0 1 37.8 1.8c2.3 1 4.5 2.3 7.2 3.6l2 1.4c.5.5.8.7 1.4.9l1.3.9a3 3 0 0 1 1.3 1.8c-1.8-.3-3.4-.8-4.7-1.7a51 51 0 0 0-33.6-9c-6.2.8-12.2 3.6-18.3 5.4l-.2-.2.3-1.6c.7-.5 1.3-.6 2.1-1Z",
    "data-index": 885
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M401.2 239.6c.4.6.5.9 1 1.2.7 1.6 1.2 3 1.5 4.8-.4.5-.7.7-1 1.3-8.9 0-17.7-.6-26.6-.6a74 74 0 0 0-15.4 1.6c-3.9.8-5.1-.5-5.4-4.3.6-1 1.2-1.6 1.9-2.5.5-.7 1-1 1.7-1.7l1.7-1.5 3.3-2.2c.9-.4 1.5-.6 2.3-1.1a36.6 36.6 0 0 1 29.1.9l3.6 2 2.3 2.1m-8.6-3c-16.5-5.2-30.1-1.6-34.1 8.5h42l.8-2.3c-2.6-2-5.3-3.8-8.7-6.1Z",
    "data-index": 886
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "M386.7 314.3c-.5.6-.7.8-1.3.7.2-2.3 1.2-4.3 1.1-6.2-.2-4.9-.3-9.9-1.6-14.5-1.1-3.7-4.6-4.7-8.1-2.4-4.9 3.2-6.4 13-3.6 20 2.6 6.4 7.4 4.6 12 3.6 0 .4-.2.8-.4 1.5-6.6 3.5-8.9 2.8-13.8-3.8-.3-5.7-1.1-11.3 0-16.5 1.5-6.5 7.6-10.5 13.3-6.8 6.2 7.7 6.5 15.6 2.4 24.4Z",
    "data-index": 887,
    style: {
      visibility: "visible"
    }
  }), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3BA",
    d: "M665.4 461.8c.2 1.4.2 3 0 5a16 16 0 0 1 0-5Z",
    "data-index": 888
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m486 294 1.7-1.5c3-.6 5.8-1 9-1.3a22 22 0 0 1 4.3 3.6c0 .4 0 .5-.5.5-7.9-3.4-11.3-3.3-14.3 2.2A22.5 22.5 0 0 0 484 309c.3 3.7 2.3 7.2 3.5 10.9l-.2.2c-6.4-6-7.4-14.1-2.9-24.1l1.6-2Z",
    "data-index": 889
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m499 320-1.5 1.5a52 52 0 0 1-8 .3c-1-.5-1.4-.8-2-1.5-.2-.2 0-.4.5-.4h10.8l.2.1Z",
    "data-index": 890
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m504 313.5-1 2.4c-.5.8-.9 1.2-1.6 1.7-.3.1-.4 0-.5-.5 3.5-7.5 2-14.7 0-21.8l.2-.2c.5 0 .8.2 1.1.8l1.2 2c.3 5.2.5 10.2.6 15.6Z",
    "data-index": 891
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "#393B4F",
    d: "M476.5 245.6c6-2.3 12-5.1 18.2-5.8a51 51 0 0 1 33.6 9c1.3.8 3 1.3 4.8 1.9.8 0 1.1 0 1.6.6l1 1c.5.5.7.8 1 1.4l-1 5c-1.8-.5-3.9-.6-5.8-1.4-15.7-6.2-31.6-10.8-48.8-7.8-2.5.4-5 .3-4.6-4Z",
    "data-index": 892
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "#181836",
    d: "m501.1 317.8-1.8 2.1c-.3.1-.5 0-.5-.4a8 8 0 0 1 2.2-1.9l.1.2Z",
    "data-index": 893
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFF",
    d: "M112.9 387.8c-9-1.2-12.6-7.7-15.6-14.5-8.9-20.3-11-41.8-9.8-63.6a127 127 0 0 1 8.7-43.8 44 44 0 0 1 13-18.3c6-4.7 12.5-5 19.2-1.4 5.4 3 7.9 11.4 8.4 18.1.7 10.7-4.2 19-8.8 27.6a63.4 63.4 0 0 0-4.6 47.9 87.2 87.2 0 0 1 3 34.4c-.9 5.8-6.4 11.8-13.5 13.6Z",
    "data-index": 894,
    style: {
      visibility: "visible"
    }
  }), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M252 844c.2 1.1 0 2.4-.4 4-.1-1 0-2.5.5-4Z",
    "data-index": 895
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A8D9",
    d: "M250 851.9a6 6 0 0 1-.6 3 6 6 0 0 1 .6-3Z",
    "data-index": 896
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "#393B4F",
    d: "M393 236.9c3 2 5.7 4 8.3 5.9l-.8 2.3h-42c4-10.1 17.6-13.7 34.5-8.2Z",
    "data-index": 897
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#393B4F",
    d: "M385.2 315.5c-4.6 1-9.4 2.8-12-3.7-2.8-6.9-1.3-16.7 3.6-19.9 3.5-2.3 7-1.3 8 2.4 1.4 4.6 1.5 9.6 1.7 14.5.1 2-1 3.9-1.3 6.3v.4Z",
    "data-index": 898,
    style: {
      visibility: "visible"
    }
  }), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "#393B4F",
    d: "M501 317.1c-.8 1-1.5 1.5-2.3 2.4-3.3.3-6.7.3-10.6.3-1.8-3.6-3.8-7.1-4-10.8-.3-3.8.4-8.1 2.1-11.5 3-5.5 6.4-5.6 14.3-2.2 2.5 7.1 3.9 14.3.4 21.8Z",
    "data-index": 899
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIllustrationTransparentSmall);
export default __webpack_public_path__ + "static/media/help-illustration-transparent_small.f201954ecde18f068ff43a2a212116c3.svg";
export { ForwardRef as ReactComponent };